/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var vme = zbuyer.viewmodels.enums;
        controllers.AccountDirectiveElement = '#accountDirective';
        var EmailRegExp = /^([\w-+\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,11}|[0-9]{1,3})(\]?)$/;
        var UrlRegExp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
        var NewInvestorEmailInputElement = '#newInvestorNotificationInput';
        var SmsPhoneInputElement = '#smsPhone';
        var TemplateUrl = 'staticpages/directives/accountdirective.html';
        var ImageFileSignatures = {
            R0lGODdh: 'image/gif',
            R0lGODlh: 'image/gif',
            iVBORw0KGgo: 'image/png',
            '/9j/': 'image/jpg',
            Qk02U: 'image/bmp',
        };
        var AccountDirectiveController = /** @class */ (function (_super) {
            __extends(AccountDirectiveController, _super);
            function AccountDirectiveController($scope, $q, $timeout, $window, accountService, appSettingsService, crmService, notificationService, testNotificationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$q = $q;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.accountService = accountService;
                _this.appSettingsService = appSettingsService;
                _this.crmService = crmService;
                _this.notificationService = notificationService;
                _this.testNotificationService = testNotificationService;
                // Mirror public profile with its "edit" object
                $scope.$watch(function ($scope) { return _this.$scope.viewModel.publicProfile; }, function () {
                    _this.$scope.publicProfileEdit = angular.copy(_this.$scope.viewModel.publicProfile);
                });
                // Update the image link along with any change in publicProfileEdit or the actual link value
                $scope.$watch(function ($scope) { var _a; return (_a = _this.$scope.publicProfileEdit) === null || _a === void 0 ? void 0 : _a.headshotPhoto_BASE64; }, function () {
                    var _a;
                    _this.$scope.publicProfileImageLink = _this.getProfileImageLink((_a = _this.$scope.publicProfileEdit) === null || _a === void 0 ? void 0 : _a.headshotPhoto_BASE64);
                });
                if (!$scope.signup) {
                    accountService.getPublicProfile().then(function (publicProfile) {
                        _this.$scope.viewModel.publicProfile = publicProfile;
                        if (!(publicProfile === null || publicProfile === void 0 ? void 0 : publicProfile.success)) {
                            _this.notificationService.error(zbuyer.messages.PublicProfileError, zbuyer.messages.ApplicationTitle);
                        }
                    }).catch(console.debug);
                }
                $scope.AccountSectionType = vme.AccountSectionType;
                $scope.emailRegExp = EmailRegExp;
                $scope.urlRegExp = UrlRegExp;
                $scope.demoAccountIds = [];
                var demoAccountIds = $scope.demoAccountIds;
                appSettingsService.getAppSettings().then(function (settings) {
                    $scope.appSettings = settings;
                    demoAccountIds.push(settings.demoAccountSubscribedId);
                    demoAccountIds.push(settings.demoAccountUnsubscribedId);
                });
                return _this;
            }
            AccountDirectiveController.getDirective = function () {
                return {
                    controller: AccountDirectiveController,
                    restrict: 'E',
                    scope: {
                        logoutCallback: '&onLogout',
                        signup: '=',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            AccountDirectiveController.prototype.initializeNotifications = function (reinitialize) {
                if (reinitialize === void 0) { reinitialize = false; }
                this.testLeadInitialize(reinitialize);
                this.crmInitialize(reinitialize);
            };
            AccountDirectiveController.prototype.showAccountHome = function () {
                if (this.$scope.viewModel.isEditingEnabled) {
                    this.toggleEditMode();
                }
                this.setActiveSection(vme.AccountSectionType.Home);
            };
            AccountDirectiveController.prototype.showAccountNotifications = function () {
                this.setActiveSection(vme.AccountSectionType.Notifications);
            };
            AccountDirectiveController.prototype.showMemberProfile = function () {
                this.setActiveSection(vme.AccountSectionType.MemberProfile);
            };
            AccountDirectiveController.prototype.showPublicProfile = function () {
                this.$scope.publicProfileEdit = angular.copy(this.$scope.viewModel.publicProfile);
                this.setActiveSection(vme.AccountSectionType.PublicProfile);
            };
            AccountDirectiveController.prototype.showAccountSubscription = function () {
                this.setActiveSection(vme.AccountSectionType.Subscription);
            };
            AccountDirectiveController.prototype.showAccountTransactions = function () {
                this.setActiveSection(vme.AccountSectionType.Transactions);
            };
            AccountDirectiveController.prototype.showChangePassword = function () {
                this.setActiveSection(vme.AccountSectionType.ChangePassword);
                if (this.isDemoAccount()) {
                    // Allow demo account to show the UI but pre-warn since change-password will be blocked by API if sent through
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                }
            };
            AccountDirectiveController.prototype.updateNotificationSettings = function () {
                var _this = this;
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    return;
                }
                var updateNotificationSettingsRequest = {
                    emailAlerts: this.$scope.viewModel.account.emailAlerts,
                    smsPhone: { fullNumber: this.$scope.viewModel.account.smsNumber },
                    textAlerts: this.$scope.viewModel.account.textAlerts
                };
                this.accountService.updateNotificationSettings(updateNotificationSettingsRequest).catch(function (response) {
                    _this.notificationService.error(response.data.exceptionMessage, response.data.message);
                });
            };
            AccountDirectiveController.prototype.checkOut = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.checkoutViewModel = {
                    account: viewModel.account,
                    isCheckoutActive: true
                };
                this.$window.scrollTo(0, 0);
            };
            AccountDirectiveController.prototype.fillInvestorNotificationEmails = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                this.accountService.getInvestorNotificationEmails().then(function (result) {
                    viewModel.investorNotificationEmails = result.investorNotificationEmails;
                }).catch(function (response) {
                    _this.notificationService.error(response.data.exceptionMessage, zbuyer.messages.ApplicationTitle);
                });
            };
            AccountDirectiveController.prototype.goBack = function () {
                this.showAccountHome();
            };
            AccountDirectiveController.prototype.handleLegacyServiceError = function (error) {
                if (error === void 0) { error = null; }
                var errorMessageToDisplay;
                if (typeof error == 'string') {
                    errorMessageToDisplay = error;
                }
                else {
                    console.error(error);
                    errorMessageToDisplay = 'An unexpected error has occurred. Please contact support.';
                }
                this.notificationService.error(errorMessageToDisplay);
            };
            AccountDirectiveController.prototype.investorNotificationEmailAdd = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.addingInvestorNotificationEmail = true;
                this.$timeout(function () {
                    angular.element(NewInvestorEmailInputElement).focus();
                });
            };
            AccountDirectiveController.prototype.investorNotificationEmailCancel = function () {
                this.resetEmailForm();
            };
            AccountDirectiveController.prototype.investorNotificationEmailDelete = function (investorNotificationEmail) {
                var _this = this;
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    return;
                }
                this.accountService.deleteInvestorNotificationEmail(investorNotificationEmail.emailId).then(function (response) {
                    _this.notificationService.success(zbuyer.messages.AccountInfoSaveSuccess, zbuyer.messages.ApplicationTitle);
                    _this.fillInvestorNotificationEmails();
                }).catch(function (response) {
                    _this.notificationService.error(response.data.exceptionMessage, zbuyer.messages.ApplicationTitle);
                });
            };
            AccountDirectiveController.prototype.investorNotificationEmailSave = function () {
                var _this = this;
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    return;
                }
                var viewModel = this.$scope.viewModel;
                this.accountService.addInvestorLeadNotification(viewModel.newInvestorNotificationEmail, true).then(function (response) {
                    _this.notificationService.success(zbuyer.messages.AccountInfoSaveSuccess, zbuyer.messages.ApplicationTitle);
                    _this.resetEmailForm();
                    _this.fillInvestorNotificationEmails();
                }).catch(function (response) {
                    _this.notificationService.error(response.data.exceptionMessage, zbuyer.messages.ApplicationTitle);
                });
            };
            AccountDirectiveController.prototype.investorNotificationEmailUpdate = function (investorNotificationEmail) {
                var _this = this;
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    return;
                }
                var request = {
                    email: investorNotificationEmail.email,
                    emailId: investorNotificationEmail.emailId,
                    optedIn: investorNotificationEmail.optedIn
                };
                this.accountService.updateInvestorNotificationEmail(request).then(function () {
                    _this.notificationService.success(zbuyer.messages.AccountInfoSaveSuccess, zbuyer.messages.ApplicationTitle);
                }).catch(function (response) {
                    _this.notificationService.error(zbuyer.messages.AccountInfoSaveError, zbuyer.messages.ApplicationTitle);
                });
            };
            AccountDirectiveController.prototype.isDemoAccount = function () {
                var _this = this;
                var matches = this.$scope.demoAccountIds.filter(function (id) { return id == _this.$scope.viewModel.account.id; });
                return matches.length > 0;
            };
            AccountDirectiveController.prototype.crmInitialize = function (reinitialize) {
                var _this = this;
                if (reinitialize === void 0) { reinitialize = false; }
                var viewModel = this.$scope.viewModel;
                if (viewModel.crmAvailableTypes && !reinitialize) {
                    return;
                }
                viewModel.crmAvailableTypes = null;
                viewModel.crmConnections = null;
                this.crmService.getTypes().then(function (crmConnectionTypes) {
                    viewModel.crmAvailableTypes = crmConnectionTypes;
                    console.debug('Got CRM Types List', crmConnectionTypes);
                }).catch(function (err) { return _this.handleLegacyServiceError(err); });
                this.crmService.getAll().then(function (crmConnections) {
                    viewModel.crmConnections = crmConnections;
                    console.debug('Got CRM Connections List', crmConnections);
                }).catch(function (err) { return _this.handleLegacyServiceError(err); });
            };
            AccountDirectiveController.prototype.crmDelete = function (crmConnection) {
                var _this = this;
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    return;
                }
                var viewModel = this.$scope.viewModel;
                var connectionsAsSaved = viewModel.crmConnections;
                viewModel.crmConnections = connectionsAsSaved.filter(function (item) { return item != crmConnection; });
                this.crmService.delete(crmConnection.crmConnectionId).then(function (response) {
                    _this.notificationService.success("".concat(crmConnection.displayName, " has been deleted"));
                }).catch(function (err) {
                    _this.handleLegacyServiceError(err);
                    // Failed -- set back to what it was
                    viewModel.crmConnections = connectionsAsSaved;
                });
            };
            AccountDirectiveController.prototype.crmToggleEnabled = function (crmConnection) {
                var _this = this;
                var promiseState = { pending: true };
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    // Failed -- toggle back
                    crmConnection.isEnabled = !crmConnection.isEnabled;
                    ;
                    return;
                }
                this.crmService.setEnabled(crmConnection.crmConnectionId, crmConnection.isEnabled).then(function (response) {
                    var verb = crmConnection.isEnabled ? 'enable' : 'disable';
                    _this.notificationService.success("".concat(crmConnection.displayName, " has been ").concat(verb, "d"));
                }).catch(function (err) {
                    _this.handleLegacyServiceError(err);
                    // Failed -- toggle back
                    crmConnection.isEnabled = !crmConnection.isEnabled;
                }).finally(function () {
                    promiseState.pending = false;
                });
                return promiseState;
            };
            AccountDirectiveController.prototype.crmShowAddConnection = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                controllers.AddCrmModalController.loadModal(viewModel.crmSelectedType).then(function (newConnection) {
                    // After modal closes, add to list
                    if (newConnection) {
                        viewModel.crmConnections.push(newConnection);
                        // Load as pristine
                        _this.crmInitialize(true);
                    }
                    else {
                        if (_this.isDemoAccount()) {
                            // Clarify after the fact (demo user can see the add-crm form but if they submit, API will throw)
                            _this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                        }
                    }
                });
            };
            AccountDirectiveController.prototype.resetEmailForm = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.addingInvestorNotificationEmail = false;
                viewModel.newInvestorNotificationEmail = null;
            };
            AccountDirectiveController.prototype.resetForm = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.accountTemp = null;
                viewModel.validate = false;
            };
            AccountDirectiveController.prototype.saveMemberProfile = function (memberProfileForm) {
                var _this = this;
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    return;
                }
                var viewModel = this.$scope.viewModel;
                viewModel.validate = true;
                if (memberProfileForm.$invalid) {
                    return;
                }
                if (!viewModel.isEditingEnabled) {
                    return;
                }
                var request = {
                    accountInfo: viewModel.account
                };
                this.accountService.updateAccountInfo(request).then(function (response) {
                    _this.notificationService.success(zbuyer.messages.AccountInfoSaveSuccess, zbuyer.messages.ApplicationTitle);
                    _this.toggleEditMode(false);
                    // Gotta re-login! (if API says so (you changed your email))
                    if (response.loginRequired) {
                        _this.$scope.logoutCallback();
                    }
                }).catch(function (err) {
                    console.debug(err);
                    _this.notificationService.error(zbuyer.messages.AccountInfoSaveError, zbuyer.messages.ApplicationTitle);
                    // Rolling back
                    _this.toggleEditMode(true);
                });
            };
            AccountDirectiveController.prototype.savePublicProfile = function (publicProfileForm) {
                var _this = this;
                if (this.isDemoAccount()) {
                    this.notificationService.info(zbuyer.messages.DemoAccountReadOnly);
                    return;
                }
                var viewModel = this.$scope.viewModel;
                viewModel.validate = true;
                if (publicProfileForm.$invalid) {
                    return;
                }
                if (!viewModel.isEditingEnabled) {
                    return;
                }
                var profileEdit = this.$scope.publicProfileEdit;
                var request = {
                    displayName: profileEdit.displayName,
                    displayCompany: profileEdit.displayCompany,
                    displayPhone: profileEdit.displayPhone,
                    websiteURL: profileEdit.websiteURL,
                    phoneIsMobile: profileEdit.phoneIsMobile,
                    headshotPhoto_BASE64: profileEdit.headshotPhoto_BASE64,
                    //Available but not yet part of requirements:
                    //shortBiographyText: profileEdit.shortBiographyText
                };
                this.accountService.updatePublicProfile(request).then(function (response) {
                    if (!response.success) {
                        // Save failed
                        _this.notificationService.error(response.errorMessageToDisplay, zbuyer.messages.ApplicationTitle);
                        return;
                    }
                    // Success: take our last edit as "official" (but immediately request a refresh from API)
                    viewModel.publicProfile = angular.copy(profileEdit);
                    _this.accountService.getPublicProfile().then(function (publicProfile) {
                        if (!publicProfile.success) {
                            throw publicProfile.errorMessageToDisplay;
                        }
                        // NOTE: Scope-watch in constructor will ensure the publicProfileEdit reflects this change
                        viewModel.publicProfile = publicProfile;
                    }).catch(function (err) {
                        console.debug('Failed to refresh public profile after saving:', err);
                        _this.notificationService.warning(zbuyer.messages.PublicProfileError, zbuyer.messages.ApplicationTitle);
                    });
                    _this.notificationService.success(zbuyer.messages.PublicProfileSaveSuccess, zbuyer.messages.ApplicationTitle);
                    _this.toggleEditMode(false);
                }).catch(function (err) {
                    console.debug(err);
                    _this.notificationService.error(zbuyer.messages.PublicProfileSaveError, zbuyer.messages.ApplicationTitle);
                });
            };
            AccountDirectiveController.prototype.loadProfilePhoto = function (file) {
                var _this = this;
                var reader = new FileReader();
                if (!file) {
                    this.$scope.publicProfileEdit.headshotPhoto_BASE64 = '';
                    this.$scope.$applyAsync();
                    return;
                }
                reader.onloadend = function (loadEvent) {
                    if (!loadEvent.loaded) {
                        console.debug(reader.error);
                        _this.notificationService.error("Unable to load file", zbuyer.messages.ApplicationTitle);
                        return;
                    }
                    var dataURL = reader.result;
                    var _a = dataURL.split(','), prefix = _a[0], base64Data = _a[1];
                    _this.$scope.publicProfileEdit.headshotPhoto_BASE64 = base64Data;
                    // Necessary since loadProfilePhoto is currently called by out-of-scope means (due to file input limitations)
                    // Note: scope-watcher will update actual image link based on updated profile photo data
                    _this.$scope.$applyAsync();
                };
                reader.readAsDataURL(file);
            };
            AccountDirectiveController.prototype.getProfileImageLink = function (base64Data) {
                var mimeType = 'image';
                if (!base64Data) {
                    return null;
                }
                for (var sig in ImageFileSignatures) {
                    if (base64Data.startsWith(sig)) {
                        mimeType = ImageFileSignatures[sig];
                    }
                }
                return "data:".concat(mimeType, ";base64,").concat(base64Data);
            };
            AccountDirectiveController.prototype.setActiveSection = function (sectionType) {
                var viewModel = this.$scope.viewModel;
                viewModel.activeAccountSection = sectionType;
            };
            AccountDirectiveController.prototype.testLeadInitialize = function (reinitialize) {
                var _this = this;
                if (reinitialize === void 0) { reinitialize = false; }
                var viewModel = this.$scope.viewModel;
                if (viewModel.testLeadFormInputs && !reinitialize) {
                    return;
                }
                viewModel.testLeadFormInputs = null;
                this.testNotificationService.getTestNotificationOptions().then(function (inputFormItems) {
                    // Should enable "Send Test Lead" button
                    viewModel.testLeadFormInputs = inputFormItems;
                }).catch(function (err) { return _this.handleLegacyServiceError(err); });
            };
            AccountDirectiveController.prototype.testLeadSendNotification = function () {
                var _this = this;
                var promiseState = { pending: true };
                controllers.TestNotificationModalController.loadModal(this.$scope.viewModel.testLeadFormInputs).then(function (formValues) {
                    // Should be formValues object if it wasn't cancelled
                    if (formValues) {
                        _this.testNotificationService.sendTestNotification(formValues).then(function () {
                            _this.notificationService.success('Test notification sent!');
                        }).catch(function (err) { return _this.handleLegacyServiceError(err); })
                            .finally(function () { return promiseState.pending = false; });
                    }
                    else {
                        promiseState.pending = false;
                    }
                });
                return promiseState;
            };
            AccountDirectiveController.prototype.smsPhoneBlurred = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.editingSmsPhone = false;
                if (viewModel.textNotificationForm.phone.$invalid && viewModel.account.textAlerts) {
                    viewModel.account.textAlerts = false;
                    this.updateNotificationSettings();
                }
            };
            AccountDirectiveController.prototype.smsPhoneChanged = function () {
                var viewModel = this.$scope.viewModel;
                if (!viewModel.textNotificationForm.phone.$invalid) {
                    // Turn on text alerts and save as soon as valid
                    viewModel.account.textAlerts = true;
                    this.updateNotificationSettings();
                }
            };
            AccountDirectiveController.prototype.smsPhoneFocused = function () {
                this.$scope.viewModel.editingSmsPhone = true;
            };
            AccountDirectiveController.prototype.toggleEditMode = function (revertChanges) {
                if (revertChanges === void 0) { revertChanges = true; }
                var viewModel = this.$scope.viewModel;
                // Note: Same editing mode flag used for 2 different sections, just not at same time
                viewModel.isEditingEnabled = !viewModel.isEditingEnabled;
                if (viewModel.activeAccountSection == vme.AccountSectionType.MemberProfile) {
                    if (viewModel.isEditingEnabled) {
                        // Member profile is edited by backing up the original
                        viewModel.accountTemp = angular.copy(viewModel.account, viewModel.accountTemp);
                    }
                    else {
                        // Discard edits
                        if (revertChanges && viewModel.accountTemp) {
                            viewModel.account = viewModel.accountTemp;
                        }
                        this.resetForm();
                    }
                }
                else if (viewModel.activeAccountSection == vme.AccountSectionType.PublicProfile) {
                    viewModel.validate = false;
                    // Public profile is never changed until actually saved -- only the "edit" which is used to build the save request
                    if (viewModel.isEditingEnabled || revertChanges) {
                        // Just ensure the visible "edit" matches on fresh edit, or when reverting to saved changes
                        this.$scope.publicProfileEdit = angular.copy(this.$scope.viewModel.publicProfile);
                    }
                }
            };
            AccountDirectiveController.prototype.toggleTextAlerts = function () {
                var viewModel = this.$scope.viewModel;
                if (viewModel.textNotificationForm.phone.$invalid && viewModel.account.textAlerts) {
                    // Don't allow turning on when invalid
                    viewModel.account.textAlerts = false;
                    angular.element(SmsPhoneInputElement).focus();
                }
                else {
                    this.updateNotificationSettings();
                }
            };
            AccountDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Q,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.AppSettingsService,
                names.zbuyer.services.CrmService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.NotificationTestService
            ];
            return AccountDirectiveController;
        }(controllers.ControllerBase));
        controllers.AccountDirectiveController = AccountDirectiveController;
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.Account, AccountDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var AddCrmModalController = /** @class */ (function (_super) {
            __extends(AddCrmModalController, _super);
            function AddCrmModalController($scope, $sce, $uibModalInstance, crmService, modalService, notificationService, viewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$uibModalInstance = $uibModalInstance;
                _this.crmService = crmService;
                _this.modalService = modalService;
                _this.notificationService = notificationService;
                _this.modalService.handleCloseActions(_this.$scope, _this.$uibModalInstance);
                $scope.viewModel = viewModel;
                if (viewModel.crmConnectionType.showConnectButton) {
                    viewModel.formViewModel.submitCallback = function (formValues) { return _this.addCrmConnection(formValues); };
                }
                return _this;
            }
            AddCrmModalController.loadModal = function (crmConnectionType) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var modalInstance = $uibModal.open({
                    controller: names.zbuyer.controllers.AddCrmModalController,
                    resolve: {
                        viewModel: {
                            crmConnectionType: crmConnectionType,
                            formViewModel: {
                                inputFormItems: crmConnectionType.inputFormItems,
                                submitButtonText: 'Connect',
                                showSubmitButton: crmConnectionType.showConnectButton,
                                title: crmConnectionType.displayName
                            }
                        }
                    },
                    backdropClass: 'add-crm-backdrop',
                    size: 'md',
                    backdrop: true,
                    templateUrl: AddCrmModalController.TemplateUrl,
                    windowClass: 'add-crm-modal'
                });
                return modalInstance.result;
            };
            AddCrmModalController.prototype.cancel = function () {
                this.$uibModalInstance.close();
            };
            AddCrmModalController.prototype.close = function (newConnection) {
                this.$uibModalInstance.close(newConnection);
            };
            AddCrmModalController.prototype.trustHtml = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            AddCrmModalController.prototype.addCrmConnection = function (formValues) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                console.debug('Submitting input values:', formValues);
                return this.crmService.add(viewModel.crmConnectionType.crmConnectionTypeId, formValues)
                    .then(function (crmConnection) {
                    _this.notificationService.success("Added ".concat(viewModel.crmConnectionType.displayName, " connection: ").concat(crmConnection.displayName));
                    _this.close(crmConnection);
                })
                    .catch(function (error) {
                    var errorMessageToDisplay;
                    if (typeof error == 'string') {
                        errorMessageToDisplay = error;
                    }
                    else {
                        console.error(error);
                        errorMessageToDisplay = 'An unexpected error has occurred. Please contact support.';
                    }
                    _this.notificationService.error(errorMessageToDisplay);
                });
            };
            AddCrmModalController.TemplateUrl = 'staticpages/modals/AddCrmModal.html';
            AddCrmModalController.$inject = [
                names.angular.Scope,
                names.angular.Sce,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.CrmService,
                names.zbuyer.services.ModalService,
                names.zbuyer.services.NotificationService,
                'viewModel'
            ];
            return AddCrmModalController;
        }(controllers.ControllerBase));
        controllers.AddCrmModalController = AddCrmModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.AddCrmModalController, AddCrmModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/components/advancedpackageslidercomponent.html';
        var AdvancedPackageSliderController = /** @class */ (function () {
            function AdvancedPackageSliderController($scope) {
                $scope.$$postDigest(function () {
                    $scope.$broadcast('rzSliderForceRender');
                });
            }
            AdvancedPackageSliderController.prototype.$onInit = function () {
                this.sliderOptions = {
                    ceil: this.maxLeads,
                    disabled: this.sliderDisabled,
                    hidePointerLabels: true,
                    onChange: this.getOnMoveCallback(),
                    onEnd: this.getFinishedMovingCallback()
                };
            };
            AdvancedPackageSliderController.prototype.getFinishedMovingCallback = function () {
                var _this = this;
                return function (sliderId, modelValue, highValue, pointerType) {
                    _this.valueUpdatedCallback({ newValue: modelValue });
                };
            };
            AdvancedPackageSliderController.prototype.getOnMoveCallback = function () {
                var _this = this;
                return function (sliderId, modelValue, highValue, pointerType) {
                    _this.sliderMovedCallback({ newValue: modelValue });
                };
            };
            AdvancedPackageSliderController.getController = function () {
                return {
                    controller: ['$scope', AdvancedPackageSliderController],
                    bindings: {
                        currentValue: '<',
                        maxLeads: '<',
                        pricePerLead: '<',
                        sliderDisabled: '<',
                        sliderMovedCallback: '&',
                        valueUpdatedCallback: '&'
                    },
                    templateUrl: TemplateUrl
                };
            };
            return AdvancedPackageSliderController;
        }());
        angular.module(names.zbuyer.Application)
            .component(names.zbuyer.components.AdvancedPackageSliderComponent, AdvancedPackageSliderController.getController());
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var BlockId = 'AdvancedSubscriptionEditLoadingBlock';
        var TemplateUrl = 'staticpages/directives/advancedsubscriptioneditdirective.html';
        var AdvancedSubscriptionEditDirectiveController = /** @class */ (function (_super) {
            __extends(AdvancedSubscriptionEditDirectiveController, _super);
            function AdvancedSubscriptionEditDirectiveController($scope, preCheckoutService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.preCheckoutService = preCheckoutService;
                _this.spinWaitService = spinWaitService;
                _this.pristine = true;
                _this.$scope.viewModel = {
                    lastPackageResponse: null,
                    errorToDisplay: null
                };
                return _this;
            }
            AdvancedSubscriptionEditDirectiveController.prototype.$onInit = function () {
                var _this = this;
                if (this.$scope.initialPackageResponse == null) {
                    this.setLoading();
                    this.refreshAdvancedPackage().finally(function () { return _this.setNotLoading(); });
                }
                else {
                    this.processPackageResponseData(this.$scope.initialPackageResponse);
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.findByCountyAndState = function (countyName, stateCode) {
                var _a;
                return (_a = this.$scope.viewModel) === null || _a === void 0 ? void 0 : _a.lastPackageResponse.countyPackages.find(function (county) { return county.countyName == countyName && county.stateCode == stateCode; });
            };
            AdvancedSubscriptionEditDirectiveController.prototype.getBuyerFinalizeCallback = function (countyName, stateCode) {
                var _this = this;
                return function (newValue) {
                    _this.onBuyerUpdate({ countyName: countyName, stateCode: stateCode }, newValue);
                };
            };
            AdvancedSubscriptionEditDirectiveController.prototype.getSellerFinalizeCallback = function (countyName, stateCode) {
                var _this = this;
                return function (newValue) {
                    _this.onSellerUpdate({ countyName: countyName, stateCode: stateCode }, newValue);
                };
            };
            // Updates the model value but does not synchronize with the server
            AdvancedSubscriptionEditDirectiveController.prototype.nonBindingBuyerUpdate = function (callback, newValue) {
                var oldEntry = this.findByCountyAndState(callback.countyName, callback.stateCode);
                if (oldEntry != null) {
                    oldEntry.selectedBuyers = newValue;
                }
            };
            // Updates the model value but does not synchronize with the server
            AdvancedSubscriptionEditDirectiveController.prototype.nonBindingSellerUpdate = function (callback, newValue) {
                var oldEntry = this.findByCountyAndState(callback.countyName, callback.stateCode);
                if (oldEntry != null) {
                    oldEntry.selectedSellers = newValue;
                }
            };
            // Updates the model value but does not synchronize with the server
            AdvancedSubscriptionEditDirectiveController.prototype.getNonBindingBuyerUpdate = function (countyName, stateCode) {
                var _this = this;
                return function (newValue) {
                    _this.nonBindingBuyerUpdate({ countyName: countyName, stateCode: stateCode }, newValue);
                };
            };
            // Updates the model value but does not synchronize with the server
            AdvancedSubscriptionEditDirectiveController.prototype.getNonBindingSellerUpdate = function (countyName, stateCode) {
                var _this = this;
                return function (newValue) {
                    _this.nonBindingSellerUpdate({ countyName: countyName, stateCode: stateCode }, newValue);
                };
            };
            AdvancedSubscriptionEditDirectiveController.prototype.handleError = function (error) {
                if (error === void 0) { error = null; }
                var viewModel = this.$scope.viewModel;
                if (typeof error == 'string') {
                    viewModel.errorToDisplay = error;
                }
                else {
                    viewModel.errorToDisplay = 'An unexpected error has occurred. Please refresh the page.';
                    console.log(error);
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.onBlurSellerLeadsInput = function (countyPackage) {
                var _a;
                countyPackage.selectedSellers = Math.max(0, Math.min(countyPackage.maxSellers, (_a = countyPackage.selectedSellers) !== null && _a !== void 0 ? _a : 0));
                this.updateLeadsCount({
                    countyName: countyPackage.countyName,
                    stateCode: countyPackage.stateCode,
                    buyerLeadsCount: countyPackage.selectedBuyers,
                    sellerLeadsCount: countyPackage.selectedSellers
                });
            };
            AdvancedSubscriptionEditDirectiveController.prototype.onBlurBuyerLeadsInput = function (countyPackage) {
                var _a;
                countyPackage.selectedBuyers = Math.max(0, Math.min(countyPackage.maxBuyers, (_a = countyPackage.selectedBuyers) !== null && _a !== void 0 ? _a : 0));
                this.updateLeadsCount({
                    countyName: countyPackage.countyName,
                    stateCode: countyPackage.stateCode,
                    buyerLeadsCount: countyPackage.selectedBuyers,
                    sellerLeadsCount: countyPackage.selectedSellers
                });
            };
            AdvancedSubscriptionEditDirectiveController.prototype.onBuyerUpdate = function (callback, newValue) {
                var oldEntry = this.findByCountyAndState(callback.countyName, callback.stateCode);
                if (oldEntry != null) {
                    this.updateLeadsCount({
                        countyName: oldEntry.countyName,
                        stateCode: oldEntry.stateCode,
                        buyerLeadsCount: newValue,
                        sellerLeadsCount: oldEntry.selectedSellers
                    });
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.onSellerUpdate = function (callback, newValue) {
                var oldEntry = this.findByCountyAndState(callback.countyName, callback.stateCode);
                if (oldEntry != null) {
                    this.updateLeadsCount({
                        countyName: oldEntry.countyName,
                        stateCode: oldEntry.stateCode,
                        buyerLeadsCount: oldEntry.selectedBuyers,
                        sellerLeadsCount: newValue
                    });
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.openCountyModal = function () {
                var _this = this;
                var alreadySelectedCounties = [];
                if (this.$scope.viewModel.lastPackageResponse) {
                    alreadySelectedCounties = this.$scope.viewModel.lastPackageResponse.countyPackages.map(function (countyPackage) {
                        return { name: countyPackage.countyName, stateAbbreviation: countyPackage.stateCode };
                    });
                }
                controllers.SelectCountyModalController.loadModal(alreadySelectedCounties).then(function (selectedCounty) {
                    if (!selectedCounty) {
                        return;
                    }
                    _this.setLoading();
                    _this.pristine = false;
                    _this.preCheckoutService.addCountyToWorkingArea(selectedCounty)
                        .then(function () { return _this.refreshAdvancedPackage(); })
                        .catch(function (err) { return _this.handleError(err); })
                        .finally(function () { return _this.setNotLoading(); });
                });
            };
            AdvancedSubscriptionEditDirectiveController.prototype.openLearnMoreModal = function (track) {
                controllers.LearnMoreModalController.loadModal(track);
            };
            AdvancedSubscriptionEditDirectiveController.prototype.openMetroModal = function () {
                var _this = this;
                controllers.SelectMetroModalController.loadModal()
                    .then(function (selectedMetroArea) {
                    if (!selectedMetroArea) {
                        return;
                    }
                    _this.setLoading();
                    _this.pristine = false;
                    return _this.preCheckoutService.addMetroAreaToWorkingArea(selectedMetroArea)
                        .then(function () { return _this.refreshAdvancedPackage(); })
                        .catch(function (err) { return _this.handleError(err); })
                        .finally(function () { _this.setNotLoading(); });
                });
            };
            AdvancedSubscriptionEditDirectiveController.prototype.openStatisticsModal = function (countyName, stateCode) {
                if (!this.sellerIsSoldOut(countyName, stateCode)) {
                    controllers.CountyStatisticsModalController.loadModal(stateCode, countyName);
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.preferSellersBuyers = function (preferSellers, preferBuyers, userConfirmed) {
                var _this = this;
                if (userConfirmed === void 0) { userConfirmed = false; }
                if (this.pristine || userConfirmed) {
                    this.setLoading();
                    this.preCheckoutService.setLeadTypePreference(preferSellers, preferBuyers)
                        .then(function () { return _this.refreshAdvancedPackage(); })
                        .catch(function (err) { return _this.handleError(err); })
                        .finally(function () { _this.setNotLoading(); });
                }
                else {
                    zbuyer.controllers.YesNoModalComponent.loadModal({
                        titleText: "Are you sure?",
                        text: "Any lead count values you have customized may be reset.",
                        noButtonText: null,
                        yesButtonText: null
                    }).then(function (result) {
                        if (result == controllers.YesNoModalResults.Yes) {
                            _this.preferSellersBuyers(preferSellers, preferBuyers, true);
                        }
                    });
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.processPackageResponseData = function (data) {
                var viewModel = this.$scope.viewModel;
                if (!data.success || data.errorMessageToDisplay) {
                    console.log(data);
                    viewModel.errorToDisplay = data.errorMessageToDisplay;
                }
                else {
                    viewModel.errorToDisplay = null;
                }
                viewModel.lastPackageResponse = data;
            };
            AdvancedSubscriptionEditDirectiveController.prototype.refreshAdvancedPackage = function () {
                var _this = this;
                return this.preCheckoutService.getAdvancedPackage()
                    .then(function (response) { return _this.processPackageResponseData(response); })
                    .catch(function (err) { return _this.handleError(err); });
            };
            AdvancedSubscriptionEditDirectiveController.prototype.removeCounty = function (countyName, stateCode) {
                var _this = this;
                this.pristine = false;
                this.setLoading();
                return this.preCheckoutService.removeCountyFromWorkingArea({ name: countyName, stateAbbreviation: stateCode, specialInfoItemMessage: "", specialInfoItemUrl: "" })
                    .then(function () { return _this.refreshAdvancedPackage(); })
                    .catch(function (err) { return _this.handleError(err); })
                    .finally(function () { return _this.setNotLoading(); });
            };
            AdvancedSubscriptionEditDirectiveController.prototype.revertToRecommendedSettings = function (modalText, userConfirmed) {
                var _this = this;
                if (userConfirmed === void 0) { userConfirmed = false; }
                if (this.pristine || userConfirmed) {
                    this.setLoading();
                    this.preCheckoutService.resetToRecommendedPackage()
                        .then(function () { return _this.$scope.resetToRecommendedCallback(); })
                        .catch(function (err) { return _this.handleError(err); })
                        .finally(function () { return _this.setNotLoading(); });
                }
                else {
                    zbuyer.controllers.YesNoModalComponent.loadModal({
                        titleText: null,
                        text: modalText,
                        noButtonText: null,
                        yesButtonText: null
                    }).then(function (result) {
                        if (result == controllers.YesNoModalResults.Yes) {
                            _this.revertToRecommendedSettings(modalText, true);
                        }
                    });
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.sellerIsSoldOut = function (countyName, stateCode) {
                var area = this.findByCountyAndState(countyName, stateCode);
                if (area && area.sellersSoldOut == false) {
                    return false;
                }
                else {
                    return true;
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.setLoading = function () {
                this.spinWaitService.block(BlockId, 'image logo', 'Loading...');
            };
            AdvancedSubscriptionEditDirectiveController.prototype.setNotLoading = function () {
                this.spinWaitService.unblock(BlockId);
            };
            AdvancedSubscriptionEditDirectiveController.prototype.viewCart = function () {
                var _this = this;
                if (this.$scope.viewModel.lastPackageResponse) {
                    var packageInfo = this.$scope.viewModel.lastPackageResponse.countyPackages.map(function (countyPackage) {
                        return {
                            countyName: countyPackage.countyName,
                            stateCode: countyPackage.stateCode,
                            buyerLeadsCount: countyPackage.selectedBuyers,
                            sellerLeadsCount: countyPackage.selectedSellers
                        };
                    });
                    this.preCheckoutService.validateAdvancedPackageDisplay({ countyPackages: packageInfo, totalPriceUSD: this.$scope.viewModel.lastPackageResponse.totalPriceUSD })
                        .then(function (packageValid) {
                        if (packageValid) {
                            _this.$scope.checkoutCallback();
                        }
                        else {
                        }
                    });
                }
                else {
                    return;
                }
            };
            AdvancedSubscriptionEditDirectiveController.prototype.updateLeadsCount = function (newValues) {
                var _this = this;
                this.pristine = false;
                this.setLoading();
                return this.preCheckoutService.setAdvancedCountyLeadCounts(newValues)
                    .then(function (response) { return _this.processPackageResponseData(response); })
                    .catch(function (err) { return _this.handleError(err); })
                    .finally(function () { return _this.setNotLoading(); });
            };
            AdvancedSubscriptionEditDirectiveController.getDirective = function () {
                return {
                    controller: AdvancedSubscriptionEditDirectiveController,
                    restrict: 'E',
                    scope: {
                        checkoutCallback: '&onCheckout',
                        initialPackageResponse: '<',
                        loading: '<',
                        resetToRecommendedCallback: '&onReset'
                    },
                    templateUrl: TemplateUrl
                };
            };
            AdvancedSubscriptionEditDirectiveController.$inject = [
                names.angular.Scope,
                names.zbuyer.services.CheckoutHelperService,
                names.zbuyer.services.SpinWaitService
            ];
            return AdvancedSubscriptionEditDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.AdvancedSubscriptionEdit, AdvancedSubscriptionEditDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var BlockId = 'BasicSubscriptionEditLoadingBlock';
        var TemplateUrl = 'staticpages/directives/basicsubscriptioneditdirective.html';
        var DefaultMinimumLeadCount = 10;
        var BasicSubscriptionEditDirectiveController = /** @class */ (function (_super) {
            __extends(BasicSubscriptionEditDirectiveController, _super);
            function BasicSubscriptionEditDirectiveController($scope, $timeout, notificationService, preCheckoutService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$timeout = $timeout;
                _this.notificationService = notificationService;
                _this.preCheckoutService = preCheckoutService;
                _this.spinWaitService = spinWaitService;
                _this.setLoading();
                return _this;
            }
            BasicSubscriptionEditDirectiveController.getDirective = function () {
                return {
                    controller: BasicSubscriptionEditDirectiveController,
                    restrict: 'E',
                    scope: {
                        checkoutCallback: '&onCheckout',
                        viewModel: '=',
                        activeStep: '=',
                    },
                    templateUrl: TemplateUrl
                };
            };
            BasicSubscriptionEditDirectiveController.fitToSliderRange = function (value, sliderOptions) {
                return Math.max(sliderOptions.floor, Math.min(sliderOptions.ceil, value));
            };
            BasicSubscriptionEditDirectiveController.prototype.isPendingSetLeadsAmount = function (scope, isSellerTrack, leadCount) {
                var pendingAmount = (isSellerTrack ? scope.sellerLeadsAmountPending : scope.buyerLeadsAmountPending);
                return pendingAmount == leadCount;
            };
            BasicSubscriptionEditDirectiveController.prototype.setPendingLeadAmount = function (scope, isSellerTrack, leadCount) {
                if (isSellerTrack) {
                    scope.sellerLeadsAmountPending = leadCount;
                }
                else {
                    scope.buyerLeadsAmountPending = leadCount;
                }
                scope.userEditingLeads = scope.sellerLeadsAmountPending != null || scope.buyerLeadsAmountPending != null;
            };
            BasicSubscriptionEditDirectiveController.prototype.setLeadsForTrack = function (isSellerTrack) {
                var _this = this;
                var scope = this.$scope;
                var amountToSet = isSellerTrack ?
                    scope.viewModel.sellerLeadCount :
                    scope.viewModel.buyerLeadCount;
                if (this.isPendingSetLeadsAmount(scope, isSellerTrack, amountToSet)) {
                    // Already expecting response for this amount
                    return;
                }
                // Track the pending amount to verify against response
                this.setPendingLeadAmount(scope, isSellerTrack, amountToSet);
                var responsePromise = isSellerTrack ?
                    this.preCheckoutService.setRecomendedPackageSellers(amountToSet) :
                    this.preCheckoutService.setRecomendedPackageBuyers(amountToSet);
                var isRequestValid = false;
                responsePromise
                    .then(function (recommendedPackage) {
                    // Is the amount requested still the most recent?
                    isRequestValid = _this.isPendingSetLeadsAmount(scope, isSellerTrack, amountToSet);
                    if (!isRequestValid) {
                        // Superceded
                        return;
                    }
                    // Note: overwrites all info (counties, values on each track, etc)
                    scope.viewModel = recommendedPackage;
                    // In case somehow there are pending requests on both tracks, don't let
                    // first response contradict whatever's pending on the second response
                    // (i.e. don't let the slider flicker back to what it was).
                    if (isSellerTrack && scope.buyerLeadsAmountPending) {
                        scope.viewModel.buyerLeadCount = scope.buyerLeadsAmountPending;
                    }
                    else if (!isSellerTrack && scope.sellerLeadsAmountPending) {
                        scope.viewModel.sellerLeadCount = scope.sellerLeadsAmountPending;
                    }
                    _this.updateSliders();
                })
                    .catch(function (err) { return _this.handleError(err); })
                    .finally(function () {
                    if (isRequestValid) {
                        // Cleanup (request was not invalidated by any newer request)
                        _this.setPendingLeadAmount(scope, isSellerTrack, null);
                    }
                });
            };
            BasicSubscriptionEditDirectiveController.prototype.setLoading = function () {
                this.spinWaitService.block(BlockId, 'image logo', 'Loading...');
            };
            BasicSubscriptionEditDirectiveController.prototype.setNotLoading = function () {
                this.spinWaitService.unblock(BlockId);
            };
            BasicSubscriptionEditDirectiveController.prototype.onFocusLeadsInput = function () {
                this.$scope.userEditingLeads = true;
            };
            BasicSubscriptionEditDirectiveController.prototype.onBlurSellerLeadsInput = function () {
                this.$scope.viewModel.sellerLeadCount = BasicSubscriptionEditDirectiveController.fitToSliderRange(this.$scope.viewModel.sellerLeadCount, this.$scope.sellerLeadsSliderOptions);
                this.setLeadsForTrack(true);
            };
            BasicSubscriptionEditDirectiveController.prototype.onBlurBuyerLeadsInput = function () {
                this.$scope.viewModel.buyerLeadCount = BasicSubscriptionEditDirectiveController.fitToSliderRange(this.$scope.viewModel.buyerLeadCount, this.$scope.buyerLeadsSliderOptions);
                this.setLeadsForTrack(false);
            };
            BasicSubscriptionEditDirectiveController.prototype.initializeSliders = function (selfInvoke) {
                var _this = this;
                if (selfInvoke === void 0) { selfInvoke = true; }
                if (selfInvoke) {
                    // Gets us past the ng init cycle avoiding glitches with Rzlider on rendering too soon.
                    this.$timeout(function () { return _this.initializeSliders(false); }, 1);
                    return;
                }
                var viewModel = this.$scope.viewModel;
                var scope = this.$scope;
                scope.buyerLeadsAmountPending = null;
                scope.sellerLeadsAmountPending = null;
                var buyerLeadsSliderOptions = {
                    disableAnimation: true,
                    hidePointerLabels: true,
                    onStart: function () { return scope.userEditingLeads = true; },
                    onEnd: function () { return _this.setLeadsForTrack(false); }
                };
                this.configureSlider(buyerLeadsSliderOptions, viewModel.buyerLeadCount, viewModel.maxBuyers, viewModel.buyersSoldOut);
                var sellerLeadsSliderOptions = {
                    disableAnimation: true,
                    hidePointerLabels: true,
                    onStart: function () { return scope.userEditingLeads = true; },
                    onEnd: function () { return _this.setLeadsForTrack(true); }
                };
                this.configureSlider(sellerLeadsSliderOptions, viewModel.sellerLeadCount, viewModel.maxSellers, viewModel.sellersSoldOut);
                scope.buyerLeadsSliderOptions = buyerLeadsSliderOptions;
                scope.sellerLeadsSliderOptions = sellerLeadsSliderOptions;
                this.setNotLoading();
            };
            BasicSubscriptionEditDirectiveController.prototype.updateSliders = function () {
                var viewModel = this.$scope.viewModel;
                this.configureSlider(this.$scope.buyerLeadsSliderOptions, viewModel.buyerLeadCount, viewModel.maxBuyers, viewModel.buyersSoldOut);
                this.configureSlider(this.$scope.sellerLeadsSliderOptions, viewModel.sellerLeadCount, viewModel.maxSellers, viewModel.sellersSoldOut);
            };
            BasicSubscriptionEditDirectiveController.prototype.configureSlider = function (sliderOptions, currentLeadCount, maxLeadCount, soldOut) {
                var sliderMinimum = Math.min(DefaultMinimumLeadCount, currentLeadCount, maxLeadCount);
                var disabled = soldOut || (maxLeadCount <= sliderMinimum);
                sliderOptions.floor = sliderMinimum;
                sliderOptions.ceil = maxLeadCount;
                sliderOptions.disabled = disabled;
            };
            BasicSubscriptionEditDirectiveController.prototype.goToTeamSizeStep = function () {
                this.$scope.activeStep = zbuyer.viewmodels.enums.PreCheckoutStep.TeamSize;
            };
            BasicSubscriptionEditDirectiveController.prototype.goToWorkingAreaStep = function () {
                this.$scope.activeStep = zbuyer.viewmodels.enums.PreCheckoutStep.WorkingArea;
            };
            BasicSubscriptionEditDirectiveController.prototype.goToAdvancedStep = function () {
                this.$scope.activeStep = zbuyer.viewmodels.enums.PreCheckoutStep.AdvancedEdit;
            };
            BasicSubscriptionEditDirectiveController.prototype.handleError = function (error) {
                if (error === void 0) { error = null; }
                var viewModel = this.$scope.viewModel;
                // Reset UI signals
                this.$scope.buyerLeadsAmountPending = null;
                this.$scope.sellerLeadsAmountPending = null;
                this.$scope.userEditingLeads = false;
                if (typeof error == 'string') {
                    viewModel.errorMessageToDisplay = error;
                }
                else {
                    viewModel.errorMessageToDisplay = 'An unexpected error has occurred. Please refresh the page.';
                    console.log(error);
                }
                this.notificationService.error(viewModel.errorMessageToDisplay);
            };
            BasicSubscriptionEditDirectiveController.prototype.loadRecommendedPackage = function () {
                var _this = this;
                var scope = this.$scope;
                return this.preCheckoutService.getRecommendedPackage()
                    .then(function (pkg) {
                    if (!pkg) {
                        _this.handleError(null);
                        return;
                    }
                    scope.viewModel = pkg;
                    _this.updateSliders();
                })
                    .catch(function (err) { return _this.handleError(err); });
            };
            BasicSubscriptionEditDirectiveController.prototype.preferSellersBuyers = function (preferSellers, preferBuyers) {
                var _this = this;
                this.setLoading();
                this.preCheckoutService.setLeadTypePreference(preferSellers, preferBuyers)
                    .then(function () { return _this.loadRecommendedPackage(); })
                    .catch(function (err) { return _this.handleError(err); })
                    .finally(function () { return _this.setNotLoading(); });
            };
            BasicSubscriptionEditDirectiveController.prototype.showCountyBreakdownModal = function () {
                controllers.RecommendedPackageCountyBreakdownController.loadModal(this.$scope.viewModel.counties);
            };
            BasicSubscriptionEditDirectiveController.prototype.showLearnMoreModal = function (track) {
                controllers.LearnMoreModalController.loadModal(track);
            };
            BasicSubscriptionEditDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Timeout,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.CheckoutHelperService,
                names.zbuyer.services.SpinWaitService
            ];
            return BasicSubscriptionEditDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.BasicSubscriptionEdit, BasicSubscriptionEditDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var vme = zbuyer.viewmodels.enums;
        var TemplateUrl = 'staticpages/directives/cartbuilderdirective.html';
        var CartFlashTimeoutMillis = 1000; // Time to block UI with indication on "cart updated"
        var CartItemBuilder = /** @class */ (function () {
            function CartItemBuilder() {
            }
            return CartItemBuilder;
        }());
        var LeadPathGroup = /** @class */ (function () {
            function LeadPathGroup() {
            }
            return LeadPathGroup;
        }());
        var CartBuilderController = /** @class */ (function (_super) {
            __extends(CartBuilderController, _super);
            function CartBuilderController($scope, $location, $q, $sce, $timeout, $window, checkoutService, countiesService, countyStatisticsService, notificationService, spinWaitService, statesService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$location = $location;
                _this.$q = $q;
                _this.$sce = $sce;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.checkoutService = checkoutService;
                _this.countiesService = countiesService;
                _this.countyStatisticsService = countyStatisticsService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.statesService = statesService;
                _this.$scope.losAngelesSubdivided = { name: 'Los Angeles (Subdivided)', stateAbbreviation: 'CA' };
                _this.$scope.LeadType = vme.CartLeadType;
                var checkoutFlag = _this.$location.search()[names.zbuyer.queryparameters.Checkout];
                if (checkoutFlag) {
                    if (checkoutFlag.toLowerCase() === true.toString()) {
                        // Flag indicates we want to go straight to checkout
                        _this.cartCheckout();
                        return _this;
                    }
                }
                _this.initializeCartBuilderController();
                return _this;
            }
            CartBuilderController.getDirective = function () {
                return {
                    controller: CartBuilderController,
                    restrict: 'E',
                    scope: {
                        checkoutCallback: '&onCheckout',
                        viewModel: '=',
                        zipCode: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            CartBuilderController.prototype.initializeCartBuilderController = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var initDropdowns = this.statesService.getStates().then(function (result) {
                    viewModel.states = result;
                    if (!_this.$scope.zipCode) {
                        return _this.$q.resolve();
                    }
                    return _this.selectCountyByZip(_this.$scope.zipCode);
                });
                var allInitDone = this.$q.all([initDropdowns, this.getCurrentCart()]).then(function () {
                    _this.$scope.initialized = true;
                });
                this.spinWaitService.blockDuring(allInitDone, 'CartBuilderInitializing', 'image logo');
            };
            CartBuilderController.prototype.activateOption = function (leadOption, pathGroup) {
                var affectedSelector;
                pathGroup.leadOptions.forEach(function (builder) {
                    if (builder == leadOption) {
                        builder.isActive = true;
                        affectedSelector = builder.selector;
                    }
                    else {
                        builder.isActive = false;
                    }
                });
                this.forceSliderUpdate(affectedSelector);
            };
            CartBuilderController.prototype.forceSliderUpdate = function (affectedSelector) {
                var _this = this;
                // Section containing the slider was previously hidden, and the RzSlider atttempts to render itself too soon after displayed, causing defects.
                // So we can set a flag that lets it hide while multiple re-renders are attmempted (timing is tricky)
                affectedSelector.rendering = true;
                // Note: Render seems to be needed strictly AFTER the Angular digest but also needs some unknown delay beyond even that.
                this.$timeout(function () {
                    // In testing, this was usually late enough to reveal the good render after concealing the first botched render.
                    affectedSelector.rendering = false;
                    _this.$scope.$broadcast('rzSliderForceRender');
                }, 175);
                this.$timeout(function () {
                    _this.$scope.$broadcast('rzSliderForceRender');
                }, 250);
                this.$timeout(function () {
                    _this.$scope.$broadcast('rzSliderForceRender');
                }, 750);
            };
            CartBuilderController.prototype.initializeLeadOption = function (leadOption, tabTitle) {
                if (!leadOption.showLeadOption) {
                    return null;
                }
                var itemBuilder = {
                    settings: leadOption,
                    tabTitle: tabTitle,
                    isActive: leadOption.isDefaultTabOfGroup
                };
                var ceil = itemBuilder.settings.quantityMax;
                var value = Math.min(ceil, itemBuilder.settings.quantityDefault);
                var floor = ceil == 0 ? 0 : itemBuilder.settings.quantityMin;
                itemBuilder.selector = this.getSelector(value, floor, ceil, itemBuilder.isSoldOut);
                itemBuilder.isSoldOut = itemBuilder.settings.showPriceAndQtyBlock && ceil == 0;
                return itemBuilder;
            };
            CartBuilderController.prototype.addOrUpdateLeadOption = function (cartItemBuilder) {
                var viewModel = this.$scope.viewModel;
                var request = {
                    quantity: cartItemBuilder.selector.selectedValue,
                    county: viewModel.selectedCounty.name,
                    state: viewModel.selectedState.abbreviation,
                    includeCurrentCart: true,
                    leadType: cartItemBuilder.settings.leadType
                };
                this.updateCart(request).then(function () {
                    cartItemBuilder.settings.alreadyInCart = true;
                });
            };
            CartBuilderController.prototype.addOption = function (additionalOption) {
                var viewModel = this.$scope.viewModel;
                var request = {
                    quantity: 1,
                    county: viewModel.selectedCounty.name,
                    state: viewModel.selectedState.abbreviation,
                    includeCurrentCart: true,
                    additionalOptionType: additionalOption.additionalOptionType,
                    leadType: vme.CartLeadType.Unknown,
                };
                this.updateCart(request).then(function () {
                    additionalOption.alreadyInCart = true;
                });
            };
            CartBuilderController.prototype.cartCheckout = function () {
                this.$scope.checkoutCallback();
            };
            CartBuilderController.prototype.checkStatisticsModalShouldBeVisible = function () {
                var _this = this;
                var _a, _b;
                var viewModel = this.$scope.viewModel;
                var state = (_a = viewModel.selectedState) === null || _a === void 0 ? void 0 : _a.abbreviation;
                var county = (_b = viewModel.selectedCounty) === null || _b === void 0 ? void 0 : _b.name;
                viewModel.statisticModalLinkVisible = false;
                if (!state || !county) {
                    // County is un-selected
                    return this.$q.resolve();
                }
                this.countyStatisticsService.getCountyStatisticsForStateAndCounty(state, county).then(function (result) {
                    var countyStatistics = result.countyStatistics;
                    if (!countyStatistics) {
                        return;
                    }
                    if (countyStatistics.availability ||
                        countyStatistics.averageHomeValue ||
                        countyStatistics.averageLeadSharing ||
                        countyStatistics.maxHomeValue ||
                        countyStatistics.minHomeValue ||
                        countyStatistics.needFinancingToBuy ||
                        countyStatistics.sellersAlsoBuying ||
                        countyStatistics.willingToDiscount ||
                        countyStatistics.soldWithin1YearText ||
                        countyStatistics.soldWithin2YearsText ||
                        countyStatistics.soldWithin3YearsText ||
                        countyStatistics.soldWithin6MonthsText) {
                        viewModel.statisticModalLinkVisible = true;
                        return;
                    }
                    if (countyStatistics.leadMapEnabled) {
                        _this.countyStatisticsService.getCountyLeadsCoordinatesForStateAndCounty(state, county).then(function (result) {
                            var _a;
                            var coordinates = (_a = result === null || result === void 0 ? void 0 : result.countyLeadsCoordinates) === null || _a === void 0 ? void 0 : _a.coordinates;
                            if (coordinates && coordinates.length > 0) {
                                viewModel.statisticModalLinkVisible = true;
                            }
                        }).catch(console.debug);
                    }
                    if (countyStatistics.cityStatisticsEnabled) {
                        _this.countyStatisticsService.getCityLeadCountsForStateAndCounty(state, county).then(function (result) {
                            if ((result === null || result === void 0 ? void 0 : result.cityLeads) && result.cityLeads.length > 0) {
                                viewModel.statisticModalLinkVisible = true;
                            }
                        }).catch(console.debug);
                    }
                }).catch(console.debug);
            };
            CartBuilderController.prototype.getCartItemBuilder = function (cartRowItemType) {
                for (var _i = 0, _a = this.$scope.leadPathGroups; _i < _a.length; _i++) {
                    var optionList = _a[_i];
                    for (var _b = 0, _c = optionList.leadOptions; _b < _c.length; _b++) {
                        var cartBuilder = _c[_b];
                        if (cartBuilder.settings.leadType.toString() == cartRowItemType) {
                            return cartBuilder;
                        }
                    }
                }
            };
            CartBuilderController.prototype.deleteCartItem = function (cartItem) {
                var viewModel = this.$scope.viewModel;
                var request = {
                    state: cartItem.stateEdit,
                    county: cartItem.countyEdit,
                    quantity: 0,
                    includeCurrentCart: true
                };
                var onSuccess;
                if (cartItem.rowType == vme.CartRowType.CartAdditionalOption) {
                    request.leadType = vme.CartLeadType.Unknown;
                    request.additionalOptionType = cartItem.itemType;
                    // We'll fudge a temporary update to the additional option, since we'll know it's been removed
                    var additionalItem_1 = this.$scope.cartAdditionalOptions.find(function (opt) { return opt.additionalOptionType == request.additionalOptionType; });
                    if (additionalItem_1) {
                        onSuccess = function () { additionalItem_1.alreadyInCart = false; };
                    }
                }
                else if (cartItem.rowType == vme.CartRowType.CartLeadOption) {
                    var cartItemBuilder = this.getCartItemBuilder(cartItem.itemType);
                    // Note: itemType is string but *should* be enough to get us the original lead option
                    if (!cartItemBuilder) {
                        console.error('Unable to find lead option info for CartRow with itemType ', cartItem.itemType);
                        return;
                    }
                    // Identify hard CartLeadType
                    request.leadType = cartItemBuilder.settings.leadType;
                    // We'll fudge a temporary udate to the lead option, since we'll know it's been removed
                    onSuccess = function () { cartItemBuilder.settings.alreadyInCart = false; };
                }
                else {
                    throw 'This cart line item cannot be deleted';
                }
                this.updateCart(request).then(onSuccess);
            };
            CartBuilderController.prototype.handleError = function (error) {
                if (typeof error == 'string') {
                    this.notificationService.error(error);
                }
                else {
                    this.notificationService.error('An unexpected error has occurred. Please refresh the page.');
                    console.error(error);
                }
                this.$window.scrollTo(this.$window.scrollX, 0);
            };
            CartBuilderController.prototype.editCartItem = function (cartItem) {
                var _this = this;
                // This will ensure that the "active" state on the tabs are re-bound (they have a one-time-binding)
                this.$scope.initialized = false;
                var editCart = this.selectCounty(cartItem.countyEdit, cartItem.stateEdit).then(function () {
                    // Once we have the right county, make sure the right tab is showing for the cart item we're editing.
                    for (var _i = 0, _a = _this.$scope.leadPathGroups; _i < _a.length; _i++) {
                        var pathGroup = _a[_i];
                        var matchesForCartRow = pathGroup.leadOptions.filter(function (option) { return option.settings.leadType.toString() == cartItem.itemType; });
                        if (matchesForCartRow.length) {
                            _this.activateOption(matchesForCartRow[0], pathGroup);
                        }
                    }
                    // So the tab activation state properly updates
                    return _this.$timeout(function () {
                        _this.$scope.initialized = true;
                        _this.$window.scrollTo({ top: 0 });
                    });
                }).catch(function (err) { return _this.handleError(err); });
                this.spinWaitService.blockDuring(editCart, 'EditCartItem', 'image logo');
            };
            CartBuilderController.prototype.fillCounties = function (stateAbbreviation) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.counties = null; // incoming...
                return this.countiesService.getCountiesForState(stateAbbreviation).then(function (result) {
                    viewModel.counties = result;
                    if (stateAbbreviation === _this.$scope.losAngelesSubdivided.stateAbbreviation) {
                        viewModel.counties.push(_this.$scope.losAngelesSubdivided);
                        viewModel.counties = viewModel.counties.sort(function (a, b) { return a.name.localeCompare(b.name); });
                    }
                    // Auto-select single choice if only one.
                    if (viewModel.counties.length === 1) {
                        viewModel.selectedCounty = viewModel.counties[0];
                        return _this.onCountySelected(false);
                    }
                    return _this.$q.resolve();
                });
            };
            CartBuilderController.prototype.fillRelatedCounties = function () {
                var viewModel = this.$scope.viewModel;
                if (!viewModel.selectedCounty) {
                    // County was un-selected, no related counties to fill
                    return this.$q.resolve();
                }
                return this.countiesService.getRelatedCounties(viewModel.selectedState.abbreviation, viewModel.selectedCounty.name).then(function (result) {
                    // Ensure reponse is still relevant to current state of UI
                    if (viewModel.selectedCounty && viewModel.selectedState) {
                        if (viewModel.selectedCounty.name === result.countyRequested && viewModel.selectedState.abbreviation === result.stateRequested) {
                            viewModel.relatedCounties = result.counties;
                        }
                    }
                });
            };
            CartBuilderController.prototype.flashUpdatedCartOverlay = function () {
                var _this = this;
                var blockId = 'SubscriptionCart';
                this.spinWaitService.blockDuring(this.$timeout(CartFlashTimeoutMillis), blockId, names.misc.BlockUISpinnerCheckmarkClass, zbuyer.messages.UpdateCart)
                    .finally(function () { return _this.spinWaitService.unblock(blockId); });
            };
            CartBuilderController.prototype.getBindableHtml = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            CartBuilderController.prototype.getSelector = function (value, floor, ceil, disabled) {
                return {
                    options: {
                        autoHideLimitLabels: false,
                        ceil: ceil,
                        disabled: disabled,
                        disableAnimation: true,
                        floor: floor,
                        hideLimitLabels: false,
                        // Render all numeric values (max/min/etc except the central model value since we will render that independently)
                        translate: function (value, sliderId, label) {
                            return label == 'model' ? '' : value.toString();
                        }
                    },
                    selectedValue: value,
                };
            };
            CartBuilderController.prototype.joinWaitingList = function (cartItemBuilder) {
                var viewModel = this.$scope.viewModel;
                if (!cartItemBuilder.settings.showWaitingListOption) {
                    return;
                }
                var request = {
                    quantity: 0,
                    joinWaitingList: true,
                    county: viewModel.selectedCounty.name,
                    state: viewModel.selectedState.abbreviation,
                    includeCurrentCart: true,
                    leadType: cartItemBuilder.settings.leadType
                };
                this.updateCart(request);
            };
            CartBuilderController.prototype.addLeadPathGroup = function (rawPathGroup, isSelling) {
                var _this = this;
                if (!rawPathGroup.showPathGroup) {
                    return null;
                }
                var itemBuilders = [
                    this.initializeLeadOption(rawPathGroup.nonExclusiveLeads, 'Shared'),
                    this.initializeLeadOption(rawPathGroup.exclusiveLeads, 'Exclusive')
                ].filter(function (o) { return !!o; });
                if (!itemBuilders.length) {
                    return null;
                }
                var pathGroup = {
                    isSellingPath: isSelling,
                    leadOptions: itemBuilders
                };
                this.$scope.leadPathGroups.push(pathGroup);
                // Special workaround to correct slider rendering after sufficient delay
                pathGroup.leadOptions.forEach(function (leadOption) { return _this.forceSliderUpdate(leadOption.selector); });
                return pathGroup;
            };
            CartBuilderController.prototype.onCountySelected = function (blockUI) {
                var _this = this;
                if (blockUI === void 0) { blockUI = true; }
                if (blockUI) {
                    return this.spinWaitService.blockDuring(this.onCountySelected(false), 'OnCountySelected', 'image logo');
                }
                var viewModel = this.$scope.viewModel;
                viewModel.relatedCounties = null;
                this.$scope.leadPathGroups = [];
                if (!viewModel.selectedCounty) {
                    return this.$q.resolve(); // Nothing else to do
                }
                var promises = [this.fillRelatedCounties(), this.checkStatisticsModalShouldBeVisible()];
                if (viewModel.selectedCounty != this.$scope.losAngelesSubdivided) {
                    var gotItemOptions = this.checkoutService.getCartItemOptions(viewModel.selectedCounty.name, viewModel.selectedCounty.stateAbbreviation).then(function (response) {
                        console.debug('Got CART OPTIONS', response);
                        _this.addLeadPathGroup(response.sellingPathGroup, true);
                        _this.addLeadPathGroup(response.buyingPathGroup, false);
                        _this.$scope.cartAdditionalOptions = response.additionalOptions;
                    }).catch(function (err) { return _this.handleError(err); });
                    promises.push(gotItemOptions);
                }
                return this.$q.all(promises);
            };
            CartBuilderController.prototype.onStateSelected = function (blockUI) {
                if (blockUI === void 0) { blockUI = true; }
                if (blockUI) {
                    return this.spinWaitService.blockDuring(this.onStateSelected(false), 'OnStateSelected', 'image logo');
                }
                var viewModel = this.$scope.viewModel;
                return this.fillCounties(viewModel.selectedState.abbreviation);
            };
            CartBuilderController.prototype.resetDropdownSelection = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.selectedCounty = null;
                viewModel.selectedState = null;
                this.$window.scrollTo({ top: 0 });
            };
            CartBuilderController.prototype.selectCounty = function (countyName, stateAbbreviation) {
                var _this = this;
                var _a, _b;
                var viewModel = this.$scope.viewModel;
                if (stateAbbreviation) {
                    if (((_a = viewModel.selectedState) === null || _a === void 0 ? void 0 : _a.abbreviation) != stateAbbreviation) {
                        // Need right state first. Bring blocking overlay back up after state load finished
                        return this.selectState(stateAbbreviation).then(function () { return _this.selectCounty(countyName); });
                    }
                }
                if (((_b = viewModel.selectedCounty) === null || _b === void 0 ? void 0 : _b.name) == countyName) {
                    return this.$q.resolve();
                }
                var search = viewModel.counties.filter(function (c) { return c.name == countyName; });
                if (search.length > 0) {
                    this.$scope.viewModel.selectedCounty = search[0];
                    return this.onCountySelected(false);
                }
                else {
                    return this.$q.reject();
                }
            };
            CartBuilderController.prototype.selectCountyByZip = function (zip) {
                var _this = this;
                return this.countiesService.getCountyForZip(zip).then(function (county) {
                    if (county) {
                        return _this.selectCounty(county.name, county.stateAbbreviation);
                    }
                });
            };
            CartBuilderController.prototype.selectState = function (abbreviation) {
                var viewModel = this.$scope.viewModel;
                if (viewModel.selectedState && viewModel.selectedState.abbreviation === abbreviation) {
                    return this.$q.resolve();
                }
                var search = viewModel.states.filter(function (s) { return s.abbreviation === abbreviation; });
                if (search.length > 0) {
                    viewModel.selectedState = search[0];
                    return this.onStateSelected(false);
                }
                return this.$q.resolve();
            };
            CartBuilderController.prototype.getCurrentCart = function () {
                var _this = this;
                var gettingCart = this.checkoutService.getCurrentCart(false).then(function (currentCartResponse) {
                    _this.handleUpdatedCart(currentCartResponse);
                }).catch(function (err) { return _this.handleError(err); });
                this.spinWaitService.blockDuring(gettingCart, 'GetCurrentCart', 'image logo', 'Loading Cart');
                return gettingCart;
            };
            CartBuilderController.prototype.showCountyStatisticsModal = function () {
                var viewModel = this.$scope.viewModel;
                controllers.CountyStatisticsModalController.loadModal(viewModel.selectedState.abbreviation, viewModel.selectedCounty.name);
            };
            CartBuilderController.prototype.showLearnMoreModal = function (pathGroup) {
                controllers.LearnMoreModalController.loadModal(pathGroup.isSellingPath ? names.misc.SellersTrack : names.misc.BuyersTrack);
            };
            CartBuilderController.prototype.showZipLookupModal = function () {
                var _this = this;
                controllers.ZipLookupModalController.loadModal().result.then(function (zip) {
                    return _this.spinWaitService.blockDuring(_this.selectCountyByZip(zip), 'SelectCountyByZip', 'image logo');
                });
            };
            CartBuilderController.prototype.updateCart = function (request) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var updatingCart = this.checkoutService.updateCart(request).then(function (response) {
                    _this.handleUpdatedCart(response.currentCart);
                    viewModel.cart = response.currentCart;
                });
                return this.spinWaitService.blockDuring(updatingCart, 'UpdateCart', 'image logo', 'Updating Cart...')
                    .then(function () { return _this.flashUpdatedCartOverlay(); })
                    .catch(function (err) { return _this.handleError(err); });
            };
            CartBuilderController.prototype.handleUpdatedCart = function (currentCart) {
                var _a, _b;
                var viewModel = this.$scope.viewModel;
                if (!currentCart.cartIsEditable) {
                    (_b = (_a = this.$scope).checkoutCallback) === null || _b === void 0 ? void 0 : _b.call(_a);
                    return;
                }
                if (currentCart.redirectToUrl) {
                    this.$window.location.href = currentCart.redirectToUrl;
                }
                console.debug('GOT CART', currentCart);
                viewModel.cart = currentCart;
            };
            CartBuilderController.$inject = [
                names.angular.Scope,
                names.angular.Location,
                names.angular.Q,
                names.angular.Sce,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.services.CheckoutService,
                names.zbuyer.services.CountiesService,
                names.zbuyer.services.CountyStatisticsService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService,
                names.zbuyer.services.StatesService
            ];
            return CartBuilderController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.CartBuilder, CartBuilderController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/checkoutdirective.html';
        var CheckoutDirectiveController = /** @class */ (function (_super) {
            __extends(CheckoutDirectiveController, _super);
            function CheckoutDirectiveController($scope, $sce, $location, $timeout, $window, checkoutService, complianceService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$location = $location;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.checkoutService = checkoutService;
                _this.complianceService = complianceService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.initializeCheckoutDirectiveController();
                return _this;
            }
            CheckoutDirectiveController.getDirective = function () {
                return {
                    controller: CheckoutDirectiveController,
                    restrict: 'E',
                    scope: {
                        supportPhone: '=',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            Object.defineProperty(CheckoutDirectiveController.prototype, "checkoutIsDisabled", {
                get: function () {
                    var viewModel = this.$scope.viewModel;
                    return viewModel.awaitingFormCertification || !viewModel.cartIsValid || (viewModel.paymentForm.$submitted && viewModel.paymentForm.$invalid);
                },
                enumerable: false,
                configurable: true
            });
            CheckoutDirectiveController.prototype.initializeCheckoutDirectiveController = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.awaitingFormCertification = true;
                this.complianceService.applyTrustedFormCertification(names.zbuyer.compliance.Checkout).finally(function () {
                    viewModel.awaitingFormCertification = false;
                });
                this.checkoutService.getCurrentCart(true).then(function (response) {
                    var _a;
                    if (response.redirectToUrl) {
                        _this.$window.location.href = response.redirectToUrl;
                    }
                    viewModel.cart = response;
                    viewModel.cartIsValid = response.cartIsValid;
                    viewModel.errorMessage = (_a = response.errorMessageToDisplay) !== null && _a !== void 0 ? _a : (response.success ? '' : 'There was an error getting your cart data');
                    var checkoutData = response.cartCheckoutData;
                    ;
                    if (checkoutData) {
                        viewModel.initialChargeAmount = checkoutData.initialChargeAmount;
                        viewModel.recurringChargeAmount = checkoutData.recurringChargeAmount;
                        viewModel.recurringNextChargeDate = checkoutData.recurringNextChargeDate;
                    }
                    viewModel.paymentViewModel = {};
                    viewModel.checkoutDataLoaded = true;
                });
                var checkoutFlag = this.$location.search()[names.zbuyer.queryparameters.Checkout];
                if (checkoutFlag) {
                    // Indicates KW Signup flow required
                    viewModel.isKwSignupMode = true;
                    // Note: Technically we are not expecting &checkout=false. IF set immediately to false, user will end up at standard old cart-edit.
                    // But for checkout=true we will see the CheckoutDirective immediately and editing cart from THERE will redirect to KW Signup flows (AKA /precheckout)) as expected.
                    viewModel.isCheckoutActive = checkoutFlag.toLowerCase() === true.toString();
                }
                angular.element(window).on('resize', function () {
                    _this.resizeTermsColumn();
                });
            };
            CheckoutDirectiveController.prototype.editCart = function () {
                var viewModel = this.$scope.viewModel;
                if (this.$scope.viewModel.isKwSignupMode) {
                    if (viewModel.cartIsValid) {
                        // Normal case for KW signup -> just go back to basic-subscription-edit
                        this.$window.location.href = 'signup/precheckout?step=4';
                    }
                    else {
                        // Probably shouldn't be here -> go back to first step of KW signup
                        this.$window.location.href = 'signup/precheckout?step=1';
                    }
                }
                else {
                    viewModel.isCheckoutActive = false;
                }
            };
            CheckoutDirectiveController.prototype.getBindableHtml = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            CheckoutDirectiveController.prototype.checkout = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (viewModel.paymentForm.$invalid) {
                    return;
                }
                viewModel.errorMessage = null;
                var blockId = 'SubscriptionCheckout';
                this.spinWaitService.block(blockId, names.misc.BlockUISpinnerCheckmarkClass, 'Processing Payment');
                var checkoutRequest = {
                    billingZipCode: viewModel.paymentViewModel.billingZipCode,
                    cardCVV2: viewModel.paymentViewModel.cardCVV2,
                    cardExpirationMonth: viewModel.paymentViewModel.cardExpirationMonth,
                    cardExpirationYear: viewModel.paymentViewModel.cardExpirationYear,
                    cardNumber: viewModel.paymentViewModel.cardNumber.replace(/ /g, ''),
                    initialChargeAmtShown: viewModel.initialChargeAmount,
                    recurringChargeAmtShown: viewModel.recurringChargeAmount
                };
                this.checkoutService.performCheckout(checkoutRequest).then(function (result) {
                    if (result.checkoutSuccess) {
                        if (result.showKWCommandPageNext) {
                            viewModel.showKWCommandNotice = true;
                            _this.$window.scrollTo(0, 0);
                        }
                        else {
                            _this.continueOnCheckoutSuccess();
                        }
                    }
                    else {
                        viewModel.errorMessage = result.errorMessageToDisplay;
                        _this.notificationService.error(result.errorMessageToDisplay);
                    }
                }).catch(function (reason) {
                    viewModel.errorMessage = zbuyer.messages.ErrorProcessingPayment;
                    _this.notificationService.error(zbuyer.messages.ErrorProcessingPayment);
                }).finally(function () {
                    _this.spinWaitService.unblock(blockId);
                });
            };
            CheckoutDirectiveController.prototype.continueOnCheckoutSuccess = function () {
                window.location.href = "".concat(appConfiguration.baseUrl, "signup/success");
            };
            CheckoutDirectiveController.prototype.resizeTermsColumn = function () {
                var setWidth = angular.element('.terms-col > ul:first-child > li:first-child').width();
                if (!setWidth) {
                    return;
                }
                angular.element('.terms-col > ul:last-child > li:first-child').width(setWidth);
            };
            CheckoutDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Sce,
                names.angular.Location,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.services.CheckoutService,
                names.zbuyer.services.ComplianceService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService
            ];
            return CheckoutDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.Checkout, CheckoutDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/claimedleadmodal.html';
        var ClaimedLeadNavigationOption;
        (function (ClaimedLeadNavigationOption) {
            ClaimedLeadNavigationOption[ClaimedLeadNavigationOption["ViewClaimed"] = 1] = "ViewClaimed";
            ClaimedLeadNavigationOption[ClaimedLeadNavigationOption["NextLead"] = 2] = "NextLead";
            ClaimedLeadNavigationOption[ClaimedLeadNavigationOption["BackToList"] = 3] = "BackToList";
        })(ClaimedLeadNavigationOption = controllers.ClaimedLeadNavigationOption || (controllers.ClaimedLeadNavigationOption = {}));
        var ClaimedLeadModalController = /** @class */ (function (_super) {
            __extends(ClaimedLeadModalController, _super);
            function ClaimedLeadModalController($scope, $uibModalInstance, modalService, notificationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.modalService = modalService;
                _this.notificationService = notificationService;
                $scope.ClaimedLeadNavigationOption = ClaimedLeadNavigationOption;
                modalService.handleCloseActions($scope, $uibModalInstance);
                return _this;
            }
            ClaimedLeadModalController.showModal = function (modalScope) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var modalInstance = $uibModal.open({
                    controller: names.zbuyer.controllers.ClaimedLeadModalController,
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'claimed-lead-modal-parent-window',
                    scope: modalScope
                });
                return modalInstance.result.then(function (result) { return result; });
            };
            ClaimedLeadModalController.prototype.closeModal = function (navigation) {
                this.$uibModalInstance.close(navigation);
            };
            ClaimedLeadModalController.prototype.handleError = function (thrownError) {
                if (thrownError === void 0) { thrownError = null; }
                if (typeof thrownError == 'string') {
                    this.notificationService.error(thrownError);
                }
                else {
                    this.notificationService.error('An unexpected error has occurred.');
                    console.error(thrownError);
                }
            };
            ClaimedLeadModalController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.ModalService,
                names.zbuyer.services.NotificationService
            ];
            return ClaimedLeadModalController;
        }(controllers.ControllerBase));
        controllers.ClaimedLeadModalController = ClaimedLeadModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.ClaimedLeadModalController, ClaimedLeadModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/ComplianceAgreement.html';
        var ComplianceAgreementModalComponent = /** @class */ (function () {
            function ComplianceAgreementModalComponent($scope, complianceService, modalService, notificationService) {
                this.$scope = $scope;
                this.complianceService = complianceService;
                this.modalService = modalService;
                this.notificationService = notificationService;
            }
            ComplianceAgreementModalComponent.prototype.$onInit = function () {
                // NOTE: viewModel and $uibModalInstance are NOT injected/resolved in constructor, so waiting for $onInit is necessary
                this.modalService.handleCloseActions(this.$scope, this.$uibModalInstance);
                var viewModel = this.viewModel;
                this.complianceService.applyTrustedFormCertification(names.zbuyer.compliance.TcpaComplianceAgreement).finally(function () {
                    // Always allow user to submit once attempt to apply TCPA cert is completed
                    viewModel.loading = false;
                });
            };
            ComplianceAgreementModalComponent.prototype.agreeAndClose = function () {
                var _this = this;
                var termsHtml = $('.compliance-agreement-terms').html();
                if (!termsHtml) {
                    console.debug('Unable to set compliance: no terms HTML found');
                    return;
                }
                this.complianceService.setProspectingCompliance(termsHtml).then(function (result) {
                    _this.$uibModalInstance.close(true);
                }).catch(function (err) {
                    _this.cancel();
                    _this.notificationService.error(err, zbuyer.messages.ApplicationTitle);
                });
            };
            ComplianceAgreementModalComponent.prototype.cancel = function () {
                this.$uibModalInstance.close(false);
            };
            ComplianceAgreementModalComponent.loadModal = function (account) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var modalInstance = $uibModal.open({
                    backdropClass: 'compliance-agreement-backdrop',
                    component: names.zbuyer.components.ComplianceAgreement,
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        // NOTE: For components, awkwardly the only way to receive the resolves seems to be a literal public resolve property on the component,
                        // which will have these properties *nested* (late bound after constructor -- cannot be injected!)
                        memberAccount: account,
                        loading: true,
                    },
                    windowClass: 'compliance-agreement-modal'
                });
                return modalInstance.result;
            };
            ComplianceAgreementModalComponent.getComponentOptions = function () {
                return {
                    controller: ComplianceAgreementModalComponent,
                    controllerAs: 'modal',
                    bindings: {
                        $uibModalInstance: "<modalInstance",
                        // Note: Very specifically must be from "resolve", at least for Components backing a bs.modal opened with IModalOptions
                        // Note: this goes to a class-level property (not to scope)
                        viewModel: "<resolve"
                    },
                    templateUrl: TemplateUrl
                };
            };
            ComplianceAgreementModalComponent.$inject = [
                names.angular.Scope,
                names.zbuyer.services.ComplianceService,
                names.zbuyer.services.ModalService,
                names.zbuyer.services.NotificationService
            ];
            return ComplianceAgreementModalComponent;
        }());
        controllers.ComplianceAgreementModalComponent = ComplianceAgreementModalComponent;
        angular.module(names.zbuyer.Application)
            .component(names.zbuyer.components.ComplianceAgreement, ComplianceAgreementModalComponent.getComponentOptions());
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/ComplianceReminder.html';
        var ComplianceReminderModalComponent = /** @class */ (function () {
            function ComplianceReminderModalComponent($scope, modalService) {
                this.$scope = $scope;
                this.modalService = modalService;
            }
            ComplianceReminderModalComponent.prototype.$onInit = function () {
                this.modalService.handleCloseActions(this.$scope, this.$uibModalInstance);
            };
            ComplianceReminderModalComponent.getComponentOptions = function () {
                return {
                    controller: ComplianceReminderModalComponent,
                    bindings: {
                        $uibModalInstance: "<modalInstance",
                    },
                    templateUrl: TemplateUrl
                };
            };
            ComplianceReminderModalComponent.prototype.cancel = function () {
                this.$uibModalInstance.close(false);
            };
            ComplianceReminderModalComponent.prototype.close = function () {
                this.$uibModalInstance.close(true);
            };
            ComplianceReminderModalComponent.loadModal = function () {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var modalInstance = $uibModal.open({
                    backdropClass: 'compliance-reminder-backdrop',
                    size: 'sm',
                    component: names.zbuyer.components.ComplianceReminder,
                    windowClass: 'compliance-reminder-modal'
                });
                return modalInstance.result;
            };
            ComplianceReminderModalComponent.$inject = [
                names.angular.Scope,
                names.zbuyer.services.ModalService
            ];
            return ComplianceReminderModalComponent;
        }());
        controllers.ComplianceReminderModalComponent = ComplianceReminderModalComponent;
        angular.module(names.zbuyer.Application)
            .component(names.zbuyer.components.ComplianceReminder, ComplianceReminderModalComponent.getComponentOptions());
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var ConvertToNumberDirective = /** @class */ (function () {
            function ConvertToNumberDirective($scope) {
                this.$scope = $scope;
            }
            ConvertToNumberDirective.getDirective = function () {
                return {
                    link: function (scope, element, attrs, ngModel) {
                        ngModel.$parsers.push(function (val) {
                            return parseInt(val, 10);
                        });
                        ngModel.$formatters.push(function (val) {
                            return '' + val;
                        });
                    },
                    require: 'ngModel',
                    restrict: 'A'
                };
            };
            ConvertToNumberDirective.$inject = [
                names.angular.Scope
            ];
            return ConvertToNumberDirective;
        }());
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.ConvertToNumber, ConvertToNumberDirective.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/countystatisticsdirective.html';
        var CountyStatisticsDirectiveController = /** @class */ (function (_super) {
            __extends(CountyStatisticsDirectiveController, _super);
            function CountyStatisticsDirectiveController($scope, $q, $timeout, appConfiguration, countyStatisticsService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$q = $q;
                _this.$timeout = $timeout;
                _this.appConfiguration = appConfiguration;
                _this.countyStatisticsService = countyStatisticsService;
                $scope.viewModel = { cityLeads: null, countyLeadsCoordinates: null, countyStatistics: null };
                _this.currencyFormatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                });
                $scope.$watch('state', function (newValue, oldValue) {
                    _this.selectState(newValue);
                }, true);
                $scope.$watch('county', function (newValue, oldValue) {
                    _this.selectCounty(newValue);
                }, true);
                return _this;
            }
            CountyStatisticsDirectiveController.getDirective = function () {
                return {
                    controller: CountyStatisticsDirectiveController,
                    restrict: 'E',
                    scope: {
                        state: '=',
                        county: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            CountyStatisticsDirectiveController.prototype.selectCounty = function (county) {
                this.fillCountyStatistics(this.$scope.state, county);
            };
            CountyStatisticsDirectiveController.prototype.selectState = function (state) {
                this.fillCountyStatistics(state, this.$scope.county);
            };
            CountyStatisticsDirectiveController.prototype.fillCountyStatistics = function (state, county) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                this.$scope.state = state;
                this.$scope.county = county;
                // Clear statistics while loading to prevent stale display on error
                viewModel.countyStatistics = null;
                viewModel.countyLeadsCoordinates = null;
                viewModel.cityLeads = null;
                if (!this.$scope.state || !this.$scope.county) {
                    // County was un-selected, no statistics to fill
                    return;
                }
                var countyStatistics = this.countyStatisticsService.getCountyStatisticsForStateAndCounty(state, county);
                var countyMap = this.countyStatisticsService.getCountyLeadsCoordinatesForStateAndCounty(state, county);
                var cityLeads = this.countyStatisticsService.getCityLeadCountsForStateAndCounty(state, county);
                var results = this.$q.all([countyStatistics, countyMap, cityLeads]);
                results.then(function (result) {
                    // Verify results still match scope values for requested states and counties
                    if (_this.$scope.state && _this.$scope.county) {
                        if (_this.$scope.state === state && _this.$scope.county == county) {
                            viewModel.countyStatistics = result[0].countyStatistics;
                            viewModel.countyLeadsCoordinates = result[1].countyLeadsCoordinates;
                            viewModel.cityLeads = result[2].cityLeads;
                        }
                    }
                }).catch(function (_) {
                    // Do not display invalid data on error
                    return;
                });
            };
            CountyStatisticsDirectiveController.prototype.assignMapToDOMObject = function (id) {
                this.map = L.map(id);
                var isRetina = L.Browser.retina;
                var baseUrl = "".concat(this.appConfiguration.webServiceUrl, "/map-data/tile/{z}/{x}/{y}");
                var retinaUrl = "".concat(this.appConfiguration.webServiceUrl, "/map-data/tile-highres/{z}/{x}/{y}");
                L.tileLayer(isRetina ? retinaUrl : baseUrl, {
                    attribution: "Powered by <a href=\"https://www.geoapify.com/\" target=\"_blank\">Geoapify</a> | \u00A9 OpenStreetMap <a href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\">contributors</a>",
                    maxZoom: 13,
                }).addTo(this.map);
                var markerIcon = L.icon({
                    iconUrl: "".concat(this.appConfiguration.webServiceUrl, "/map-data/icon"),
                    iconSize: [10, 14],
                    iconAnchor: [5, 7]
                });
                var markerList = [];
                for (var _i = 0, _a = this.$scope.viewModel.countyLeadsCoordinates.coordinates; _i < _a.length; _i++) {
                    var markerLocation = _a[_i];
                    markerList.push(L.marker([markerLocation.lat, markerLocation.lon], {
                        icon: markerIcon
                    }).addTo(this.map));
                }
                this.group = L.featureGroup(markerList);
                var controller = this;
                this.resizeMap();
                this.$timeout(function () {
                    controller.resizeMap();
                }, 100);
                angular.element(id).on('resize', function () {
                    controller.resizeMap();
                });
            };
            CountyStatisticsDirectiveController.prototype.resizeMap = function () {
                this.map.invalidateSize();
                this.map.fitBounds(this.group.getBounds().pad(.1));
            };
            CountyStatisticsDirectiveController.prototype.shouldShowSellRateStatistics = function () {
                var countyStatistics = this.$scope.viewModel.countyStatistics;
                return countyStatistics && Boolean(countyStatistics.soldWithinIsNationwideAverage
                    || countyStatistics.soldWithin1YearText
                    || countyStatistics.soldWithin2YearsText
                    || countyStatistics.soldWithin3YearsText
                    || countyStatistics.soldWithin6MonthsText);
            };
            CountyStatisticsDirectiveController.prototype.formatCurrency = function (value) {
                return this.currencyFormatter.format(+value);
            };
            CountyStatisticsDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Q,
                names.angular.Timeout,
                names.zbuyer.AppConfiguration,
                names.zbuyer.services.CountyStatisticsService
            ];
            return CountyStatisticsDirectiveController;
        }(controllers.ControllerBase));
        controllers.CountyStatisticsDirectiveController = CountyStatisticsDirectiveController;
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.CountyStatistics, CountyStatisticsDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/countystatisticsmodal.html';
        var CountyStatisticsModalViewModel = /** @class */ (function () {
            function CountyStatisticsModalViewModel() {
            }
            return CountyStatisticsModalViewModel;
        }());
        var CountyStatisticsModalController = /** @class */ (function (_super) {
            __extends(CountyStatisticsModalController, _super);
            function CountyStatisticsModalController($scope, $uibModalInstance, appConfiguration, modalService, countyStatisticsModalViewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.appConfiguration = appConfiguration;
                _this.modalService = modalService;
                _this.countyStatisticsModalViewModel = countyStatisticsModalViewModel;
                $scope.viewModel = countyStatisticsModalViewModel;
                modalService.handleCloseActions($scope, $uibModalInstance);
                return _this;
            }
            CountyStatisticsModalController.loadModal = function (state, county) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var countyStatisticsModalViewModel = { state: state, county: county };
                return $uibModal.open({
                    controller: names.zbuyer.controllers.CountyStatisticsModalController,
                    resolve: {
                        countyStatisticsModalViewModel: countyStatisticsModalViewModel
                    },
                    size: 'lg',
                    templateUrl: TemplateUrl,
                    windowClass: 'county-statistics-modal'
                });
            };
            CountyStatisticsModalController.prototype.close = function () {
                this.$uibModalInstance.close();
            };
            CountyStatisticsModalController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.AppConfiguration,
                names.zbuyer.services.ModalService,
                'countyStatisticsModalViewModel'
            ];
            return CountyStatisticsModalController;
        }(controllers.ControllerBase));
        controllers.CountyStatisticsModalController = CountyStatisticsModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.CountyStatisticsModalController, CountyStatisticsModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/countystatisticspagedirective.html';
        var CountyStatisticsPageDirectiveController = /** @class */ (function (_super) {
            __extends(CountyStatisticsPageDirectiveController, _super);
            function CountyStatisticsPageDirectiveController($scope, $q, $window, $location, countiesService, countyPackagesService, spinWaitService, statesService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$q = $q;
                _this.$window = $window;
                _this.$location = $location;
                _this.countiesService = countiesService;
                _this.countyPackagesService = countyPackagesService;
                _this.spinWaitService = spinWaitService;
                _this.statesService = statesService;
                _this.$scope.viewModel = {
                    countyPackageDataCounties: [],
                    selectedCountyPackageData: null,
                    selectedState: null,
                    states: []
                };
                var viewModel = _this.$scope.viewModel;
                _this.$scope.losAngelesSubdivided = { county: 'Los Angeles (Subdivided)', state: 'CA' };
                _this.showOverlayDuring(function () {
                    return _this.statesService.getStates().then(function (result) {
                        viewModel.states = result;
                        var queryParameters = _this.$location.search();
                        if (typeof queryParameters.state === 'string' && typeof queryParameters.county === 'string') {
                            _this.selectCounty(queryParameters.county, queryParameters.state);
                        }
                    });
                });
                return _this;
            }
            CountyStatisticsPageDirectiveController.getDirective = function () {
                return {
                    controller: CountyStatisticsPageDirectiveController,
                    restrict: 'E',
                    scope: {},
                    templateUrl: TemplateUrl
                };
            };
            CountyStatisticsPageDirectiveController.prototype.countySelected = function (blockUI) {
                var _this = this;
                if (blockUI === void 0) { blockUI = true; }
                if (blockUI) {
                    return this.showOverlayDuring(function () { return _this.countySelected(false); });
                }
                return this.$q.resolve();
            };
            CountyStatisticsPageDirectiveController.prototype.fillCounties = function (stateAbbreviation) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.countyPackageDataCounties = null; // incoming...
                return this.countyPackagesService.getCountyPackageDataForState(stateAbbreviation).then(function (result) {
                    viewModel.countyPackageDataCounties = result;
                    if (stateAbbreviation === _this.$scope.losAngelesSubdivided.state) {
                        viewModel.countyPackageDataCounties.push(_this.$scope.losAngelesSubdivided);
                        viewModel.countyPackageDataCounties = viewModel.countyPackageDataCounties.sort(function (a, b) { return a.county < b.county ? -1 : a.county > b.county ? 1 : 0; });
                    }
                    // Auto-select single choice if only one.
                    if (viewModel.countyPackageDataCounties.length === 1) {
                        viewModel.selectedCountyPackageData = viewModel.countyPackageDataCounties[0];
                        return _this.countySelected(false);
                    }
                    return _this.$q.resolve();
                });
            };
            CountyStatisticsPageDirectiveController.prototype.getCountyPackageData = function (state, county) {
                var viewModel = this.$scope.viewModel;
                return viewModel.countyPackageDataCounties.filter(function (cpd) { return cpd.county === county && cpd.state === state; })[0];
            };
            CountyStatisticsPageDirectiveController.prototype.isLosAngelesCounty = function () {
                var viewModel = this.$scope.viewModel;
                return viewModel.selectedCountyPackageData && viewModel.selectedCountyPackageData.county === this.$scope.losAngelesSubdivided.county;
            };
            CountyStatisticsPageDirectiveController.prototype.resetDropdownSelection = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.selectedCountyPackageData = null;
                viewModel.selectedState = null;
                this.$window.scrollTo({ top: 0 });
            };
            CountyStatisticsPageDirectiveController.prototype.selectCounty = function (countyName, stateAbbreviation) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (stateAbbreviation) {
                    var selectedStateAbbrev = viewModel.selectedState && viewModel.selectedState.abbreviation;
                    if (selectedStateAbbrev != stateAbbreviation) {
                        // Need right state first. Bring blocking overlay back up after state load finished
                        return this.selectState(stateAbbreviation).then(function () { return _this.showOverlayDuring(function () { return _this.selectCounty(countyName); }); });
                    }
                }
                var search = viewModel.countyPackageDataCounties.filter(function (c) { return c.county == countyName; });
                if (search.length > 0) {
                    this.$scope.viewModel.selectedCountyPackageData = search[0];
                    return this.countySelected(false);
                }
                else {
                    return this.$q.reject();
                }
            };
            CountyStatisticsPageDirectiveController.prototype.selectState = function (abbreviation) {
                var viewModel = this.$scope.viewModel;
                if (viewModel.selectedState && viewModel.selectedState.abbreviation === abbreviation) {
                    return this.$q.resolve();
                }
                var search = viewModel.states.filter(function (s) { return s.abbreviation === abbreviation; });
                if (search.length > 0) {
                    viewModel.selectedState = search[0];
                    return this.stateSelected();
                }
                return this.$q.resolve();
            };
            CountyStatisticsPageDirectiveController.prototype.selectCountyByZip = function (zip) {
                var _this = this;
                return this.showOverlayDuring(function () {
                    return _this.countiesService.getCountyForZip(zip).then(function (county) {
                        if (county) {
                            _this.selectCounty(county.name, county.stateAbbreviation);
                        }
                    });
                });
            };
            CountyStatisticsPageDirectiveController.prototype.showOverlay = function (active, message) {
                if (active === void 0) { active = true; }
                if (message === void 0) { message = null; }
                var blockId = 'CountyStatisticsStateCountyLoading';
                if (active) {
                    this.spinWaitService.block(blockId, 'image logo', message || 'Loading...');
                }
                else {
                    this.spinWaitService.unblock(blockId);
                }
            };
            CountyStatisticsPageDirectiveController.prototype.showOverlayDuring = function (untilFunc, message) {
                var _this = this;
                if (message === void 0) { message = null; }
                try {
                    this.showOverlay(true, message);
                    return untilFunc().finally(function () { return _this.showOverlay(false); });
                }
                catch (error) {
                    this.showOverlay(false);
                    return this.$q.reject(error);
                }
            };
            CountyStatisticsPageDirectiveController.prototype.stateSelected = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                return this.showOverlayDuring(function () { return _this.fillCounties(viewModel.selectedState.abbreviation); });
            };
            CountyStatisticsPageDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Q,
                names.angular.Window,
                names.angular.Location,
                names.zbuyer.services.CountiesService,
                names.zbuyer.services.CountyPackagesService,
                names.zbuyer.services.SpinWaitService,
                names.zbuyer.services.StatesService
            ];
            return CountyStatisticsPageDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.CountyStatisticsPage, CountyStatisticsPageDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var DynamicFormController = /** @class */ (function (_super) {
            __extends(DynamicFormController, _super);
            function DynamicFormController($scope, $sce) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$scope.$watch(function (scope) { return scope.viewModel; }, function () {
                    // Ensure formController is accessible from model (in case of external submit action)
                    _this.$scope.viewModel.formController = _this.formController;
                });
                var viewModel = _this.$scope.viewModel;
                if (!viewModel.inputValues) {
                    viewModel.inputValues = {};
                }
                if (viewModel.showSubmitButton !== false) {
                    viewModel.showSubmitButton = true;
                }
                viewModel.inputFormItems.forEach(function (inputItem) {
                    var _a;
                    if (!inputItem.itemId) {
                        return;
                    }
                    if (inputItem.itemType == zbuyer.models.enums.InputFormItemType.CheckBox) {
                        var checked = ((_a = inputItem.defaultValue) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'true';
                        viewModel.inputValues[inputItem.itemId] = checked;
                    }
                    else {
                        viewModel.inputValues[inputItem.itemId] = inputItem.defaultValue;
                    }
                });
                return _this;
            }
            DynamicFormController.prototype.submit = function () {
                var _a, _b;
                this.formController.$submitted = true;
                if (this.formController.$invalid) {
                    return;
                }
                var promise = (_b = (_a = this.$scope.viewModel).submitCallback) === null || _b === void 0 ? void 0 : _b.call(_a, this.$scope.viewModel.inputValues);
                // Watch for callback completion if applicable, to prevent double-submit
                if (!promise) {
                    return null;
                }
                var promiseState = { pending: true };
                promise.finally(function () { return promiseState.pending = false; });
                return promiseState;
            };
            DynamicFormController.prototype.trustHtml = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            DynamicFormController.$inject = [
                names.angular.Scope,
                names.angular.Sce
            ];
            return DynamicFormController;
        }(controllers.ControllerBase));
        controllers.DynamicFormController = DynamicFormController;
        angular.module(names.zbuyer.Application).directive(names.zbuyer.directives.DynamicForm, function () { return ({
            controller: DynamicFormController,
            restrict: 'E',
            transclude: true,
            scope: {
                viewModel: '=',
            },
            templateUrl: 'staticpages/directives/dynamicformdirective.html'
        }); });
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/educationleadsdirective.html';
        var EducationLeadsDirectiveController = /** @class */ (function (_super) {
            __extends(EducationLeadsDirectiveController, _super);
            function EducationLeadsDirectiveController($scope, $window, appConfiguration) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$window = $window;
                _this.appConfiguration = appConfiguration;
                _this.initializeEducationLeadsDirectiveController();
                return _this;
            }
            EducationLeadsDirectiveController.getDirective = function () {
                return {
                    controller: EducationLeadsDirectiveController,
                    restrict: 'E',
                    scope: {
                        track: '=',
                        isModal: '@'
                    },
                    templateUrl: TemplateUrl
                };
            };
            EducationLeadsDirectiveController.prototype.initializeEducationLeadsDirectiveController = function () {
                this.$scope.viewModel = {};
                this.$scope.viewModel.track = this.$scope.track;
                if (typeof this.$scope.isModal == 'string') {
                    this.$scope.viewModel.isModal = true;
                }
                else {
                    this.$scope.viewModel.isModal = false;
                }
                this.$scope.appConfiguration = this.appConfiguration;
                if (this.$scope.viewModel.track) {
                    var self_1 = this;
                    $.getJSON("".concat(this.appConfiguration.baseUrl, "Content/education-leads-detail.json"), function (jsonData) {
                        self_1.educationLeadsDetail = jsonData;
                    });
                }
                this.setupBackgrounds();
            };
            EducationLeadsDirectiveController.prototype.goToTopic = function (topic) {
                this.$window.location.href = "education/".concat(topic);
            };
            EducationLeadsDirectiveController.prototype.openExampleImage = function (imageName, headerText) {
                var pathToImage = 'Content/Images/LeadExampleImages/' + imageName;
                var viewModel = {};
                viewModel.imagePathToEnlarge = pathToImage;
                viewModel.headerText = headerText;
                controllers.LeadExampleDetailModalController.loadModal(viewModel);
            };
            EducationLeadsDirectiveController.prototype.showDetail = function (detailId, topic) {
                this.fillDetail(detailId, topic);
                controllers.EducationModalController.showEducationModal(this.$scope.viewModel);
            };
            EducationLeadsDirectiveController.prototype.fillDetail = function (detailId, topic) {
                var viewModel = this.$scope.viewModel;
                viewModel.topic = topic;
                // Pull relevant HTML for track from the education-leads-detail (JSON data loaded in initialize)
                var trackDetails = viewModel.track == names.misc.SellersTrack ? this.educationLeadsDetail.sellers : this.educationLeadsDetail.buyers;
                viewModel.detail = trackDetails[detailId];
            };
            EducationLeadsDirectiveController.prototype.setupBackgrounds = function () {
                var options = { alignX: 0.5, alignY: 0.2, url: 'Content/Images/education-banner.jpg' };
                angular.element('.education-banner').backstretch([options]);
            };
            EducationLeadsDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Window,
                names.zbuyer.AppConfiguration
            ];
            return EducationLeadsDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.EducationLeads, EducationLeadsDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/educationmodal.html';
        var EducationModalController = /** @class */ (function (_super) {
            __extends(EducationModalController, _super);
            function EducationModalController($scope, $sce, $uibModalInstance, educationLeadsViewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$uibModalInstance = $uibModalInstance;
                _this.initializeEducationModal(educationLeadsViewModel);
                _this.$uibModalInstance.rendered.then(function () {
                    // Any initialization here
                });
                return _this;
            }
            EducationModalController.prototype.initializeEducationModal = function (educationLeadsViewModel) {
                this.$scope.viewModel = educationLeadsViewModel;
            };
            EducationModalController.prototype.closeModal = function () {
                this.$uibModalInstance.close(true);
            };
            EducationModalController.prototype.renderHtml = function () {
                return this.$sce.trustAsHtml(this.$scope.viewModel.detail);
            };
            EducationModalController.prototype.renderHtmlTopic = function () {
                return this.$sce.trustAsHtml(this.$scope.viewModel.topic);
            };
            EducationModalController.showEducationModal = function (educationLeadsViewModel) {
                var $injector = angular.element('html').injector();
                var $uibModel = $injector.get(names.angular.UiBootstrapModal);
                return $uibModel.open({
                    backdropClass: 'education-modal-backdrop',
                    controller: names.zbuyer.controllers.EducationModalController,
                    resolve: {
                        educationLeadsViewModel: educationLeadsViewModel
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'education-modal'
                });
            };
            EducationModalController.$inject = [
                names.angular.Scope,
                names.angular.Sce,
                names.angular.UiBootstrapModalInstance,
                'educationLeadsViewModel'
            ];
            return EducationModalController;
        }(controllers.ControllerBase));
        controllers.EducationModalController = EducationModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.EducationModalController, EducationModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var FilterMenuHeaderElement = '.filter-header';
        var FilterMenuSelectionsElement = '.selections';
        var FilterMenuWrapperElement = '.filter-menu-wrapper';
        var ModalDialogElement = '.modal-dialog';
        var ModalResizeWindowEvent = 'resize.filterModal';
        var OneHundredThousand = 100000;
        var OneMillion = 1000000;
        var OneThousand = 1000;
        var SearchButtonElement = '.search-button';
        var TemplateUrl = 'staticpages/modals/filtermodal.html';
        var TenThousand = 10000;
        var FilterModalController = /** @class */ (function (_super) {
            __extends(FilterModalController, _super);
            function FilterModalController($scope, $timeout, $uibModalInstance, $window, searchLeadsViewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$timeout = $timeout;
                _this.$uibModalInstance = $uibModalInstance;
                _this.$window = $window;
                _this.searchLeadsViewModel = searchLeadsViewModel;
                _this.priceRangeSelectorMax = 10000000;
                _this.priceRangeSelectorMin = 10000;
                _this.priceRangeSelectorSetup = {
                    max: _this.priceRangeSelectorMax,
                    min: _this.priceRangeSelectorMin,
                    options: {
                        ceil: _this.priceRangeSelectorMax,
                        floor: _this.priceRangeSelectorMin,
                        onChange: function () {
                            _this.syncPriceRangeSelector();
                        },
                        stepsArray: _this.setSelectorSteps(),
                        translate: function (value) {
                            return _this.numberToCurrencyShorthand(value);
                        }
                    }
                };
                _this.$scope.priceRangeSelector = _this.priceRangeSelectorSetup;
                _this.$scope.viewModel = searchLeadsViewModel;
                _this.$uibModalInstance.rendered.then(function () {
                    _this.initializePriceNumberRange();
                    _this.initializeModalResizing();
                });
                _this.$uibModalInstance.closed.then(function () {
                    angular.element(window).off(ModalResizeWindowEvent);
                });
                return _this;
            }
            FilterModalController.showFilterModal = function (searchLeadsViewModel) {
                var $injector = angular.element('html').injector();
                var $uibModel = $injector.get(names.angular.UiBootstrapModal);
                var modal = $uibModel.open({
                    backdropClass: 'filter-modal-backdrop',
                    controller: names.zbuyer.controllers.FilterModalController,
                    resolve: {
                        searchLeadsViewModel: searchLeadsViewModel
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'filter-modal'
                });
                return modal;
            };
            Object.defineProperty(FilterModalController.prototype, "allFoldersSelected", {
                get: function () {
                    return this.$scope.viewModel.folders.every(function (folderOption) { return folderOption.selected; });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(FilterModalController.prototype, "allReasonsSelected", {
                get: function () {
                    return this.$scope.viewModel.reasonsSelling.every(function (reasonOption) { return reasonOption.selected; });
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(FilterModalController.prototype, "allTagsSelected", {
                get: function () {
                    return this.$scope.viewModel.leadTags.every(function (tagOption) { return tagOption.selected; });
                },
                enumerable: false,
                configurable: true
            });
            FilterModalController.prototype.closeFilters = function (turnFiltersOn) {
                this.$uibModalInstance.close(turnFiltersOn);
            };
            FilterModalController.prototype.initializePriceNumberRange = function () {
                this.redrawPriceSelector();
                var viewModel = this.$scope.viewModel;
                // Fill default values
                var defaultMin = viewModel.appSettings.priceFilterDefaultBase;
                var defaultMax = viewModel.appSettings.priceFilterDefaultCap;
                var setMin = viewModel.priceRangeMin || defaultMin;
                var setMax = viewModel.priceRangeMax || defaultMax;
                this.setPriceSelectorRange(setMin, setMax);
            };
            FilterModalController.prototype.resetFilters = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.bathroomsMax = viewModel.appSettings.bathroomFilterDefaultCap;
                viewModel.bathroomsMin = viewModel.appSettings.bathroomFilterDefaultBase;
                viewModel.bedroomsMax = viewModel.appSettings.bedroomFilterDefaultCap;
                viewModel.bedroomsMin = viewModel.appSettings.bedroomFilterDefaultBase;
                viewModel.priceRangeMax = viewModel.appSettings.priceFilterDefaultCap;
                viewModel.priceRangeMin = viewModel.appSettings.priceFilterDefaultBase;
                this.resetSelectableItems(viewModel.leadTags);
                this.resetSelectableItems(viewModel.reasonsSelling);
                this.resetSelectableItems(viewModel.folders);
                viewModel.folders.filter(function (f) { return f.item.name == 'Unfiled'; }).forEach(function (item) { return item.selected = true; });
                viewModel.searchText = '';
                this.setPriceSelectorRange(viewModel.priceRangeMin, viewModel.priceRangeMax);
            };
            FilterModalController.prototype.search = function () {
                this.closeFilters(true);
            };
            FilterModalController.prototype.toggleFolder = function (folder) {
                folder.selected = !folder.selected;
            };
            FilterModalController.prototype.toggleFolders = function () {
                var viewModel = this.$scope.viewModel;
                var allSelected = this.allFoldersSelected;
                // Select all if any are unselected, otherwise UNselect all
                viewModel.folders.forEach(function (folderOption) { return folderOption.selected = !allSelected; });
            };
            FilterModalController.prototype.toggleReasons = function () {
                var viewModel = this.$scope.viewModel;
                var allSelected = this.allReasonsSelected;
                // Select all if any are unselected, otherwise UNselect all
                viewModel.reasonsSelling.forEach(function (reasonOption) { return reasonOption.selected = !allSelected; });
            };
            FilterModalController.prototype.toggleTags = function () {
                var viewModel = this.$scope.viewModel;
                var allSelected = this.allTagsSelected;
                // Select all if any are unselected, otherwise UNselect all
                viewModel.leadTags.forEach(function (tagOption) { return tagOption.selected = !allSelected; });
            };
            FilterModalController.prototype.getNearestNumberFromArray = function (find, inArray) {
                return inArray.reduce(function (previousValue, currentValue) {
                    return (Math.abs(currentValue - find) < Math.abs(previousValue - find) ? currentValue : previousValue);
                });
            };
            FilterModalController.prototype.initializeModalResizing = function () {
                var _this = this;
                this.$timeout(function () {
                    _this.resizeModalContents();
                });
                angular.element(window).on(ModalResizeWindowEvent, (function () {
                    _this.resizeModalContents();
                }));
            };
            /**
             * Formats a number value (e.g. 1000000 -> $1M, 50000 -> $50K)
             * @param value The number to format
             */
            FilterModalController.prototype.numberToCurrencyShorthand = function (value) {
                var base = value.toString();
                switch (true) {
                    case (value === this.priceRangeSelectorMin):
                        return 'No Min';
                    case (value < TenThousand):
                        base = base;
                        break;
                    case (value < OneMillion):
                        base = "".concat((value / OneThousand).toString(), "K");
                        break;
                    case (value === this.priceRangeSelectorMax):
                        return 'No Max';
                    default:
                        base = "".concat((value / OneMillion).toString(), "M");
                        break;
                }
                return "$".concat(base);
            };
            FilterModalController.prototype.redrawPriceSelector = function () {
                this.$scope.$broadcast('reCalcViewDimensions');
            };
            FilterModalController.prototype.resizeModalContents = function () {
                var windowHeight = angular.element(window).height();
                var modalMarginTop = +angular.element(ModalDialogElement).css('margin-top').slice(0, -2);
                var modalMarginBottom = +angular.element(ModalDialogElement).css('margin-bottom').slice(0, -2);
                var modalContentPadding = +angular.element(FilterMenuWrapperElement).css('padding-top').slice(0, -2);
                var buttonHeight = angular.element(SearchButtonElement).outerHeight();
                var bottomMargin = 20 + modalMarginTop + modalContentPadding + modalMarginBottom + buttonHeight;
                var newSize = windowHeight - angular.element(FilterMenuHeaderElement).height() - bottomMargin;
                angular.element(FilterMenuSelectionsElement).height(newSize);
            };
            FilterModalController.prototype.resetSelectableItems = function (items) {
                items.forEach(function (item) { return item.selected = false; });
            };
            FilterModalController.prototype.setPriceSelectorRange = function (min, max) {
                var selector = this.$scope.priceRangeSelector;
                selector.min = this.getNearestNumberFromArray(min, selector.options.stepsArray);
                selector.max = this.getNearestNumberFromArray(max, selector.options.stepsArray);
                this.redrawPriceSelector();
            };
            FilterModalController.prototype.setSelectorSteps = function () {
                var steps = [this.priceRangeSelectorMin];
                var number = this.priceRangeSelectorMin;
                // This loop increments differently based on the size of the number
                // Numbers less than one million increment 10k
                // Numbers more than one million increment 100k
                while (number < this.priceRangeSelectorMax) {
                    if (number >= OneMillion) {
                        number += OneHundredThousand;
                    }
                    else {
                        number += TenThousand;
                    }
                    steps.push(number);
                }
                return steps;
            };
            FilterModalController.prototype.syncPriceRangeSelector = function () {
                var selector = this.$scope.priceRangeSelector;
                var viewModel = this.$scope.viewModel;
                viewModel.priceRangeMin = selector.min;
                viewModel.priceRangeMax = selector.max;
            };
            FilterModalController.$inject = [
                names.angular.Scope,
                names.angular.Timeout,
                names.angular.UiBootstrapModalInstance,
                names.angular.Window,
                'searchLeadsViewModel'
            ];
            return FilterModalController;
        }(controllers.ControllerBase));
        controllers.FilterModalController = FilterModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.FilterModalController, FilterModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var ForgotPasswordController = /** @class */ (function (_super) {
            __extends(ForgotPasswordController, _super);
            function ForgotPasswordController($q, $scope, accountService, generalApiService, notificationService, spinWaitService, vcRecaptchaService) {
                var _this = _super.call(this, $scope) || this;
                _this.$q = $q;
                _this.$scope = $scope;
                _this.accountService = accountService;
                _this.generalApiService = generalApiService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.vcRecaptchaService = vcRecaptchaService;
                _this.initialize();
                return _this;
            }
            ForgotPasswordController.prototype.initialize = function () {
                this.$scope.viewModel = {};
                this.$scope.viewModel.forgotPasswordEmail = '';
            };
            ForgotPasswordController.prototype.validateRecaptchaAndSend = function () {
                var _this = this;
                var deferred = this.$q.defer();
                var recaptchaKey = this.$scope.viewModel.recaptchaResponse;
                if (typeof recaptchaKey === 'undefined' || recaptchaKey == '') {
                    this.notificationService.error(zbuyer.messages.RecaptchaIsBlank, zbuyer.messages.RecaptchaError);
                    return deferred.promise;
                }
                var validating = this.generalApiService.validateRecaptcha(recaptchaKey).then(function (response) {
                    if (response.success) {
                        _this.spinWaitService.unblock('validate-recaptcha');
                        _this.sendForgotPasswordEmail();
                    }
                    else {
                        _this.notificationService.error(zbuyer.messages.RecaptchaRejected, zbuyer.messages.RecaptchaError);
                        deferred.reject(zbuyer.messages.RecaptchaError);
                    }
                }).catch(function () {
                    _this.notificationService.error(zbuyer.messages.ApiCommunicationError, zbuyer.messages.ApplicationTitle);
                    deferred.reject(zbuyer.messages.ApiCommunicationError);
                });
                this.spinWaitService.blockDuring(validating, 'validate-recaptcha');
                return deferred.promise;
            };
            ForgotPasswordController.prototype.sendForgotPasswordEmail = function () {
                var _this = this;
                var sendForgotPasswordEmailRequest = {
                    email: this.$scope.viewModel.forgotPasswordEmail
                };
                var sendingForgotPasswordEmail = this.accountService.sendForgotPasswordEmail(sendForgotPasswordEmailRequest).then(function (success) {
                    if (success) {
                        _this.notificationService.success(zbuyer.messages.ForgotPasswordSuccess, 'Check Your Email');
                        _this.$scope.viewModel.forgotPasswordEmail = "";
                    }
                    else {
                        _this.notificationService.error(zbuyer.messages.ForgotPasswordFailed, 'Error');
                    }
                    return success;
                }).finally(function () {
                    _this.vcRecaptchaService.reload();
                });
                this.spinWaitService.blockDuring(sendingForgotPasswordEmail, 'reset-password');
                return sendingForgotPasswordEmail;
            };
            ForgotPasswordController.$inject = [
                names.angular.Q,
                names.angular.Scope,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.GeneralApiService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService,
                names.zbuyer.services.VcRecaptchaService
            ];
            return ForgotPasswordController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.ForgotPasswordController, ForgotPasswordController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var LocationSearchViewModel = /** @class */ (function () {
            function LocationSearchViewModel(location, asCityInCounty) {
                if (asCityInCounty === void 0) { asCityInCounty = false; }
                this.location = location;
                this.asCityInCounty = asCityInCounty;
                if (!this.location.zip && !this.location.city) {
                    this.text = "".concat(this.location.county, " County, ").concat(this.location.state);
                }
                else if (this.asCityInCounty) {
                    this.text = "".concat(this.location.city, ", ").concat(this.location.state);
                }
                else {
                    var cityLabel = "".concat(this.location.city, ", ").concat(this.location.state, " (").concat(this.location.county, ")");
                    this.text = this.location.zip ? "".concat(this.location.zip, " - ").concat(cityLabel) : cityLabel;
                }
            }
            return LocationSearchViewModel;
        }());
        var PreviewFilterMenuWrapperElement = '.preview-filter-menu-wrapper';
        var FilterMenuHeaderElement = '.filter-header';
        var FilterMenuSelectionsElement = '.selections';
        var ModalDialogElement = '.modal-dialog';
        var ModalResizeWindowEvent = 'resize.filterModal';
        var OneHundredThousand = 100000;
        var OneMillion = 1000000;
        var OneThousand = 1000;
        var SearchButtonElement = '.search-button';
        var TemplateUrl = 'StaticPages/Modals/PreviewFilterModal.html';
        var TenThousand = 10000;
        var IsNumericText = function (n) { return !isNaN(+n); };
        var PreviewFilterModalController = /** @class */ (function (_super) {
            __extends(PreviewFilterModalController, _super);
            function PreviewFilterModalController($scope, $q, $timeout, $uibModalInstance, leadPreviewService, notificationService, leadPreviewsViewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$q = $q;
                _this.$timeout = $timeout;
                _this.$uibModalInstance = $uibModalInstance;
                _this.leadPreviewService = leadPreviewService;
                _this.notificationService = notificationService;
                _this.leadPreviewsViewModel = leadPreviewsViewModel;
                _this.priceRangeSelectorMax = 10000000;
                _this.priceRangeSelectorMin = 10000;
                _this.priceRangeSelectorSetup = {
                    max: _this.priceRangeSelectorMax,
                    min: _this.priceRangeSelectorMin,
                    options: {
                        ceil: _this.priceRangeSelectorMax,
                        floor: _this.priceRangeSelectorMin,
                        onChange: function () {
                            _this.syncPriceRangeSelector();
                        },
                        stepsArray: _this.setSelectorSteps(),
                        translate: function (value) {
                            return _this.numberToCurrencyShorthand(value);
                        }
                    }
                };
                _this.$scope.priceRangeSelector = _this.priceRangeSelectorSetup;
                _this.$scope.viewModel = leadPreviewsViewModel;
                _this.$uibModalInstance.rendered.then(function () {
                    _this.initializeLocations();
                    _this.initializePriceNumberRange();
                });
                _this.$uibModalInstance.closed.then(function () {
                    angular.element(window).off(ModalResizeWindowEvent);
                });
                return _this;
            }
            PreviewFilterModalController.showPreviewFilterModal = function (leadPreviewsViewModel) {
                var $injector = angular.element('html').injector();
                var $uibModel = $injector.get(names.angular.UiBootstrapModal);
                var modal = $uibModel.open({
                    backdropClass: 'preview-filter-modal-backdrop',
                    controller: names.zbuyer.controllers.PreviewFilterModalController,
                    resolve: {
                        leadPreviewsViewModel: leadPreviewsViewModel
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'preview-filter-modal'
                });
                return modal;
            };
            PreviewFilterModalController.prototype.initializeLocations = function () {
                // Prep location lists at various levels for easy use in auto-complete lists and as final leads-search parameters.
                var _this = this;
                // Used in two of the three lists
                var countyModels;
                // Will be re-used for 2 different variations of model
                var cityLocations;
                var hasErrors = false;
                var gotZipModels = this.leadPreviewService.getSubscribedLocations('zip')
                    .then(function (locations) { return _this.$scope.zipLocations = locations
                    .sort(function (a, b) { return a.zip.localeCompare(b.zip); })
                    .map(function (zipLoc) { return new LocationSearchViewModel(zipLoc); }); })
                    .catch(function (err) {
                    hasErrors = true;
                    _this.$scope.zipLocations = [];
                    _this.handleError(err);
                });
                var gotRawCityLocations = this.leadPreviewService.getSubscribedLocations('city')
                    .then(function (locations) {
                    cityLocations = locations
                        .sort(function (a, b) {
                        var countyCompare = a.county.localeCompare(b.county);
                        return (countyCompare ? countyCompare : a.city.localeCompare(b.city));
                    });
                })
                    .catch(function (err) {
                    hasErrors = true;
                    cityLocations = [];
                    _this.handleError(err);
                });
                var gotCountyModels = this.leadPreviewService.getSubscribedLocations('county')
                    .then(function (locations) { return countyModels = locations
                    .sort(function (a, b) { return a.county.localeCompare(b.county); })
                    .map(function (loc) { return new LocationSearchViewModel(loc); }); })
                    .catch(function (err) {
                    hasErrors = true;
                    countyModels = [];
                    _this.handleError(err);
                });
                // Notify of any failures collectively (we'll still use what we can for dropdowns)
                this.$q.all([gotCountyModels, gotRawCityLocations, gotZipModels])
                    .finally(function () {
                    if (hasErrors) {
                        _this.handleError('Location search may not work properly due to errors retrieving your subscribed locations.');
                    }
                    // Massage results into pre-sorted auto-suggest lists:
                    // 1. Zip-based autosuggest (already set above, nothing to massage from there)
                    // 2. Combine cities and counties in alpha order for and 3+char autosuggestion list
                    _this.$scope.mixedLocations = __spreadArray(__spreadArray([], cityLocations.map(function (loc) { return new LocationSearchViewModel(loc); }), true), countyModels, true).sort(function (a, b) { return a.text.localeCompare(b.text); });
                    // 3. State-based autosuggest with counties followed by their cities.
                    var stateLocationModels = [];
                    countyModels.forEach(function (countyModel) {
                        var cityModelsUnderCounty = cityLocations
                            .filter(function (cityLoc) { return cityLoc.county === countyModel.location.county && cityLoc.state === countyModel.location.state; })
                            .map(function (cityLoc) { return new LocationSearchViewModel(cityLoc, true); });
                        stateLocationModels.push(countyModel);
                        stateLocationModels.push.apply(stateLocationModels, cityModelsUnderCounty);
                    });
                    _this.$scope.stateLocations = stateLocationModels;
                    // Restore the selected location based on the view model properties
                    var selectedLocation = _this.$scope.mixedLocations.find(function (loc) {
                        return loc.location.city === _this.$scope.viewModel.locationCity &&
                            loc.location.state === _this.$scope.viewModel.locationState &&
                            loc.location.zip === _this.$scope.viewModel.locationZip &&
                            loc.location.county === _this.$scope.viewModel.locationCounty;
                    });
                    if (selectedLocation) {
                        _this.$scope.selectedLocation = selectedLocation;
                        _this.$scope.locationSearchText = selectedLocation.text;
                    }
                });
            };
            PreviewFilterModalController.prototype.closeFilters = function (turnFiltersOn) {
                this.$uibModalInstance.close(this.$scope.viewModel);
            };
            PreviewFilterModalController.prototype.initializePriceNumberRange = function () {
                this.redrawPriceSelector();
                var viewModel = this.$scope.viewModel;
                var setMin = viewModel.priceRangeMin || this.priceRangeSelectorMin;
                var setMax = viewModel.priceRangeMax || this.priceRangeSelectorMax;
                var setMin = viewModel.priceRangeMin;
                var setMax = viewModel.priceRangeMax;
                this.setPriceSelectorRange(setMin, setMax);
            };
            PreviewFilterModalController.prototype.resetFilters = function () {
                var viewModel = this.$scope.viewModel;
                var settings = this.leadPreviewsViewModel.appSettings;
                viewModel.bathroomsMax = settings.bathroomFilterDefaultCap;
                viewModel.bathroomsMin = settings.bathroomFilterDefaultBase;
                viewModel.bedroomsMax = settings.bedroomFilterDefaultCap;
                viewModel.bedroomsMin = settings.bedroomFilterDefaultBase;
                viewModel.priceRangeMax = settings.priceFilterDefaultCap;
                viewModel.priceRangeMin = settings.priceFilterDefaultBase;
                viewModel.includeUnknownBathrooms = true;
                viewModel.includeUnknownBedrooms = true;
                viewModel.includeUnknownPrice = true;
                viewModel.locationState = null;
                viewModel.locationCounty = null;
                viewModel.locationCity = null;
                viewModel.locationZip = null;
                viewModel.searchText = null;
                viewModel.includeBuyers = true;
                viewModel.includeSellers = true;
                viewModel.leadType = 'Buyer & Seller';
                this.$scope.locationSearchText = "";
                this.setPriceSelectorRange(viewModel.priceRangeMin, viewModel.priceRangeMax);
            };
            PreviewFilterModalController.prototype.search = function () {
                this.closeFilters(true);
            };
            PreviewFilterModalController.prototype.searchLocations = function (searchText) {
                if (!searchText || !searchText.length) {
                    return this.$scope.mixedLocations;
                }
                // Number search => search zips
                if (IsNumericText(searchText)) {
                    return this.$scope.zipLocations
                        .filter(function (zipLocation) { return zipLocation.location.zip.startsWith(searchText); });
                }
                // 2 letters: Match by STATE: Show each county with its cities under it
                if (searchText.length == 2) {
                    var stateQuery = searchText.toUpperCase();
                    var stateResults = this.$scope.stateLocations.filter(function (stateLoc) { return stateLoc.location.state == stateQuery; });
                    if (stateResults.length) {
                        return stateResults;
                    }
                }
                // Default general search matching city or county
                searchText = searchText.toLowerCase();
                var mixedMatches = this.$scope.mixedLocations.filter(function (loc) {
                    var _a;
                    var name = ((_a = loc.location.city) !== null && _a !== void 0 ? _a : loc.location.county).toLowerCase();
                    return name.includes(searchText);
                });
                // Show "starting" matches first (vs "containing" matches), and alpha-sort from there
                return mixedMatches.sort(function (a, b) {
                    var aStarts = a.text.toLowerCase().startsWith(searchText);
                    if (aStarts != b.text.toLowerCase().startsWith(searchText)) {
                        return aStarts ? -1 : 1;
                    }
                    return a.text.localeCompare(b.text);
                });
            };
            PreviewFilterModalController.prototype.onSelectedLocationChange = function (selectedLocation) {
                var _a, _b, _c, _d;
                this.$scope.viewModel.locationCity = (_a = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.location) === null || _a === void 0 ? void 0 : _a.city;
                this.$scope.viewModel.locationState = (_b = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.location) === null || _b === void 0 ? void 0 : _b.state;
                this.$scope.viewModel.locationZip = (_c = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.location) === null || _c === void 0 ? void 0 : _c.zip;
                this.$scope.viewModel.locationCounty = (_d = selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.location) === null || _d === void 0 ? void 0 : _d.county;
            };
            PreviewFilterModalController.prototype.getNearestNumberFromArray = function (find, inArray) {
                return inArray.reduce(function (previousValue, currentValue) {
                    return (Math.abs(currentValue - find) < Math.abs(previousValue - find) ? currentValue : previousValue);
                });
            };
            PreviewFilterModalController.prototype.handleError = function (thrownError) {
                if (thrownError === void 0) { thrownError = null; }
                if (typeof thrownError == 'string') {
                    this.notificationService.error(thrownError);
                }
                else {
                    this.notificationService.error('An unexpected error has occurred.');
                    console.error(thrownError);
                }
            };
            /**
             * Formats a number value (e.g. 1000000 -> $1M, 50000 -> $50K)
             * @param value The number to format
             */
            PreviewFilterModalController.prototype.numberToCurrencyShorthand = function (value) {
                var base = value.toString();
                switch (true) {
                    case (value === this.priceRangeSelectorMin):
                        return 'No Min';
                    case (value < TenThousand):
                        base = base;
                        break;
                    case (value < OneMillion):
                        base = "".concat((value / OneThousand).toString(), "K");
                        break;
                    case (value === this.priceRangeSelectorMax):
                        return 'No Max';
                    default:
                        base = "".concat((value / OneMillion).toString(), "M");
                        break;
                }
                return "$".concat(base);
            };
            PreviewFilterModalController.prototype.redrawPriceSelector = function () {
                this.$scope.$broadcast('reCalcViewDimensions');
            };
            PreviewFilterModalController.prototype.setPriceSelectorRange = function (min, max) {
                var selector = this.$scope.priceRangeSelector;
                selector.min = this.getNearestNumberFromArray(min, selector.options.stepsArray);
                selector.max = this.getNearestNumberFromArray(max, selector.options.stepsArray);
                this.redrawPriceSelector();
            };
            PreviewFilterModalController.prototype.setSelectorSteps = function () {
                var steps = [this.priceRangeSelectorMin];
                var number = this.priceRangeSelectorMin;
                // This loop increments differently based on the size of the number
                // Numbers less than one million increment 10k
                // Numbers more than one million increment 100k
                while (number < this.priceRangeSelectorMax) {
                    if (number >= OneMillion) {
                        number += OneHundredThousand;
                    }
                    else {
                        number += TenThousand;
                    }
                    steps.push(number);
                }
                return steps;
            };
            PreviewFilterModalController.prototype.syncPriceRangeSelector = function () {
                var selector = this.$scope.priceRangeSelector;
                var viewModel = this.$scope.viewModel;
                viewModel.priceRangeMin = selector.min;
                viewModel.priceRangeMax = selector.max;
            };
            PreviewFilterModalController.$inject = [
                names.angular.Scope,
                names.angular.Q,
                names.angular.Timeout,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.LeadPreviewService,
                names.zbuyer.services.NotificationService,
                'leadPreviewsViewModel'
            ];
            return PreviewFilterModalController;
        }(controllers.ControllerBase));
        controllers.PreviewFilterModalController = PreviewFilterModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.PreviewFilterModalController, PreviewFilterModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/greetingdirective.html';
        var GreetingDirectiveController = /** @class */ (function (_super) {
            __extends(GreetingDirectiveController, _super);
            function GreetingDirectiveController($scope, appConfiguration) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.appConfiguration = appConfiguration;
                _this.initializeGreetingDirective();
                return _this;
            }
            GreetingDirectiveController.getDirective = function () {
                return {
                    controller: GreetingDirectiveController,
                    restrict: 'E',
                    scope: {
                        signup: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            GreetingDirectiveController.prototype.initializeGreetingDirective = function () {
                this.setGreeting();
            };
            GreetingDirectiveController.prototype.setGreeting = function () {
                var background = 'Login';
                var greeting = 'Good ';
                var morning = 'Morning';
                var afternoon = 'Afternoon';
                var evening = 'Evening';
                var hours = (new Date()).getHours();
                switch (true) {
                    case (hours < 12):
                        background += morning;
                        greeting += morning;
                        break;
                    case (hours < 17):
                        background += afternoon;
                        greeting += afternoon;
                        break;
                    case (hours < 20):
                        background += 'Early' + evening;
                        greeting += evening;
                        break;
                    default:
                        background += 'Late' + evening;
                        greeting += evening;
                        break;
                }
                angular.element('.greeting-holder').backstretch([this.appConfiguration.baseUrl + 'Content/Images/' + background + '.jpg']);
                this.$scope.greeting = this.$scope.signup ? 'Create an account' : greeting;
            };
            GreetingDirectiveController.$inject = [
                names.angular.Scope,
                names.zbuyer.AppConfiguration
            ];
            return GreetingDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.Greeting, GreetingDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/hamburgermenudirective.html';
        var HamburgerMenuDirectiveController = /** @class */ (function (_super) {
            __extends(HamburgerMenuDirectiveController, _super);
            function HamburgerMenuDirectiveController($scope, $window, authenticationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$window = $window;
                _this.authenticationService = authenticationService;
                _this.initializeViewModel();
                return _this;
            }
            HamburgerMenuDirectiveController.getDirective = function () {
                return {
                    controller: HamburgerMenuDirectiveController,
                    restrict: 'E',
                    scope: {
                        canProspect: '=',
                        canPreview: '=',
                        showMoreMenuCallback: '&onShowMore',
                    },
                    templateUrl: TemplateUrl
                };
            };
            HamburgerMenuDirectiveController.prototype.checkLogin = function () {
                var authHeader = this.authenticationService.getAuthenticationHeader();
                if (authHeader !== '') {
                    this.$scope.viewModel.loggedIntoAccount = true;
                    this.$scope.viewModel.loginButtonText = 'Log Out';
                }
                else {
                    this.$scope.viewModel.loggedIntoAccount = false;
                    this.$scope.viewModel.loginButtonText = 'Log In';
                }
            };
            HamburgerMenuDirectiveController.prototype.initializeViewModel = function () {
                this.$scope.viewModel = {};
                this.checkLogin();
            };
            HamburgerMenuDirectiveController.prototype.logOut = function () {
                this.authenticationService.logout();
            };
            HamburgerMenuDirectiveController.prototype.logIn = function () {
                this.$window.location.href = 'account/login';
            };
            HamburgerMenuDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Window,
                names.zbuyer.services.AuthenticationService
            ];
            return HamburgerMenuDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.HamburgerMenu, HamburgerMenuDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var LandingController = /** @class */ (function (_super) {
            __extends(LandingController, _super);
            function LandingController($scope, $sce, $location, $timeout, $window, appConfiguration, accountService, messageService, authenticationService, complianceService, notificationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$location = $location;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.appConfiguration = appConfiguration;
                _this.accountService = accountService;
                _this.messageService = messageService;
                _this.authenticationService = authenticationService;
                _this.complianceService = complianceService;
                _this.notificationService = notificationService;
                _this.DelayForRedirectOnFail = 3000;
                _this.initialize();
                return _this;
            }
            LandingController.prototype.initialize = function () {
                var _this = this;
                var returnUrlParameter = this.$location.search()[names.zbuyer.queryparameters.ReturnUrl];
                this.redirectUrl = new URL('/', this.appConfiguration.baseUrl);
                if (returnUrlParameter) {
                    this.redirectUrl.pathname = returnUrlParameter;
                }
                var viewModel = {};
                this.$scope.viewModel = viewModel;
                // Ensure authorization before getting started (otherwise back to login)
                this.authenticationService.getInitialAuthPromise().then(function (isAuthenticated) {
                    if (!isAuthenticated) {
                        // Not even logged in! Just directly send back to login (carrying over returnURL if we have one)
                        _this.redirectUrl.pathname = 'account/login';
                        if (returnUrlParameter) {
                            _this.redirectUrl.searchParams.set(names.zbuyer.queryparameters.ReturnUrl, returnUrlParameter);
                        }
                        _this.redirect();
                        return;
                    }
                    return _this.accountService.getAccountProfile().then(function (response) {
                        viewModel.account = response.account;
                        if (!returnUrlParameter) {
                            // No particular redirect path unless user has not set up a subscription yet
                            if (!viewModel.account.subscription) {
                                _this.redirectUrl.pathname = 'account/subscription';
                            }
                        }
                        _this.checkNextAccountMessage();
                    }).catch(function (reason) {
                        _this.notificationService.error(zbuyer.messages.AccountInfoError);
                        // Couldn't do anything with account info - move on after error presented (and don't bother checking for messages)
                        _this.$timeout(function () { return _this.redirect(); }, _this.DelayForRedirectOnFail);
                    });
                });
            };
            LandingController.prototype.submitResponse = function (actionButtonText) {
                var _this = this;
                var formViewModel = this.$scope.viewModel.formViewModel;
                formViewModel.formController.$submitted = true;
                if (formViewModel.formController.$invalid) {
                    return;
                }
                this.messageService.recordAction(this.$scope.viewModel.accountMessage.accountMessageId, actionButtonText, formViewModel.inputValues).then(function (response) {
                    if (!response.success) {
                        console.debug(response.internalDebugInfo);
                        _this.notificationService.error(response.errorMessageToDisplay);
                    }
                }).catch(function (err) {
                    console.error(err);
                    _this.notificationService.error('Unknown error with response');
                }).finally(function () {
                    _this.checkNextAccountMessage();
                });
            };
            LandingController.prototype.checkNextAccountMessage = function () {
                var _this = this;
                var _a;
                var viewModel = this.$scope.viewModel;
                var lastAccountMessageId = (_a = viewModel.accountMessage) === null || _a === void 0 ? void 0 : _a.accountMessageId;
                viewModel.accountMessage = null;
                viewModel.formViewModel = null;
                viewModel.awaitingFormCertification = true;
                return this.messageService.get(this.$location.absUrl()).then(function (response) {
                    console.debug('Got account message', response);
                    if (!(response === null || response === void 0 ? void 0 : response.success)) {
                        console.debug(response.internalDebugInfo);
                        _this.notificationService.error(response.errorMessageToDisplay);
                        console.debug('Delay and redirect after GET account-message not successful');
                        return _this.$timeout(_this.DelayForRedirectOnFail).then(function () { return false; });
                    }
                    if (!response.haveAccountMessage) {
                        // Normal "done" state -- will redirect
                        return false;
                    }
                    if (lastAccountMessageId) {
                        // If message ID has been seen before then the last user action must have failed
                        // (or in any case the message cycle is not advancing)
                        if (response.accountMessageId == lastAccountMessageId) {
                            _this.notificationService.error('Unable to advance to next account message');
                            console.debug('Delay and redirect after account-message failing to advance');
                            return _this.$timeout(_this.DelayForRedirectOnFail).then(function () { return false; });
                        }
                    }
                    // Content for dynamic-form element
                    viewModel.formViewModel = {
                        title: response.messageTitle,
                        inputFormItems: response.inputFormItems,
                        showSubmitButton: false
                    };
                    viewModel.awaitingFormCertification = true;
                    viewModel.accountMessage = response;
                    _this.complianceService.applyTrustedFormCertification(names.zbuyer.compliance.AccountMessage, viewModel.accountMessage.accountMessageId).finally(function () {
                        viewModel.awaitingFormCertification = false;
                    });
                    return true;
                }).catch(function (err) {
                    console.error(err);
                    _this.notificationService.error('Unable to process account messages');
                    return _this.$timeout(_this.DelayForRedirectOnFail).then(function () { return false; });
                }).then(function (haveNewMessage) {
                    if (!haveNewMessage) {
                        _this.redirect();
                    }
                    return haveNewMessage;
                });
            };
            LandingController.prototype.logOut = function () {
                this.authenticationService.logout();
            };
            LandingController.prototype.redirect = function () {
                this.$window.location.href = this.redirectUrl.href;
            };
            LandingController.prototype.trustHtml = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            LandingController.$inject = [
                names.angular.Scope,
                names.angular.Sce,
                names.angular.Location,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.AppConfiguration,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.AccountMessageService,
                names.zbuyer.services.AuthenticationService,
                names.zbuyer.services.ComplianceService,
                names.zbuyer.services.NotificationService
            ];
            return LandingController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.LandingController, LandingController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/leadexampledetailmodal.html';
        var LeadExampleDetailModalController = /** @class */ (function (_super) {
            __extends(LeadExampleDetailModalController, _super);
            function LeadExampleDetailModalController($scope, $uibModalInstance, modalService, leadExampleDetailViewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.modalService = modalService;
                _this.leadExampleDetailViewModel = leadExampleDetailViewModel;
                $scope.viewModel = leadExampleDetailViewModel;
                _this.$uibModalInstance.rendered.then(function () {
                    // Any initialization here
                });
                modalService.handleCloseActions($scope, $uibModalInstance);
                return _this;
            }
            LeadExampleDetailModalController.loadModal = function (leadExampleDetailViewModel) {
                var $injector = angular.element('html').injector();
                var $uibModel = $injector.get(names.angular.UiBootstrapModal);
                var modal = $uibModel.open({
                    controller: names.zbuyer.controllers.LeadExampleDetailModalController,
                    resolve: {
                        leadExampleDetailViewModel: leadExampleDetailViewModel
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'lead-example-modal'
                });
                return modal;
            };
            LeadExampleDetailModalController.prototype.back = function () {
                this.$uibModalInstance.close();
            };
            LeadExampleDetailModalController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.ModalService,
                'leadExampleDetailViewModel'
            ];
            return LeadExampleDetailModalController;
        }(controllers.ControllerBase));
        controllers.LeadExampleDetailModalController = LeadExampleDetailModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.LeadExampleDetailModalController, LeadExampleDetailModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/leaddetaildirective.html';
        var LeadDetailDirectiveController = /** @class */ (function (_super) {
            __extends(LeadDetailDirectiveController, _super);
            function LeadDetailDirectiveController($scope, $sce, $compile, $location, $q, $timeout, appConfiguration, authenticationService, leadPhoneNumberService, leadsService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$compile = $compile;
                _this.$location = $location;
                _this.$q = $q;
                _this.$timeout = $timeout;
                _this.appConfiguration = appConfiguration;
                _this.authenticationService = authenticationService;
                _this.leadPhoneNumberService = leadPhoneNumberService;
                _this.leadsService = leadsService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.notesUpdatingTimeout = null;
                _this.notesUpdatingWaitTime = 750;
                _this.phoneUnavailable = 'Unavailable';
                _this.initializeLeadDetailDirectiveController();
                return _this;
            }
            LeadDetailDirectiveController.prototype.initializeLeadDetailDirectiveController = function () {
                if (!this.$scope.viewModel) {
                    this.$scope.viewModel = {};
                }
                if (this.$scope.viewModel.id) {
                    this.fillLeadDetail(this.$scope.viewModel);
                }
                if (!this.$scope.printable) {
                    this.initializeWatches();
                }
            };
            LeadDetailDirectiveController.getDirective = function () {
                return {
                    controller: LeadDetailDirectiveController,
                    restrict: 'E',
                    scope: {
                        closeLeadCallback: '&onCloseLead',
                        loading: '=',
                        openMoreMenuCallback: '&onOpenMoreMenu',
                        prospectingComplianceCallback: '&onOpenProspectingCompliance',
                        printable: '=',
                        viewModel: '=',
                        googleApiKey: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            LeadDetailDirectiveController.prototype.checkProspectingUnlockFlag = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (viewModel.isProspecting && viewModel.contactInfo.isProspectingCompliant == false) {
                    // For link-triggered unlock of prospecting phones from mobile apps
                    if (viewModel.phoneStatus == 'Hide') {
                        // NOTE: Glitchy workaround of us not actually sending enum value for PhoneStatus
                        var unlockPhonesFlag = this.$location.search()[names.zbuyer.queryparameters.UnlockPhones];
                        if (unlockPhonesFlag) {
                            // Let angular continue building the main view before popping up the prospecting agreement
                            this.$timeout(function () {
                                _this.showProspectingAgreement();
                            }, 1);
                        }
                    }
                }
            };
            LeadDetailDirectiveController.prototype.createGoogleMap = function () {
                var deferred = this.$q.defer();
                var mapElement = angular.element('#map');
                var mapCenter = new google.maps.LatLng(this.$scope.viewModel.latitude, this.$scope.viewModel.longitude);
                var mapOptions = {
                    center: mapCenter,
                    zoom: 13
                };
                if (this.$scope.printable === true) {
                    mapOptions.fullscreenControl = false;
                    mapOptions.mapTypeControl = false;
                    mapOptions.panControl = false;
                    mapOptions.rotateControl = false;
                    mapOptions.scaleControl = false;
                    mapOptions.streetViewControl = false;
                    mapOptions.zoomControl = false;
                }
                var map = new google.maps.Map(mapElement[0], mapOptions);
                map.addListener('tilesloaded', function () {
                    deferred.resolve();
                });
                var markerTitle = this.$scope.viewModel.fullAddress;
                var marker = new google.maps.Marker({
                    position: mapCenter,
                    map: map,
                    title: markerTitle
                });
                // Limit time for event to signal maps drawn (may not be fired in print render)
                return this.$q.race([deferred.promise, this.$timeout(1500)]);
            };
            LeadDetailDirectiveController.prototype.createStreetView = function () {
                var _this = this;
                var deferred = this.$q.defer();
                var streetElement = angular.element('#street');
                streetElement[0].innerHTML = '';
                var targetLatLng = new google.maps.LatLng(this.$scope.viewModel.latitude, this.$scope.viewModel.longitude);
                var panoramaOptions = {
                    position: targetLatLng,
                    pov: {
                        heading: 0,
                        pitch: 0
                    },
                    zoom: 0
                };
                if (this.$scope.printable === true) {
                    panoramaOptions.addressControl = false;
                    panoramaOptions.clickToGo = false;
                    panoramaOptions.imageDateControl = false;
                    panoramaOptions.fullscreenControl = false;
                    panoramaOptions.linksControl = false;
                    panoramaOptions.motionTrackingControl = false;
                    panoramaOptions.panControl = false;
                    panoramaOptions.zoomControl = false;
                    panoramaOptions.scrollwheel = false;
                }
                var streetPanorama = new google.maps.StreetViewPanorama(streetElement[0], panoramaOptions);
                streetPanorama.addListener('pano_changed', function () {
                    var heading = google.maps.geometry.spherical.computeHeading(streetPanorama.getLocation().latLng, targetLatLng);
                    streetPanorama.setPov({
                        heading: heading,
                        pitch: 0
                    });
                });
                streetPanorama.addListener('pov_changed', function () {
                    google.maps.event.trigger(streetPanorama, 'resize');
                });
                streetPanorama.addListener('links_changed', function () {
                    // NOTE: Doesn't guarantee streetview is ready, but generally is last event to fire
                    deferred.resolve();
                });
                // Allow some time beyond the links_changed event for streetview to render
                return deferred.promise.then(function () { return _this.$timeout(1500); });
            };
            LeadDetailDirectiveController.prototype.debounceSaveUpdates = function (newVal, oldVal) {
                var _this = this;
                if (newVal != oldVal) {
                    if (this.notesUpdatingTimeout) {
                        this.$timeout.cancel(this.notesUpdatingTimeout);
                    }
                    this.notesUpdatingTimeout = this.$timeout(function () {
                        _this.saveUpdates();
                    }, this.notesUpdatingWaitTime);
                }
            };
            ;
            LeadDetailDirectiveController.prototype.emailLead = function () {
                if (this.$scope.viewModel.contactInfo.email != null) {
                    window.location.href = "mailto: ".concat(this.$scope.viewModel.contactInfo.email);
                }
                else {
                    this.notificationService.info('There is no email address in the database.', zbuyer.messages.ApplicationTitle);
                }
            };
            LeadDetailDirectiveController.prototype.fillLeadDetail = function (leadDetail) {
                var _this = this;
                this.setupActivityActions(leadDetail.longDescriptionHtml);
                var setupMapsPromise = this.setupMapViews();
                setupMapsPromise
                    .catch(function (err) {
                    console.log(err);
                    if (!_this.$scope.printable) {
                        _this.notificationService.warning('There was an error loading the map or street view.');
                    }
                    _this.$scope.mapsError = 'There was an error loading the map or street view.';
                });
                if (this.$scope.printable) {
                    setupMapsPromise
                        .finally(function () { return _this.signalEvoPdfConverter(); });
                }
            };
            LeadDetailDirectiveController.prototype.getDirections = function () {
                if (this.$scope.viewModel.address != null) {
                    window.open("https://www.google.com/maps/place/".concat(this.$scope.viewModel.fullAddress), '_blank');
                }
            };
            LeadDetailDirectiveController.prototype.getLeadPhoneNumber = function () {
                var _this = this;
                var blockId = 'request-phone-number';
                var classGetPhone = '.phone-reveal-prompt';
                var classPhoneReveal = '.phone-reveal';
                var classPhone = '.phone-number';
                var classSecondaryPhone = '.phone-number';
                var classFade = 'fade';
                var classHide = 'ng-hide';
                $(classPhoneReveal).addClass(classFade);
                var leadId = this.$scope.viewModel.id;
                if (leadId == null) {
                    $(classPhoneReveal).removeClass(classFade);
                    this.notificationService.error("No lead was provided.", zbuyer.messages.ApplicationTitle);
                }
                else {
                    this.spinWaitService.block(blockId);
                    this.leadPhoneNumberService.getLeadPhoneNumbers(leadId).then(function (response) {
                        if (!response.showProspectingRobocallWarning) {
                            // Chain forward
                            return response;
                        }
                        // For high rate of phone-unlocks: interrupt and warn, then re-request signalling compliance (or not)
                        // (Chaining onto original promise)
                        _this.spinWaitService.unblock(blockId);
                        return controllers.ComplianceReminderModalComponent.loadModal().then(function (confirmed) {
                            _this.spinWaitService.block(blockId);
                            return _this.leadPhoneNumberService.getLeadPhoneNumbers(leadId, confirmed);
                        });
                    }).then(function (response) {
                        var revealedPhone = false;
                        if (response.phoneNumber && response.phoneNumber.fullNumber) {
                            var primaryPhone = response.phoneNumber.fullNumber;
                            _this.$scope.viewModel.contactInfo.phoneNumber.fullNumber = primaryPhone;
                            $(classPhoneReveal).addClass(classHide);
                            $(classPhone).removeClass(classHide);
                            revealedPhone = true;
                        }
                        if (response.secondaryPhoneNumber && response.secondaryPhoneNumber.fullNumber) {
                            var secondaryPhone = response.secondaryPhoneNumber.fullNumber;
                            _this.$scope.viewModel.contactInfo.secondaryPhoneNumber.fullNumber = secondaryPhone;
                            $(classPhoneReveal).addClass(classHide);
                            $(classSecondaryPhone).removeClass(classHide);
                            revealedPhone = true;
                        }
                        if (!revealedPhone) {
                            $(classGetPhone).html(_this.phoneUnavailable);
                            _this.notificationService.error("Phone unavailable. Please contact support.", zbuyer.messages.ApplicationTitle);
                        }
                    }).catch(function (response) {
                        var _a, _b;
                        $(classPhoneReveal).removeClass(classHide);
                        console.debug(response);
                        _this.notificationService.error((_b = (_a = response.data.message) !== null && _a !== void 0 ? _a : response.data.exceptionMessage) !== null && _b !== void 0 ? _b : 'Unknown error', zbuyer.messages.ApplicationTitle);
                    }).finally(function () {
                        $(classPhoneReveal).removeClass(classFade);
                        _this.spinWaitService.unblock(blockId);
                    });
                }
            };
            LeadDetailDirectiveController.prototype.initializeWatches = function () {
                var _this = this;
                this.$scope.$watch(function ($scope) { return $scope.viewModel; }, function (newValue, oldValue, $scope) {
                    if (newValue && newValue.id) {
                        _this.fillLeadDetail(newValue);
                        if (_this.$scope.unwatchNotes) {
                            _this.$scope.unwatchNotes();
                        }
                        // Watch for changes to notes once initial notes are in places
                        _this.$scope.unwatchNotes = _this.$scope.$watch(function ($scope) { var _a; return (_a = $scope.viewModel) === null || _a === void 0 ? void 0 : _a.notes; }, function (newValue, oldValue, $scope) {
                            if (newValue) {
                                _this.debounceSaveUpdates(newValue, oldValue);
                            }
                        });
                        // Check for unlockable prospecting lead if we just loaded the model
                        if (!oldValue) {
                            _this.checkProspectingUnlockFlag();
                        }
                    }
                    else if (!newValue) {
                        if (_this.$scope.unwatchNotes) {
                            _this.$scope.unwatchNotes();
                        }
                    }
                });
            };
            LeadDetailDirectiveController.prototype.printDate = function () {
                return new Date();
            };
            LeadDetailDirectiveController.prototype.renderHtmlDescription = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            LeadDetailDirectiveController.prototype.saveUpdates = function () {
                var _this = this;
                if (!this.$scope.viewModel) {
                    return;
                }
                this.leadsService.addNoteToLead(this.$scope.viewModel.notes, this.$scope.viewModel.id).then(function (response) {
                }).catch(function (response) {
                    _this.notificationService.error(response.data.message, zbuyer.messages.ApplicationTitle);
                }).finally(function () {
                });
            };
            LeadDetailDirectiveController.prototype.setupActivityActions = function (longDescriptionHtml) {
                var customHtml = this.$compile(longDescriptionHtml);
                angular.element('#longDescriptionHTML').empty().append(customHtml(this.$scope));
            };
            LeadDetailDirectiveController.prototype.showProspectingAgreement = function () {
                this.$scope.prospectingComplianceCallback();
            };
            LeadDetailDirectiveController.prototype.signalEvoPdfConverter = function () {
                if (typeof evoPdfConverter == 'undefined') {
                    return false;
                }
                else {
                    evoPdfConverter.startConversion();
                    return true;
                }
            };
            LeadDetailDirectiveController.prototype.checkGoogleMapsLoaded = function () {
                if (typeof google === 'object' && typeof google.maps === 'object') {
                    console.log('Google Maps API is defined, at version ' + google.maps.version);
                    return true;
                }
                else {
                    console.log('Google Maps API is NOT defined');
                    return false;
                }
            };
            LeadDetailDirectiveController.prototype.setupMapViews = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (!viewModel.latitude) {
                    // No coordinates? Should be able to get coordinates and call setupMapView again
                    if (viewModel.id != null && viewModel.address.addressLine1) {
                        return this.leadsService.getLeadLocation(viewModel.id)
                            .then(function (response) {
                            if (response.verified) {
                                viewModel.latitude = response.latitude;
                                viewModel.longitude = response.longitude;
                                if (viewModel.latitude) {
                                    return _this.setupMapViews();
                                }
                            }
                        });
                    }
                    else {
                        // No valid lead or no address - can't get any coordintes for lead
                        return this.$q.resolve();
                    }
                }
                if (this.$scope.printable) {
                    // No map init for print (using image links to static maps APIs)
                    return this.$q.resolve();
                }
                // Coordinates are available (initially or after retrieval)
                if (!this.checkGoogleMapsLoaded()) {
                    this.$scope.mapsError = 'Sorry! We had a problem printing the map or street view.';
                    return this.$q.resolve();
                }
                var deferred = this.$q.defer();
                try {
                    // Identify when maps are loaded using promises based on key events fired (also with timeout)
                    var streetsPromise = this.createStreetView();
                    var mapsPromise = this.createGoogleMap();
                    this.$q.all([mapsPromise, streetsPromise])
                        .finally(function () { return deferred.resolve(); });
                }
                catch (err) {
                    return this.$q.reject(err);
                }
                // Allow 3 seconds wait any for signals that map and streetview have rendered
                return this.$q.race([deferred.promise, this.$timeout(3000)]);
            };
            LeadDetailDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Sce,
                names.angular.Compile,
                names.angular.Location,
                names.angular.Q,
                names.angular.Timeout,
                names.zbuyer.AppConfiguration,
                names.zbuyer.services.AuthenticationService,
                names.zbuyer.services.LeadPhoneNumberService,
                names.zbuyer.services.LeadsService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService
            ];
            return LeadDetailDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.LeadDetail, LeadDetailDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/leadfoldermodal.html';
        var LeadFolderModalController = /** @class */ (function (_super) {
            __extends(LeadFolderModalController, _super);
            function LeadFolderModalController($scope, $timeout, $uibModalInstance, foldersService, notificationService, lead) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$timeout = $timeout;
                _this.$uibModalInstance = $uibModalInstance;
                _this.foldersService = foldersService;
                _this.notificationService = notificationService;
                _this.folderUpdatingTimeout = null;
                _this.folderUpdatingWaitTime = 1000;
                _this.newFolderInputElement = '#inputNewFolder';
                _this.initializeLeadFolderModal(lead);
                _this.$uibModalInstance.rendered.then(function () {
                    // Any initialization here
                });
                return _this;
            }
            LeadFolderModalController.prototype.initializeLeadFolderModal = function (lead) {
                var _this = this;
                this.$scope.viewModel = {};
                this.$scope.viewModel.foldersLoading = true;
                this.$scope.viewModel.lead = lead;
                this.$scope.viewModel.currentFolderName = lead.folder.name;
                this.loadFolders();
                this.$scope.$watch(function (folderName) { return _this.$scope.viewModel.lead.folder; }, function (newValue, oldValue, folderName) {
                    var viewModel = _this.$scope.viewModel;
                    viewModel.currentFolderName = viewModel.lead.folder.name;
                });
            };
            LeadFolderModalController.prototype.addNewFolder = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.addingNewFolder = true;
                this.$timeout(function () {
                    angular.element(_this.newFolderInputElement).focus();
                });
            };
            LeadFolderModalController.prototype.cancelNewFolder = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.newFolderName = null;
                viewModel.addingNewFolder = false;
            };
            LeadFolderModalController.prototype.closeModal = function () {
                this.$uibModalInstance.close(true);
            };
            LeadFolderModalController.prototype.loadFolders = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                this.$scope.viewModel.foldersLoading = true;
                this.foldersService.getFolderList().then(function (result) {
                    viewModel.folders = result.map(function (folder) { return ({
                        item: folder,
                        selected: false
                    }); });
                    var folders = _this.$scope.viewModel.folders;
                    var selectedFolder = folders.filter(function (f) { return f.item.name == viewModel.lead.folder.name; });
                    if (selectedFolder && selectedFolder.length > 0) {
                        selectedFolder[0].selected = true;
                    }
                    _this.$scope.viewModel.foldersLoading = false;
                }).catch(function (reason) {
                    _this.notificationService.error("Lead folder list unavailable. Please contact support.", zbuyer.messages.ApplicationTitle);
                    _this.$scope.viewModel.foldersLoading = false;
                });
            };
            LeadFolderModalController.prototype.saveNewFolder = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var newFolder = {
                    name: viewModel.newFolderName
                };
                this.foldersService.addLeadToFolder(newFolder, viewModel.lead.id).then(function (folder) {
                    _this.loadFolders();
                    // If folder set for lead, InvestorLead exists and lead is considered viewed
                    // so change this flag on existing lead for UI updates (will show as Viewed on next reload)
                    viewModel.lead.viewed = true;
                    viewModel.lead.folder.name = folder.name;
                }).catch(function (reason) {
                    _this.notificationService.error("Unable to add new folder. Please contact support.", zbuyer.messages.ApplicationTitle);
                }).finally(function () {
                    viewModel.addingNewFolder = false;
                });
            };
            LeadFolderModalController.prototype.setFolder = function (folderModel) {
                var viewModel = this.$scope.viewModel;
                var folders = viewModel.folders;
                var selectedFolder = folders.filter(function (f) { return f.selected == true; });
                if (selectedFolder && selectedFolder.length > 0) {
                    selectedFolder[0].selected = false;
                }
                folderModel.selected = true;
                this.foldersService.addLeadToFolder(folderModel.item, viewModel.lead.id).then(function (result) {
                    viewModel.lead.folder.name = folderModel.item.name;
                    // If folder set for lead, InvestorLead exists and lead is considered viewed
                    // so change this flag on existing lead for UI updates (will show as Viewed on next reload)
                    viewModel.lead.viewed = true;
                });
            };
            LeadFolderModalController.showLeadFolderModal = function (lead) {
                var $injector = angular.element('html').injector();
                var $uibModel = $injector.get(names.angular.UiBootstrapModal);
                return $uibModel.open({
                    backdropClass: 'filter-modal-backdrop',
                    controller: names.zbuyer.controllers.LeadFolderModalController,
                    resolve: {
                        lead: lead
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'folder-menu-modal'
                });
            };
            LeadFolderModalController.$inject = [
                names.angular.Scope,
                names.angular.Timeout,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.FoldersService,
                names.zbuyer.services.NotificationService,
                'lead'
            ];
            return LeadFolderModalController;
        }(controllers.ControllerBase));
        controllers.LeadFolderModalController = LeadFolderModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.LeadFolderModalController, LeadFolderModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/leadmoremenumodal.html';
        var LeadMoreMenuController = /** @class */ (function (_super) {
            __extends(LeadMoreMenuController, _super);
            function LeadMoreMenuController($scope, $uibModalInstance, $window, leadsService, notificationService, spinWaitService, viewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.$window = $window;
                _this.leadsService = leadsService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                $scope.viewModel = viewModel;
                return _this;
            }
            LeadMoreMenuController.showLeadMoreMenu = function (lead, allowShareAndPrint) {
                if (allowShareAndPrint === void 0) { allowShareAndPrint = false; }
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                return $uibModal.open({
                    backdropClass: 'filter-modal-backdrop',
                    controller: names.zbuyer.controllers.LeadMoreMenuController,
                    resolve: {
                        viewModel: {
                            lead: lead,
                            allowShareAndPrint: allowShareAndPrint,
                            ratingTypes: {
                                high: zbuyer.models.RatingType.high,
                                low: zbuyer.models.RatingType.low,
                                neutral: zbuyer.models.RatingType.neutral
                            }
                        }
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'more-menu-modal'
                });
            };
            LeadMoreMenuController.prototype.closeModal = function () {
                this.$uibModalInstance.close(true);
            };
            LeadMoreMenuController.prototype.downloadBlob = function (fileName, blob) {
                // IE v11 Compatibility
                if (this.$window.navigator.msSaveOrOpenBlob) {
                    this.$window.navigator.msSaveOrOpenBlob(blob, fileName);
                    return;
                }
                // All Other Browsers
                var url = window.URL.createObjectURL(blob);
                var tempLink = document.createElement('a');
                tempLink.href = url;
                tempLink.download = fileName;
                // Firefox requires adding this element to the body before a click can be triggered
                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
            };
            LeadMoreMenuController.prototype.getDirections = function () {
                if (this.$scope.viewModel.lead.address != null) {
                    window.open("https://www.google.com/maps/place/".concat(this.$scope.viewModel.lead.fullAddress), '_blank');
                }
            };
            LeadMoreMenuController.prototype.getPrintableLead = function () {
                var _this = this;
                var rateLimitErrorText = 'Download prevented due to rate limit';
                var viewModel = this.$scope.viewModel;
                var blockId = names.zbuyer.spinnermessages.PrintableScreen;
                this.spinWaitService.block(blockId);
                this.leadsService.getPrintableLead(viewModel.lead).then(function (result) {
                    if (!result.rateLimitReached) {
                        // Just pass on to final .then()
                        return result;
                    }
                    // For high rate of phone-unlocks via Share, interrupt download and warn user about FCC/TCPA compliance
                    _this.spinWaitService.unblock(blockId);
                    if (!viewModel.lead.isProspecting && !result.blob) {
                        // Not expected for non-prospecting lead, but server sent HTTP 429 and provided no data
                        throw rateLimitErrorText;
                    }
                    // For prospecting leads we can warn user about prospecting TCPA compliance.
                    return zbuyer.controllers.ComplianceReminderModalComponent.loadModal().then(function (confirmed) {
                        _this.spinWaitService.block(blockId);
                        return _this.leadsService.getPrintableLead(viewModel.lead, confirmed);
                    });
                }).then(function (result) {
                    if (result.rateLimitReached) {
                        throw rateLimitErrorText;
                    }
                    // If printable lead generated, InvestorLead exists and lead is considered viewed
                    // so change this flag on existing lead for UI updates (will show as Viewed on next reload)
                    viewModel.lead.viewed = true;
                    _this.downloadBlob("".concat(viewModel.lead.firstName, " ").concat(viewModel.lead.lastName, ".pdf"), result.blob);
                }).catch(function (reason) {
                    _this.notificationService.error("Printed version unavailable. Please contact support.", zbuyer.messages.ApplicationTitle);
                }).finally(function () {
                    _this.spinWaitService.unblock(names.zbuyer.spinnermessages.PrintableScreen);
                });
            };
            LeadMoreMenuController.prototype.rateLead = function (rating) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                this.leadsService.addRatingToLead(rating, this.$scope.viewModel.lead.id).then(function (response) {
                    viewModel.lead.rating = response;
                    // if rating was set, then InvestorLead was created and lead is considered viewed
                    // so change this flag on existing lead for UI updates (will show as Viewed on next reload)
                    viewModel.lead.viewed = true;
                }).catch(function (response) {
                    _this.notificationService.error(response.data.message, zbuyer.messages.ApplicationTitle);
                });
            };
            LeadMoreMenuController.prototype.shareLead = function () {
                var _this = this;
                var rateLimitErrorText = 'Download prevented due to rate limit';
                var blockId = 'shareLead';
                var viewModel = this.$scope.viewModel;
                this.spinWaitService.block(blockId);
                this.leadsService.getLeadVCard(viewModel.lead).then(function (result) {
                    if (!result.rateLimitReached) {
                        // Just pass on to final .then()
                        return result;
                    }
                    // For high rate of phone-unlocks via Share, interrupt download and warn user about FCC/TCPA compliance
                    _this.spinWaitService.unblock(blockId);
                    if (!viewModel.lead.isProspecting && !result.blob) {
                        // Not expected for non-prospecting lead, but server sent HTTP 429 and provided no data
                        throw rateLimitErrorText;
                    }
                    // For prospecting leads we can warn user about prospecting TCPA compliance.
                    return zbuyer.controllers.ComplianceReminderModalComponent.loadModal().then(function (confirmed) {
                        _this.spinWaitService.block(blockId);
                        return _this.leadsService.getLeadVCard(viewModel.lead, confirmed);
                    });
                }).then(function (result) {
                    if (result.rateLimitReached) {
                        throw rateLimitErrorText;
                    }
                    // if contact info generated, then InvestorLead was created and lead is considered viewed
                    // so change this flag on existing lead for UI updates (will show as Viewed on next reload)
                    viewModel.lead.viewed = true;
                    _this.downloadBlob("".concat(viewModel.lead.firstName, " ").concat(viewModel.lead.lastName, ".vcf"), result.blob);
                }).catch(function (reason) {
                    _this.notificationService.error("Share Lead unavailable. Please contact support.", zbuyer.messages.ApplicationTitle);
                }).finally(function () {
                    _this.spinWaitService.unblock(blockId);
                });
            };
            LeadMoreMenuController.prototype.showLeadFolderModal = function () {
                var viewModel = this.$scope.viewModel;
                var modal = controllers.LeadFolderModalController.showLeadFolderModal(viewModel.lead).result.then(function (result) {
                });
            };
            LeadMoreMenuController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.angular.Window,
                names.zbuyer.services.LeadsService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService,
                'viewModel'
            ];
            return LeadMoreMenuController;
        }(controllers.ControllerBase));
        controllers.LeadMoreMenuController = LeadMoreMenuController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.LeadMoreMenuController, LeadMoreMenuController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/leadpreviewsdirective.html';
        var LeadPreviewsDirectiveController = /** @class */ (function (_super) {
            __extends(LeadPreviewsDirectiveController, _super);
            function LeadPreviewsDirectiveController($scope, $window, leadPreviewService, notificationService, spinWaitService, $sce) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$window = $window;
                _this.leadPreviewService = leadPreviewService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.$sce = $sce;
                _this.lastScrollPosition = 0;
                var viewModel = _this.$scope.viewModel;
                viewModel.searchUpdated = function () {
                    _this.getLeadPreviews();
                };
                _this.$scope.$watch(function ($scope) { return $scope.isShowing; }, function (isShowing, wasShowing, $scope) { return _this.handleVisibilityChange(isShowing, wasShowing); });
                if (_this.$scope.isShowing) {
                    _this.getLeadPreviews();
                }
                return _this;
            }
            Object.defineProperty(LeadPreviewsDirectiveController.prototype, "scrollPosition", {
                get: function () {
                    return this.$window.scrollY;
                },
                set: function (scrollY) {
                    this.$window.scrollTo({ top: scrollY });
                    this.lastScrollPosition = scrollY;
                },
                enumerable: false,
                configurable: true
            });
            LeadPreviewsDirectiveController.prototype.handleVisibilityChange = function (isShowing, wasShowing) {
                var _this = this;
                if (wasShowing == isShowing) {
                    return;
                }
                if (!isShowing) {
                    // Note: Delicate: Relies on nothing else having already changed the scroll position.
                    // However, the scroll is generally set on a delay, while the app-section-change (which changes visibility)
                    // registers soon enough that we can capture the previous position from here.
                    this.lastScrollPosition = this.$window.scrollY;
                }
                else {
                    if (this.$scope.viewModel.leads) {
                        // Showing, with leads already in place - just restore scroll position
                        this.$window.setTimeout(function () {
                            _this.$window.scrollTo({ top: _this.lastScrollPosition });
                        }, 1);
                    }
                    else {
                        // Showing but nothing loaded yet (first time) so go fetch.
                        this.getLeadPreviews();
                    }
                }
            };
            LeadPreviewsDirectiveController.getDirective = function () {
                return {
                    controller: LeadPreviewsDirectiveController,
                    restrict: 'E',
                    scope: {
                        leadPreviewSelectedCallback: '&onLeadPreviewSelected',
                        isShowing: '=',
                        viewModel: '=',
                        selectedLeadId: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            LeadPreviewsDirectiveController.prototype.pageChanged = function () {
                this.getLeadPreviews();
            };
            LeadPreviewsDirectiveController.prototype.onClickedLeadPreview = function (leadPreview) {
                this.$scope.leadPreviewSelectedCallback({ leadPreview: leadPreview });
            };
            LeadPreviewsDirectiveController.prototype.getSellingDescription = function (leadPreview) {
                var parts = [];
                if (leadPreview.sellingInfo.beds > 0) {
                    parts.push("".concat(leadPreview.sellingInfo.beds, " Bed").concat(leadPreview.sellingInfo.beds > 1 ? 's' : ''));
                }
                if (leadPreview.sellingInfo.baths > 0) {
                    parts.push("".concat(leadPreview.sellingInfo.baths, " Bath").concat(leadPreview.sellingInfo.baths > 1 ? 's' : ''));
                }
                if (leadPreview.sellingInfo.estimatedValue) {
                    parts.push("<strong>$".concat(leadPreview.sellingInfo.estimatedValue.toLocaleString(), "</strong>"));
                }
                return this.$sce.trustAsHtml(parts.join(', '));
            };
            LeadPreviewsDirectiveController.prototype.getLeadPreviews = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.leads = null;
                viewModel.errorMessageToDisplay = null;
                // Scroll back to top
                this.scrollPosition = 0;
                if (!viewModel.page) {
                    viewModel.page = 1;
                }
                var request;
                if (viewModel.userFiltersApplied) {
                    request = {
                        buyer_Baths_MIN: viewModel.bathroomsMin,
                        buyer_Baths_MAX: viewModel.bathroomsMax,
                        buyer_Baths_InclUnknown: viewModel.includeUnknownBathrooms,
                        buyer_Beds_MIN: viewModel.bedroomsMin,
                        buyer_Beds_MAX: viewModel.bedroomsMax,
                        buyer_Beds_InclUnknown: viewModel.includeUnknownBedrooms,
                        buyer_PriceRange_MIN: viewModel.priceRangeMin,
                        buyer_PriceRange_MAX: viewModel.priceRangeMax,
                        buyer_PriceRange_InclUnknown: viewModel.includeUnknownPrice,
                        seller_Baths_MIN: viewModel.bathroomsMin,
                        seller_Baths_MAX: viewModel.bathroomsMax,
                        seller_Baths_InclUnknown: viewModel.includeUnknownBathrooms,
                        seller_Beds_MIN: viewModel.bedroomsMin,
                        seller_Beds_MAX: viewModel.bedroomsMax,
                        seller_Beds_InclUnknown: viewModel.includeUnknownBedrooms,
                        seller_EstimatedValue_MIN: viewModel.priceRangeMin,
                        seller_EstimatedValue_MAX: viewModel.priceRangeMax,
                        seller_EstimatedValue_InclUnknown: viewModel.includeUnknownPrice,
                        includeSellers: viewModel.includeSellers,
                        includeBuyers: viewModel.includeBuyers,
                        location_State: viewModel.locationState,
                        location_County: viewModel.locationCounty,
                        location_City: viewModel.locationCity,
                        location_Zip: viewModel.locationZip
                    };
                }
                else {
                    request = {};
                }
                request.leadsPerPage = viewModel.appSettings.leadsPerPage;
                request.pageNum = viewModel.page;
                var getLeadsPromise = this.leadPreviewService.getLeadPreviewList(request)
                    .then(function (response) {
                    viewModel.leads = response.leadPreviews;
                    viewModel.page = response.currentPage;
                    viewModel.totalItems = response.totalLeads;
                })
                    .catch(function (err) { return _this.handleError(err); });
                this.spinWaitService.blockDuring(getLeadsPromise, names.zbuyer.spinnermessages.SearchPreviewLeads);
            };
            LeadPreviewsDirectiveController.prototype.handleError = function (thrownError) {
                if (thrownError === void 0) { thrownError = null; }
                if (typeof thrownError == 'string') {
                    this.$scope.viewModel.errorMessageToDisplay = thrownError;
                }
                else {
                    this.notificationService.error('An unexpected error has occurred.');
                    console.error(thrownError);
                }
            };
            LeadPreviewsDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Window,
                names.zbuyer.services.LeadPreviewService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService,
                '$sce'
            ];
            return LeadPreviewsDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.LeadPreviewsList, LeadPreviewsDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/LeadPreviewDetailDirective.html';
        var LeadPreviewDetailDirectiveController = /** @class */ (function () {
            function LeadPreviewDetailDirectiveController($scope, $q, $routeParams, $timeout, leadPreviewService, notificationService) {
                this.$scope = $scope;
                this.$q = $q;
                this.$routeParams = $routeParams;
                this.$timeout = $timeout;
                this.leadPreviewService = leadPreviewService;
                this.notificationService = notificationService;
                this.initialize();
            }
            LeadPreviewDetailDirectiveController.getDirective = function () {
                return {
                    controller: LeadPreviewDetailDirectiveController,
                    restrict: 'E',
                    scope: {
                        selectedLeadPreview: '=',
                        leadPreviews: '=',
                        closeCallback: '&onClose',
                        showClaimedLeadCallback: '&onShowClaimedLead'
                    },
                    templateUrl: TemplateUrl
                };
            };
            Object.defineProperty(LeadPreviewDetailDirectiveController.prototype, "canLoadPrevious", {
                get: function () {
                    return this.$scope.selectedLeadPreviewIndex > 0;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(LeadPreviewDetailDirectiveController.prototype, "canLoadNext", {
                get: function () {
                    return this.$scope.leadPreviews && this.$scope.selectedLeadPreviewIndex < (this.$scope.leadPreviews.length - 1);
                },
                enumerable: false,
                configurable: true
            });
            LeadPreviewDetailDirectiveController.prototype.initialize = function () {
                var _this = this;
                this.$scope.controller = this;
                this.$scope.loading = true;
                this.$scope.selectedLeadPreviewIndex = -1;
                if (this.$routeParams.leadPreviewId) {
                    this.fetchDetails(+this.$routeParams.leadPreviewId);
                }
                this.$scope.$watch(function ($scope) { return $scope.selectedLeadPreview; }, function (lead, oldLead, $scope) { return _this.handleSelectedLeadPreviewChanged(lead, oldLead); });
            };
            LeadPreviewDetailDirectiveController.prototype.loadPrevious = function () {
                this.$scope.selectedLeadPreviewIndex--;
                this.$scope.selectedLeadPreview = this.$scope.leadPreviews[this.$scope.selectedLeadPreviewIndex];
            };
            LeadPreviewDetailDirectiveController.prototype.loadNext = function () {
                this.$scope.selectedLeadPreviewIndex++;
                this.$scope.selectedLeadPreview = this.$scope.leadPreviews[this.$scope.selectedLeadPreviewIndex];
            };
            LeadPreviewDetailDirectiveController.prototype.claimLeadAndShowModal = function () {
                var _this = this;
                this.leadPreviewService.claimLead(this.$scope.leadPreview.id)
                    .then(function (response) {
                    if (!response.success) {
                        // No longer claimable? Refresh lead-preview just in case.
                        _this.fetchDetails(_this.$scope.leadPreview.id);
                        // Throw error to pop up a message (and avoid navigating away)
                        throw response.errorMessageToDisplay;
                    }
                    // Can immediately assume this
                    _this.$scope.leadPreview.claimed = true;
                    _this.$scope.leadPreview.claimable = false;
                    // Update on shared instance as well
                    if (_this.$scope.selectedLeadPreview) {
                        _this.$scope.selectedLeadPreview.claimed = true;
                        _this.$scope.selectedLeadPreview.claimable = false;
                    }
                    // Token balance has changed so provide this to the modal, which will tell us where to go next
                    return _this.updateTokenBalance().then(function (balanceUpdated) {
                        var modalScope = _this.$scope.$new(true);
                        modalScope.result = response;
                        modalScope.balanceInfo = balanceUpdated ? _this.$scope.balanceInfo : null;
                        modalScope.allowNavigateNext = _this.canLoadNext;
                        return controllers.ClaimedLeadModalController.showModal(modalScope);
                    });
                }).then(function (navigation) {
                    switch (navigation) {
                        case controllers.ClaimedLeadNavigationOption.NextLead:
                            _this.loadNext();
                            break;
                        case controllers.ClaimedLeadNavigationOption.ViewClaimed:
                            _this.$scope.showClaimedLeadCallback({ selectedPreviewLeadId: _this.$scope.leadPreview.id });
                            break;
                        case controllers.ClaimedLeadNavigationOption.BackToList:
                            _this.$scope.closeCallback();
                            break;
                    }
                }).catch(function (err) {
                    _this.handleError(err);
                });
            };
            LeadPreviewDetailDirectiveController.prototype.updateTokenBalance = function () {
                var _this = this;
                return this.leadPreviewService.getTokenBalance()
                    .then(function (balanceResponse) {
                    _this.$scope.balanceInfo = balanceResponse;
                    return true;
                })
                    .catch(function (err) {
                    _this.handleError(err);
                    return false;
                });
            };
            LeadPreviewDetailDirectiveController.prototype.fetchDetails = function (leadId) {
                var _this = this;
                var scope = this.$scope;
                scope.loading = true;
                scope.claimLeadButtonText = "Claim Lead";
                var gotLeadPreview = this.leadPreviewService.getLeadPreview(leadId)
                    .then(function (leadPreview) {
                    scope = _this.$scope;
                    scope.leadPreview = leadPreview;
                    if (scope.selectedLeadPreview) {
                        // Update the copy on the original list, if present
                        scope.selectedLeadPreview.previewed = leadPreview.previewed;
                    }
                    if (leadPreview.sellingInfo && !leadPreview.buyingInfo) {
                        scope.claimLeadButtonText = "Claim Seller Lead";
                    }
                    else if (leadPreview.buyingInfo && !leadPreview.sellingInfo) {
                        scope.claimLeadButtonText = "Claim Buyer Lead";
                    }
                })
                    .catch(function (err) { return _this.handleError(err); });
                var gotTokenBalance = this.updateTokenBalance();
                return this.$q.all([gotLeadPreview, gotTokenBalance])
                    .then(function () { return true; })
                    .catch(function () { return false; })
                    .finally(function () {
                    _this.$scope.loading = false;
                });
            };
            LeadPreviewDetailDirectiveController.prototype.handleError = function (thrownError) {
                if (thrownError === void 0) { thrownError = null; }
                if (typeof thrownError == 'string') {
                    this.notificationService.error(thrownError);
                }
                else {
                    this.notificationService.error('An unexpected error has occurred.');
                    console.error(thrownError);
                }
            };
            LeadPreviewDetailDirectiveController.prototype.handleSelectedLeadPreviewChanged = function (newSelectedLead, oldSelectedLead) {
                if (newSelectedLead && newSelectedLead != oldSelectedLead) {
                    if (this.$scope.leadPreviews) {
                        this.$scope.selectedLeadPreviewIndex = this.$scope.leadPreviews.indexOf(newSelectedLead);
                    }
                    else {
                        this.$scope.selectedLeadPreviewIndex = -1;
                    }
                    this.fetchDetails(newSelectedLead.id);
                }
            };
            LeadPreviewDetailDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Q,
                names.angular.RouteParams,
                names.angular.Timeout,
                names.zbuyer.services.LeadPreviewService,
                names.zbuyer.services.NotificationService
            ];
            return LeadPreviewDetailDirectiveController;
        }());
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.LeadPreview, LeadPreviewDetailDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/leadsdirective.html';
        var LeadsDirectiveController = /** @class */ (function (_super) {
            __extends(LeadsDirectiveController, _super);
            function LeadsDirectiveController($scope, $sce) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                return _this;
            }
            LeadsDirectiveController.getDirective = function () {
                return {
                    controller: LeadsDirectiveController,
                    restrict: 'E',
                    scope: {
                        showLeadDetailCallback: '&onShowLeadDetail',
                        openMoreMenuCallback: '&onOpenMoreMenu',
                        pageChangedCallback: '&onPageChanged',
                        prospectingComplianceCallback: '&onOpenProspectingCompliance',
                        prospecting: '=',
                        prospectingCompliant: '=',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            LeadsDirectiveController.prototype.pageChanged = function () {
                this.$scope.pageChangedCallback();
            };
            LeadsDirectiveController.prototype.renderHtmlDescription = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            LeadsDirectiveController.prototype.showProspectingAgreement = function () {
                this.$scope.prospectingComplianceCallback();
            };
            LeadsDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Sce
            ];
            return LeadsDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.LeadsList, LeadsDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/leadssearchdirective.html';
        var LeadsSearchDirectiveController = /** @class */ (function (_super) {
            __extends(LeadsSearchDirectiveController, _super);
            function LeadsSearchDirectiveController($scope) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                return _this;
            }
            LeadsSearchDirectiveController.getDirective = function () {
                return {
                    controller: LeadsSearchDirectiveController,
                    restrict: 'E',
                    scope: {
                        filterButtonClickedCallback: '&onFilterButtonClick',
                        searchButtonClickedCallback: '&onSearchButtonClick',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            LeadsSearchDirectiveController.$inject = [
                names.angular.Scope
            ];
            return LeadsSearchDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.LeadsSearch, LeadsSearchDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/previewsearchdirective.html';
        var PreviewSearchDirectiveController = /** @class */ (function (_super) {
            __extends(PreviewSearchDirectiveController, _super);
            function PreviewSearchDirectiveController($scope) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                return _this;
            }
            PreviewSearchDirectiveController.getDirective = function () {
                return {
                    controller: PreviewSearchDirectiveController,
                    restrict: 'E',
                    scope: {
                        previewFilterButtonClickedCallback: '&onPreviewFilterButtonClick'
                    },
                    templateUrl: TemplateUrl
                };
            };
            PreviewSearchDirectiveController.$inject = [
                names.angular.Scope
            ];
            return PreviewSearchDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.PreviewSearch, PreviewSearchDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/learnmoremodal.html';
        var LearnMoreModalController = /** @class */ (function (_super) {
            __extends(LearnMoreModalController, _super);
            function LearnMoreModalController($scope, $uibModalInstance, modalService, learnMoreViewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.modalService = modalService;
                _this.learnMoreViewModel = learnMoreViewModel;
                $scope.viewModel = learnMoreViewModel;
                modalService.handleCloseActions($scope, $uibModalInstance);
                return _this;
            }
            LearnMoreModalController.loadModal = function (track) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                return $uibModal.open({
                    controller: names.zbuyer.controllers.LearnMoreModalController,
                    resolve: {
                        learnMoreViewModel: { track: track }
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'learn-more-modal'
                });
            };
            LearnMoreModalController.prototype.close = function () {
                this.$uibModalInstance.close();
            };
            LearnMoreModalController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.ModalService,
                'learnMoreViewModel'
            ];
            return LearnMoreModalController;
        }(controllers.ControllerBase));
        controllers.LearnMoreModalController = LearnMoreModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.LearnMoreModalController, LearnMoreModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/mobileapppromomodal.html';
        var MobileAppPromoModalController = /** @class */ (function (_super) {
            __extends(MobileAppPromoModalController, _super);
            function MobileAppPromoModalController($scope, $uibModalInstance, modalService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.modalService = modalService;
                _this.$uibModalInstance.rendered.then(function () {
                    // Any initialization here
                });
                modalService.handleCloseActions($scope, $uibModalInstance);
                return _this;
            }
            MobileAppPromoModalController.loadModal = function () {
                var $injector = angular.element('html').injector();
                var $uibModel = $injector.get(names.angular.UiBootstrapModal);
                var modal = $uibModel.open({
                    controller: names.zbuyer.controllers.MobileAppPromoModalController,
                    resolve: {},
                    templateUrl: TemplateUrl,
                    windowClass: 'mobile-promo-modal'
                });
                return modal;
            };
            MobileAppPromoModalController.prototype.appUrl = function () {
                if (/Android/i.test(navigator.userAgent)) {
                    return 'android';
                }
                else if (/iPhone|iPad/i.test(navigator.userAgent)) {
                    return 'ios';
                }
            };
            MobileAppPromoModalController.prototype.close = function () {
                this.$uibModalInstance.close();
            };
            MobileAppPromoModalController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.ModalService
            ];
            return MobileAppPromoModalController;
        }(controllers.ControllerBase));
        controllers.MobileAppPromoModalController = MobileAppPromoModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.MobileAppPromoModalController, MobileAppPromoModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/moremenudirective.html';
        var MoreMenuDirectiveController = /** @class */ (function (_super) {
            __extends(MoreMenuDirectiveController, _super);
            function MoreMenuDirectiveController($scope, $window) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$window = $window;
                return _this;
            }
            MoreMenuDirectiveController.getDirective = function () {
                return {
                    controller: MoreMenuDirectiveController,
                    restrict: 'E',
                    scope: {
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            MoreMenuDirectiveController.prototype.openPrivacyPolicy = function () {
                this.$window.open('legal/privacy');
            };
            MoreMenuDirectiveController.prototype.openTermsOfUse = function () {
                this.$window.open('legal/terms');
            };
            MoreMenuDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Window
            ];
            return MoreMenuDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.MoreMenu, MoreMenuDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/navbardirective.html';
        var NavBarDirectiveController = /** @class */ (function (_super) {
            __extends(NavBarDirectiveController, _super);
            function NavBarDirectiveController($scope) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                return _this;
            }
            NavBarDirectiveController.getDirective = function () {
                return {
                    controller: NavBarDirectiveController,
                    restrict: 'E',
                    scope: {
                        initialized: '=',
                        canProspect: '=',
                        canPreview: '=',
                        showLeadsCallback: '&onShowLeads',
                        showMessagesCallback: '&onShowMessages',
                        showProspectingCallback: '&onShowProspecting',
                        showSelectListCallback: '&onShowSelectList',
                        showAccountCallback: '&onShowAccount',
                        showMoreCallback: '&onShowMore'
                    },
                    templateUrl: TemplateUrl
                };
            };
            NavBarDirectiveController.$inject = [
                names.angular.Scope
            ];
            return NavBarDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.NavBar, NavBarDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var NavigationController = /** @class */ (function (_super) {
            __extends(NavigationController, _super);
            function NavigationController($scope, appSettingsService, notificationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.appSettingsService = appSettingsService;
                _this.notificationService = notificationService;
                _this.$scope.viewModel = {};
                _this.setAppSettings();
                return _this;
            }
            NavigationController.prototype.setAppSettings = function () {
                var _this = this;
                this.appSettingsService.getAppSettings().then(function (settings) {
                    _this.$scope.viewModel.appSettings = settings;
                }).catch(function (err) {
                    console.debug(err);
                    _this.notificationService.error(zbuyer.messages.AppSettingsError, zbuyer.messages.ApplicationTitle);
                });
            };
            NavigationController.$inject = [
                names.angular.Scope,
                names.zbuyer.services.AppSettingsService,
                names.zbuyer.services.NotificationService
            ];
            return NavigationController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.NavigationController, NavigationController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        controllers.NewPasswordDirectiveElement = '#newPasswordDirective';
        var NewPasswordInputElement = '#newPasswordInput';
        var RedirectDelay = 3000;
        var TemplateUrl = 'staticpages/directives/newpassworddirective.html';
        var Used = 'used';
        var NewPasswordDirectiveController = /** @class */ (function (_super) {
            __extends(NewPasswordDirectiveController, _super);
            function NewPasswordDirectiveController($scope, $timeout, $window, accountService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.accountService = accountService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                return _this;
            }
            NewPasswordDirectiveController.getDirective = function () {
                return {
                    controller: NewPasswordDirectiveController,
                    restrict: 'E',
                    scope: {
                        forgotten: '=',
                        signup: '=',
                        key: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            NewPasswordDirectiveController.prototype.invalidPassword = function () {
                var viewModel = this.$scope.viewModel;
                if (!viewModel) {
                    return true;
                }
                var validPassword = viewModel.validPassword;
                return !validPassword.length || !validPassword.content || !validPassword.format || !validPassword.match;
            };
            NewPasswordDirectiveController.prototype.getNewPassword = function () {
                return this.$scope.viewModel.validPassword.newPassword;
            };
            NewPasswordDirectiveController.prototype.newPasswordFocus = function () {
                this.$timeout(function () {
                    angular.element(NewPasswordInputElement).focus();
                }, 500);
            };
            NewPasswordDirectiveController.prototype.changeAccountPassword = function () {
                var _this = this;
                this.spinWaitService.block("change-password");
                if (this.verifyNewPassword()) {
                    var validPassword = this.$scope.viewModel.validPassword;
                    var updateAccountPasswordRequest = {
                        currentPassword: validPassword.currentPassword,
                        newPassword: validPassword.newPassword
                    };
                    this.accountService.changePassword(updateAccountPasswordRequest).then(function () {
                        validPassword.newPassword = '';
                        validPassword.confirmPassword = '';
                        validPassword.currentPassword = '';
                        validPassword.content = false;
                        validPassword.format = false;
                        validPassword.length = false;
                        validPassword.match = false;
                        _this.notificationService.success(zbuyer.messages.PasswordChangedSuccess);
                    }).catch(function (response) {
                        var _a;
                        if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.exceptionMessage) {
                            _this.notificationService.error(response.data.exceptionMessage, response.data.message);
                        }
                        else {
                            _this.notificationService.error(zbuyer.messages.PasswordChangedError, zbuyer.messages.ApplicationTitle);
                        }
                    }).finally(function () {
                        _this.spinWaitService.unblock("change-password");
                    });
                }
                else {
                    this.notificationService.error(zbuyer.messages.PasswordChangedError, zbuyer.messages.ApplicationTitle);
                    this.spinWaitService.unblock("change-password");
                }
            };
            NewPasswordDirectiveController.prototype.changeForgottenPassword = function () {
                var _this = this;
                this.spinWaitService.block("change-forgotten-password");
                var validPassword = this.$scope.viewModel.validPassword;
                if (this.$scope.key === null) {
                    this.notificationService.error("Something went wrong. Please return to our home page and try again.", "Error");
                }
                if (this.$scope.key === Used) {
                    this.resetNewPasswordForm();
                    this.notificationService.warning("Your password has already been changed. Please try logging in with your new password.", "Please Log In");
                    this.spinWaitService.unblock("change-forgotten-password");
                }
                else {
                    if (this.verifyNewPassword()) {
                        var updateForgottenPasswordRequest = {
                            key: this.$scope.key,
                            newPassword: validPassword.newPassword
                        };
                        this.accountService.changeForgottenPassword(updateForgottenPasswordRequest).then(function (response) {
                            _this.resetNewPasswordForm();
                            _this.$scope.key = Used;
                            _this.takeToLogin(response.email);
                        }).catch(function (response) {
                            var _a;
                            if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.exceptionMessage) {
                                _this.notificationService.error(response.data.exceptionMessage, response.data.message);
                            }
                            else {
                                _this.notificationService.error(zbuyer.messages.PasswordChangedError, zbuyer.messages.ApplicationTitle);
                            }
                        }).finally(function () {
                            _this.spinWaitService.unblock("change-forgotten-password");
                        });
                    }
                    else {
                        this.notificationService.error(zbuyer.messages.PasswordChangedError, zbuyer.messages.ApplicationTitle);
                        this.spinWaitService.unblock("change-forgotten-password");
                    }
                }
            };
            NewPasswordDirectiveController.prototype.resetNewPasswordForm = function () {
                var validPassword = this.$scope.viewModel.validPassword;
                validPassword.newPassword = '';
                validPassword.confirmPassword = '';
                validPassword.content = false;
                validPassword.format = false;
                validPassword.length = false;
                validPassword.match = false;
                this.verifyNewPassword();
            };
            NewPasswordDirectiveController.prototype.submitChangePasswordRequest = function () {
                if (typeof (this.$scope.key) !== 'undefined' && this.$scope.key !== null) {
                    // This is a request from a user who is not logged in (forgot password change request)
                    this.changeForgottenPassword();
                }
                else {
                    // This is a request from a user who is currently logged in
                    this.changeAccountPassword();
                }
            };
            NewPasswordDirectiveController.prototype.takeToLogin = function (email) {
                var _this = this;
                this.notificationService.success(zbuyer.messages.PasswordChangedRedirectToLogin);
                this.$timeout(function () {
                    _this.$window.location.href = "".concat(appConfiguration.baseUrl, "account/login?").concat(names.zbuyer.queryparameters.Email, "=").concat(email);
                }, RedirectDelay);
            };
            NewPasswordDirectiveController.prototype.verifyNewPassword = function () {
                if (typeof this.$scope.viewModel == 'undefined') {
                    return false;
                }
                var validPassword = this.$scope.viewModel.validPassword;
                var newPassword = validPassword.newPassword;
                var confirmPassword = validPassword.confirmPassword;
                if (typeof newPassword == 'undefined') {
                    return false;
                }
                validPassword.match = (newPassword == confirmPassword);
                validPassword.length = newPassword.length >= 8 && newPassword.length <= 20;
                validPassword.format = newPassword.indexOf(' ') == -1;
                validPassword.content = newPassword.search(/[A-Za-z]/) != -1 && newPassword.search(/[0-9]/) != -1;
                if (validPassword.content && validPassword.format && validPassword.length && validPassword.match) {
                    return true;
                }
                return false;
            };
            NewPasswordDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService
            ];
            return NewPasswordDirectiveController;
        }(controllers.ControllerBase));
        controllers.NewPasswordDirectiveController = NewPasswordDirectiveController;
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.NewPassword, NewPasswordDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/newsignupdirective.html';
        var NewSignupDirectiveController = /** @class */ (function (_super) {
            __extends(NewSignupDirectiveController, _super);
            function NewSignupDirectiveController($scope, $sce, crmService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.crmService = crmService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.initializeNewSignupDirectiveController();
                return _this;
            }
            NewSignupDirectiveController.prototype.initializeNewSignupDirectiveController = function () {
                var _this = this;
                zbuyer.analytics.FacebookPixel.track(zbuyer.analytics.FacebookPixel.NewSignupPixelID, 'New Signup');
                var scope = this.$scope;
                var blockId = 'load-crm-type';
                var initCrm = this.crmService.getDefaultType().then(function (response) {
                    scope.crmMessageBlockHtml = response.messageBlockHtml;
                    scope.crmConnectionType = response.crmConnectionType;
                }).catch(function (error) {
                    var errorMessageToDisplay;
                    if (typeof error == 'string') {
                        errorMessageToDisplay = error;
                    }
                    else {
                        console.error(error);
                        errorMessageToDisplay = 'An unexpected error has occurred. Please contact support.';
                    }
                    _this.notificationService.error(errorMessageToDisplay);
                }).finally(function () {
                    scope.doneLoading = true;
                });
                this.spinWaitService.blockDuring(initCrm, blockId);
            };
            NewSignupDirectiveController.prototype.configureCrm = function () {
                if (!this.$scope.crmConnectionType) {
                    console.error('No CRM Type available to configure');
                    return;
                }
                var scope = this.$scope;
                controllers.AddCrmModalController.loadModal(this.$scope.crmConnectionType).then(function (submitted) {
                    if (submitted) {
                        scope.crmCreated = true;
                    }
                });
            };
            NewSignupDirectiveController.prototype.trustHtml = function (html) {
                return this.$sce.trustAsHtml(html);
            };
            NewSignupDirectiveController.getDirective = function () {
                return {
                    controller: NewSignupDirectiveController,
                    restrict: 'E',
                    scope: {
                        closeCallback: '&onClose',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            NewSignupDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Sce,
                names.zbuyer.services.CrmService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService
            ];
            return NewSignupDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.NewSignup, NewSignupDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/paymentdirective.html';
        var PaymentDirectiveController = /** @class */ (function (_super) {
            __extends(PaymentDirectiveController, _super);
            function PaymentDirectiveController($scope, statesService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.statesService = statesService;
                _this.initializePaymentDirectiveController();
                return _this;
            }
            PaymentDirectiveController.getDirective = function () {
                return {
                    controller: PaymentDirectiveController,
                    restrict: 'E',
                    scope: {
                        billingAddressEnabled: '=',
                        paymentForm: '=',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            PaymentDirectiveController.prototype.initializePaymentDirectiveController = function () {
                var viewModel = this.$scope.viewModel;
                this.statesService.getStates().then(function (result) {
                    viewModel.states = result;
                });
            };
            PaymentDirectiveController.$inject = [
                names.angular.Scope,
                names.zbuyer.services.StatesService
            ];
            return PaymentDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.Payment, PaymentDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var vme = zbuyer.viewmodels.enums;
        var PreCheckoutController = /** @class */ (function (_super) {
            __extends(PreCheckoutController, _super);
            function PreCheckoutController($scope, $location, $timeout, $window, accountService, authenticationService, preCheckoutService, notificationService, animationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$location = $location;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.accountService = accountService;
                _this.authenticationService = authenticationService;
                _this.preCheckoutService = preCheckoutService;
                _this.notificationService = notificationService;
                _this.animationService = animationService;
                _this.initializeController();
                return _this;
            }
            Object.defineProperty(PreCheckoutController.prototype, "preCheckoutStep", {
                get: function () {
                    return vme.PreCheckoutStep;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(PreCheckoutController.prototype, "requestedActiveStep", {
                set: function (step) {
                    this.setActiveStep(step);
                },
                enumerable: false,
                configurable: true
            });
            PreCheckoutController.prototype.initializeController = function () {
                var _this = this;
                this.$scope.viewModel = preCheckoutViewModel;
                preCheckoutViewModel.processing = true;
                preCheckoutViewModel.workingAreaCounties = [];
                preCheckoutViewModel.workingAreaTitle = 'Working Area';
                preCheckoutViewModel.teamSizeOptions = [];
                this.authenticationService.getInitialAuthPromise().then(function (authenticated) {
                    if (!authenticated) {
                        // signup/precheckout requires an existing account
                        _this.$window.location.href = 'signup';
                        return;
                    }
                    var stepParameter = parseInt(_this.$location.search()[names.zbuyer.queryparameters.Step]);
                    if (!_this.setActiveStepFromParameter(stepParameter)) {
                        if (preCheckoutViewModel.step) {
                            _this.setActiveStep(preCheckoutViewModel.step, false);
                        }
                        else {
                            // No overriding URL parameter for step, so determine dynamically
                            _this.determineNextStep();
                        }
                    }
                    _this.$scope.$on('$locationChangeSuccess', function (event, newUrl) {
                        var newLocation = new URL(newUrl);
                        var newStep = parseInt(newLocation.searchParams.get(names.zbuyer.queryparameters.Step));
                        // Navigation operations (e.g. back-button) should update the UI when the step parameter changes
                        if (newStep != _this.$scope.viewModel.step) {
                            _this.$timeout(function () { return _this.setActiveStepFromParameter(newStep); });
                        }
                    });
                });
            };
            PreCheckoutController.prototype.continueToNextStep = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.processing = true;
                switch (viewModel.step) {
                    case vme.PreCheckoutStep.LeadType:
                        if (viewModel.questionStatuses) {
                            viewModel.questionStatuses.answeredLeadType = true;
                        }
                        this.determineNextStep(true);
                        return;
                    case vme.PreCheckoutStep.WorkingArea:
                        this.preCheckoutService.validateWorkingAreaDisplay(viewModel.workingAreaCounties)
                            .then(function (success) {
                            if (success) {
                                if (viewModel.questionStatuses) {
                                    viewModel.questionStatuses.answeredAreas = true;
                                }
                                _this.determineNextStep(true);
                            }
                        })
                            .catch(function (err) { return _this.handleError(err); });
                        return;
                    case vme.PreCheckoutStep.TeamSize:
                        this.preCheckoutService.setTeamSize(viewModel.teamSize)
                            .then(function () {
                            if (viewModel.questionStatuses) {
                                viewModel.questionStatuses.answeredTeamSize = true;
                            }
                            _this.determineNextStep(true);
                        })
                            .catch(function (err) { return _this.handleError(err); });
                        return;
                    case vme.PreCheckoutStep.BasicEdit:
                        var finalRecommendedPackage = viewModel.recommendedPackageViewModel;
                        if (!finalRecommendedPackage) {
                            this.handleError("No leads package has been created. Please reload the page.");
                        }
                        var validateRequest = {
                            counties: finalRecommendedPackage.counties,
                            sellerLeadCount: finalRecommendedPackage.sellerLeadCount,
                            buyerLeadCount: finalRecommendedPackage.buyerLeadCount,
                            totalPriceUSD: finalRecommendedPackage.totalPriceUSD
                        };
                        this.preCheckoutService.validateRecommendedPackageDisplay(validateRequest)
                            .then(function (response) {
                            if (response.success) {
                                _this.$window.location.href = 'account/subscription?checkout=true';
                                return;
                            }
                            _this.handleError(response.errorMessageToDisplay);
                        })
                            .catch(function (err) { return _this.handleError(err); });
                        return;
                    case vme.PreCheckoutStep.AdvancedEdit:
                        this.$window.location.href = 'account/subscription?checkout=true';
                        return;
                    default:
                        this.handleError("Unable to process signup step");
                        break;
                }
                viewModel.processing = false;
                this.setActiveStep(viewModel.step + 1, true);
            };
            PreCheckoutController.prototype.determineNextStep = function (isTransition) {
                var _this = this;
                if (isTransition === void 0) { isTransition = false; }
                var viewModel = this.$scope.viewModel;
                var questionStatuses = viewModel.questionStatuses;
                if (!questionStatuses) {
                    this.preCheckoutService.getQuestionStatuses()
                        .then(function (response) {
                        if (!response.success) {
                            throw 'Failed to get question statuses';
                        }
                        viewModel.questionStatuses = response;
                        // Recurse now with valid question statuses attached to model
                        _this.determineNextStep(isTransition);
                    })
                        .catch(function (err) {
                        _this.handleError(err);
                        viewModel.step = vme.PreCheckoutStep.LeadType;
                        _this.setActiveStep(viewModel.step, isTransition);
                    });
                    return;
                }
                if (!questionStatuses.answeredLeadType) {
                    this.setActiveStep(vme.PreCheckoutStep.LeadType, true);
                }
                else if (!questionStatuses.answeredAreas) {
                    this.setActiveStep(vme.PreCheckoutStep.WorkingArea, true);
                }
                else if (!questionStatuses.answeredTeamSize) {
                    this.setActiveStep(vme.PreCheckoutStep.TeamSize, true);
                }
                else {
                    this.setActiveStep(vme.PreCheckoutStep.BasicEdit, true);
                }
            };
            PreCheckoutController.prototype.goToBasicEdit = function () {
                this.setActiveStep(vme.PreCheckoutStep.BasicEdit, false);
            };
            PreCheckoutController.prototype.handleError = function (error) {
                this.$window.scrollTo(this.$window.scrollX, 0);
                var viewModel = this.$scope.viewModel;
                if (typeof error == 'string') {
                    viewModel.errorMessageToDisplay = error;
                }
                else {
                    viewModel.errorMessageToDisplay = 'An unexpected error has occurred. Please refresh the page.';
                    console.log(error);
                }
                this.notificationService.error(viewModel.errorMessageToDisplay);
                viewModel.processing = false;
            };
            PreCheckoutController.prototype.setActiveStep = function (nextStep, isTransition) {
                var _this = this;
                if (isTransition === void 0) { isTransition = false; }
                var viewModel = this.$scope.viewModel;
                viewModel.processing = true;
                viewModel.step = nextStep;
                var stepParameter = parseInt(this.$location.search()[names.zbuyer.queryparameters.Step]);
                if (stepParameter != viewModel.step) {
                    // Ensure URL reflects new step
                    this.$location.search(names.zbuyer.queryparameters.Step, viewModel.step);
                    if (!stepParameter || stepParameter < vme.PreCheckoutStep.LeadType || stepParameter > vme.PreCheckoutStep.AdvancedEdit) {
                        // Forget history if URL parameter was never valid
                        this.$location.replace();
                    }
                }
                switch (viewModel.step) {
                    case vme.PreCheckoutStep.LeadType:
                        viewModel.fullName = 'New User';
                        this.accountService.getAccountProfile()
                            .then(function (accountInfo) {
                            viewModel.fullName = "".concat(accountInfo.account.firstName, " ").concat(accountInfo.account.lastName);
                            _this.readyForStep(isTransition);
                        })
                            .catch(function (err) {
                            isTransition = false;
                            _this.handleError(err);
                        });
                        return;
                    case vme.PreCheckoutStep.WorkingArea:
                        viewModel.workingAreaCounties = [];
                        viewModel.workingAreaTitle = 'Working Area';
                        this.preCheckoutService.getCurrentWorkingArea()
                            .then(function (response) {
                            viewModel.workingAreaCounties = response.counties;
                            viewModel.workingAreaTitle = response.areaTitle;
                            _this.readyForStep(isTransition);
                        })
                            .catch(function (err) {
                            _this.handleError(err);
                        });
                        return;
                    case vme.PreCheckoutStep.TeamSize:
                        this.preCheckoutService.getTeamSize()
                            .then(function (teamSizeInfo) {
                            viewModel.teamSize = teamSizeInfo.currentTeamSize;
                            viewModel.teamSizeOptions = teamSizeInfo.teamSizeOptions;
                            _this.readyForStep(isTransition);
                        })
                            .catch(function (err) {
                            viewModel.teamSize = null;
                            viewModel.teamSizeOptions = [];
                            _this.handleError(err);
                        });
                        return;
                    case vme.PreCheckoutStep.BasicEdit:
                        viewModel.recommendedPackageViewModel = null;
                        this.preCheckoutService.getRecommendedPackage()
                            .then(function (response) {
                            if (response.advancedModeRequired) {
                                _this.setActiveStep(vme.PreCheckoutStep.AdvancedEdit, isTransition);
                                return;
                            }
                            viewModel.recommendedPackageViewModel = response;
                            _this.readyForStep(isTransition);
                        })
                            .catch(function (err) {
                            _this.handleError(err);
                        });
                        return;
                    case vme.PreCheckoutStep.AdvancedEdit:
                        viewModel.advancedPackageData = null;
                        this.preCheckoutService.getAdvancedPackage()
                            .then(function (response) {
                            viewModel.advancedPackageData = response;
                            _this.readyForStep(isTransition);
                        })
                            .catch(function (err) {
                            _this.handleError(err);
                        });
                        return;
                    default:
                        this.handleError("Unable to proceed to signup step");
                        return;
                }
                this.readyForStep(isTransition);
            };
            PreCheckoutController.prototype.setActiveStepFromParameter = function (stepParameter) {
                var viewModel = this.$scope.viewModel;
                if (stepParameter >= vme.PreCheckoutStep.LeadType && stepParameter <= vme.PreCheckoutStep.AdvancedEdit) {
                    if (stepParameter != viewModel.step) {
                        this.setActiveStep(stepParameter);
                        return true;
                    }
                }
                return false;
            };
            PreCheckoutController.prototype.readyForStep = function (animate) {
                var viewModel = this.$scope.viewModel;
                this.$window.scrollTo(this.$window.scrollX, 0);
                if (animate) {
                    var stepElement = document.querySelector('.step');
                    this.animationService.animateElement(stepElement, 'slideInUp', function () { });
                    // Ensure view is showing (after allowing animation to start)
                    this.$timeout(function () {
                        viewModel.processing = false;
                    });
                }
                else {
                    viewModel.processing = false;
                }
            };
            PreCheckoutController.prototype.continueWithLeadTypes = function (preferSellers, preferBuyers) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.processing = true;
                this.preCheckoutService.setLeadTypePreference(preferSellers, preferBuyers)
                    .then(function () {
                    viewModel.preferSellers = preferSellers;
                    viewModel.preferBuyers = preferBuyers;
                    _this.continueToNextStep();
                })
                    .catch(function (err) { return _this.handleError(err); });
            };
            PreCheckoutController.prototype.removeCounty = function (county) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var indexToRemove = viewModel.workingAreaCounties.indexOf(county);
                if (indexToRemove >= 0) {
                    viewModel.workingAreaCounties.splice(indexToRemove, 1);
                    this.preCheckoutService.removeCountyFromWorkingArea(county)
                        .catch(function (err) {
                        // Add back to array if it failed
                        viewModel.workingAreaCounties.splice(indexToRemove, 0, county);
                        _this.handleError(err);
                    });
                }
            };
            PreCheckoutController.prototype.showCountySelectModal = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                controllers.SelectCountyModalController.loadModal(viewModel.workingAreaCounties)
                    .then(function (selectedCounty) {
                    if (!selectedCounty) {
                        return;
                    }
                    viewModel.workingAreaCounties.push(selectedCounty);
                    return _this.preCheckoutService.addCountyToWorkingArea(selectedCounty);
                })
                    .catch(function (err) { return _this.handleError(err); });
            };
            PreCheckoutController.prototype.showLearnMoreModal = function (track) {
                controllers.LearnMoreModalController.loadModal(track);
            };
            PreCheckoutController.prototype.showMetroSelectModal = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                // Get selected metro from modal, add to working area, and refresh working area counties directly from API
                controllers.SelectMetroModalController.loadModal()
                    .then(function (selectedMetroArea) {
                    var _a;
                    if (!selectedMetroArea) {
                        return;
                    }
                    // Immediately add counties based on expected result of actual adding the metro area
                    var newCounties = selectedMetroArea.counties.filter(function (metroCounty) {
                        return !viewModel.workingAreaCounties.some(function (county) {
                            return county.name == metroCounty.name && county.stateAbbreviation == metroCounty.stateAbbreviation;
                        });
                    });
                    (_a = viewModel.workingAreaCounties).push.apply(_a, newCounties);
                    return _this.preCheckoutService.addMetroAreaToWorkingArea(selectedMetroArea)
                        .then(function () {
                        return _this.preCheckoutService.getCurrentWorkingArea()
                            .then(function (response) {
                            viewModel.workingAreaTitle = response.areaTitle;
                        })
                            // Tolerate not getting working area title - not critical
                            .catch(function (err) { return console.log(err); });
                    });
                })
                    .catch(function (err) { return _this.handleError(err); });
            };
            PreCheckoutController.$inject = [
                names.angular.Scope,
                names.angular.Location,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.AuthenticationService,
                names.zbuyer.services.CheckoutHelperService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.ui.services.AnimationService
            ];
            return PreCheckoutController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .factory('preCheckoutViewModel', function () { return preCheckoutViewModel; })
            .controller(names.zbuyer.controllers.PreCheckoutController, PreCheckoutController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/recommendedpackagecountybreakdownmodal.html';
        var RecommendedPackageCountyBreakdownController = /** @class */ (function () {
            function RecommendedPackageCountyBreakdownController() {
            }
            RecommendedPackageCountyBreakdownController.getController = function () {
                return {
                    controller: RecommendedPackageCountyBreakdownController,
                    bindings: {
                        $uibModalInstance: "<modalInstance",
                        resolve: '<'
                    },
                    templateUrl: TemplateUrl
                };
            };
            RecommendedPackageCountyBreakdownController.prototype.modalClose = function () {
                this.$uibModalInstance.close();
            };
            RecommendedPackageCountyBreakdownController.loadModal = function (counties) {
                var $injector = angular.element('html').injector();
                var $uibModel = $injector.get(names.angular.UiBootstrapModal);
                var $q = $injector.get(names.angular.Q);
                var modalInstance = $uibModel.open({
                    backdropClass: 'recommended-package-county-breakdown-modal-backdrop',
                    component: names.zbuyer.components.RecommendedPackageCountyBreakdownComponent,
                    resolve: {
                        counties: function () { return counties; }
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'recommended-package-county-breakdown-modal'
                });
                return modalInstance.result.then(function (result) { return $q.resolve(result); });
            };
            return RecommendedPackageCountyBreakdownController;
        }());
        controllers.RecommendedPackageCountyBreakdownController = RecommendedPackageCountyBreakdownController;
        angular.module(names.zbuyer.Application)
            .component(names.zbuyer.components.RecommendedPackageCountyBreakdownComponent, RecommendedPackageCountyBreakdownController.getController());
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/selectcountymodal.html';
        var SelectCountyModalController = /** @class */ (function (_super) {
            __extends(SelectCountyModalController, _super);
            function SelectCountyModalController($scope, $q, $uibModalInstance, preCheckoutService, modalService, selectCountiesViewModel) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$q = $q;
                _this.$uibModalInstance = $uibModalInstance;
                _this.preCheckoutService = preCheckoutService;
                _this.modalService = modalService;
                _this.selectCountiesViewModel = selectCountiesViewModel;
                modalService.handleCloseActions($scope, $uibModalInstance);
                $scope.viewModel = selectCountiesViewModel;
                return _this;
            }
            SelectCountyModalController.loadModal = function (countiesAlreadySelected) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var $q = $injector.get(names.angular.Q);
                var modalInstance = $uibModal.open({
                    controller: names.zbuyer.controllers.SelectCountyModalController,
                    resolve: {
                        selectCountyViewModel: {
                            previouslySelectedCounties: countiesAlreadySelected !== null && countiesAlreadySelected !== void 0 ? countiesAlreadySelected : [],
                            states: zbuyer.models.State.usStates
                        }
                    },
                    size: 'md',
                    templateUrl: TemplateUrl
                });
                return modalInstance.result.then(function (county) { return $q.resolve(county); });
            };
            SelectCountyModalController.prototype.countySelected = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.selectedCountyAlreadyAdded = viewModel.previouslySelectedCounties.some(function (county) { return county.stateAbbreviation == viewModel.selectedCounty.stateAbbreviation && county.name == viewModel.selectedCounty.name; });
            };
            SelectCountyModalController.prototype.stateSelected = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.selectedCountyAlreadyAdded = false;
                viewModel.selectedCounty = null;
                return this.fillCounties(viewModel.selectedState.abbreviation);
            };
            SelectCountyModalController.prototype.fillCounties = function (stateAbbreviation) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.countiesForState = null;
                return this.preCheckoutService.getCountiesForState(stateAbbreviation)
                    .then(function (counties) {
                    // Make sure request is still applicable
                    if (counties && counties.some(function (county) { return county.stateAbbreviation == viewModel.selectedState.abbreviation; })) {
                        viewModel.countiesForState = counties;
                    }
                    return _this.$q.resolve();
                })
                    .catch(function (err) {
                    if (typeof err === 'string') {
                        alert(err);
                    }
                });
            };
            SelectCountyModalController.prototype.close = function (selectedCounty) {
                this.$uibModalInstance.close(selectedCounty);
            };
            SelectCountyModalController.$inject = [
                names.angular.Scope,
                names.angular.Q,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.CheckoutHelperService,
                names.zbuyer.services.ModalService,
                'selectCountyViewModel'
            ];
            return SelectCountyModalController;
        }(controllers.ControllerBase));
        controllers.SelectCountyModalController = SelectCountyModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.SelectCountyModalController, SelectCountyModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/selectmetromodal.html';
        var SelectMetroModalController = /** @class */ (function (_super) {
            __extends(SelectMetroModalController, _super);
            function SelectMetroModalController($scope, $q, $uibModalInstance, preCheckoutService, modalService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$q = $q;
                _this.$uibModalInstance = $uibModalInstance;
                _this.preCheckoutService = preCheckoutService;
                _this.modalService = modalService;
                modalService.handleCloseActions($scope, $uibModalInstance);
                _this.$scope.viewModel = { states: zbuyer.models.State.usStates };
                return _this;
            }
            SelectMetroModalController.loadModal = function () {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var $q = $injector.get(names.angular.Q);
                var modalInstance = $uibModal.open({
                    controller: names.zbuyer.controllers.SelectMetroModalController,
                    size: 'md',
                    templateUrl: TemplateUrl
                });
                return modalInstance.result.then(function (metroArea) { return $q.resolve(metroArea); });
            };
            SelectMetroModalController.prototype.stateSelected = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.selectedMetro = null;
                return this.fillMetroAreas(viewModel.selectedState.abbreviation);
            };
            SelectMetroModalController.prototype.fillMetroAreas = function (stateAbbreviation) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                return this.preCheckoutService.getMetroAreasForState(stateAbbreviation)
                    .then(function (metros) {
                    // Make sure request is still applicable
                    if (metros && metros.some(function (metro) { return metro.stateCode == viewModel.selectedState.abbreviation; })) {
                        viewModel.metrosForState = metros;
                    }
                    return _this.$q.resolve();
                })
                    .catch(function (err) {
                    if (typeof err === 'string') {
                        alert(err);
                    }
                });
            };
            SelectMetroModalController.prototype.close = function (selectedMetro) {
                this.$uibModalInstance.close(selectedMetro);
            };
            SelectMetroModalController.$inject = [
                names.angular.Scope,
                names.angular.Q,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.CheckoutHelperService,
                names.zbuyer.services.ModalService
            ];
            return SelectMetroModalController;
        }(controllers.ControllerBase));
        controllers.SelectMetroModalController = SelectMetroModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.SelectMetroModalController, SelectMetroModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var vme = zbuyer.viewmodels.enums;
        var SignupStepElement = '.signup-step';
        var EmailRegExp = /^([\w-+\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,11}|[0-9]{1,3})(\]?)$/;
        var SignupController = /** @class */ (function (_super) {
            __extends(SignupController, _super);
            function SignupController($scope, $cookies, $location, $q, $timeout, $window, appConfiguration, accountService, authenticationService, notificationService, signupService, spinWaitService, animationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$cookies = $cookies;
                _this.$location = $location;
                _this.$q = $q;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.appConfiguration = appConfiguration;
                _this.accountService = accountService;
                _this.authenticationService = authenticationService;
                _this.notificationService = notificationService;
                _this.signupService = signupService;
                _this.spinWaitService = spinWaitService;
                _this.animationService = animationService;
                _this.initializeSignupController();
                return _this;
            }
            Object.defineProperty(SignupController.prototype, "signupStep", {
                get: function () {
                    return vme.SignupStep;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(SignupController.prototype, "isContactInfoStep", {
                get: function () {
                    return this.$scope.viewModel.signupStep == vme.SignupStep.ContactInfo;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(SignupController.prototype, "isLocationInfoStep", {
                get: function () {
                    return this.$scope.viewModel.signupStep == vme.SignupStep.LocationInfo;
                },
                enumerable: false,
                configurable: true
            });
            SignupController.prototype.initializeSignupController = function () {
                var _this = this;
                this.$scope.viewModel = signupViewModel;
                this.$scope.emailRegExp = EmailRegExp;
                signupViewModel.signupProcessing = true;
                signupViewModel.signupStep = vme.SignupStep.ContactInfo;
                this.authenticationService.getInitialAuthPromise().then(function (authenticated) {
                    _this.initializeAccountViewModel(authenticated).then(function () {
                        _this.determineActiveStep(authenticated);
                    });
                });
            };
            SignupController.prototype.animateNextStep = function (element, callback) {
                this.animationService.animateElement(element, 'slideInUp', callback);
            };
            /**
             * "Continue" button handler, processes results of current step and advances
             * to next step where applicable.
             *
             * */
            SignupController.prototype.continueSignup = function () {
                var viewModel = this.$scope.viewModel;
                var accountController = this.getAccountController();
                switch (viewModel.signupStep) {
                    case vme.SignupStep.ContactInfo:
                        if (this.$scope.contactInfoForm.$invalid) {
                            this.$scope.validate = true;
                            return; // Not ready for next step
                        }
                        // Convert full name to separate data values to be sent
                        var firstSpaceIndex = viewModel.fullName.indexOf(' ');
                        viewModel.accountViewModel.account.firstName = viewModel.fullName.slice(0, firstSpaceIndex);
                        viewModel.accountViewModel.account.lastName = viewModel.fullName.slice(firstSpaceIndex + 1);
                        break;
                    case vme.SignupStep.LocationInfo:
                        if (this.$scope.locationInfoForm.$invalid) {
                            this.$scope.validate = true;
                            return; // Not ready for next step
                        }
                        break;
                    case vme.SignupStep.Password:
                        this.createAccount();
                        return; // Expected to redirect or have error
                    case vme.SignupStep.Subscription:
                        return; // No next step, shouldn't be here
                }
                this.setActiveStep(viewModel.signupStep + 1);
            };
            SignupController.prototype.createAccount = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var newPasswordController = this.getNewPasswordController();
                if (newPasswordController.invalidPassword()) {
                    return;
                }
                var password = newPasswordController.getNewPassword();
                var account = viewModel.accountViewModel.account;
                var createAccountRequest = {
                    address: account.address,
                    campaignNumber: parseInt(this.$location.search()[names.zbuyer.queryparameters.CampaignNumber]) || null,
                    companyName: account.company,
                    email: account.email,
                    firstName: account.firstName,
                    lastName: account.lastName,
                    memberType: account.memberType,
                    password: password,
                    phoneNumber: { fullNumber: account.phone.replace(/\W+/g, '') },
                    viewId: this.$cookies.get(names.zbuyer.cookies.ViewId)
                };
                var blockUiName = 'SignupLogin';
                this.spinWaitService.block(blockUiName);
                this.signupService.newSignup(createAccountRequest).then(function (response) {
                    if (!response.isNewAccount) {
                        if (!response.canLogin) {
                            _this.scrollToTop();
                            viewModel.signupException = true;
                            _this.animationService.animateElement(document.querySelector('.signup-exception'), 'slideInUp', function () { });
                            return;
                        }
                        // Otherwise, user attempted to re-register, so go ahead and sign them in
                    }
                    // Send back into signup, now authenticated, to set up rest of account
                    return _this.authenticationService.loginWithUserNameAndPassword(account.email, password).then(function (token) {
                        _this.$window.location.reload();
                    }).catch(function (reason) {
                        _this.notificationService.error(reason.data.error_description, zbuyer.messages.LoginFailed);
                    }).finally(function () {
                        _this.$cookies.remove(names.zbuyer.cookies.ViewId);
                    });
                }).catch(function (response) {
                    _this.notificationService.error(zbuyer.messages.SignupError, zbuyer.messages.ApplicationTitle);
                }).finally(function () { return _this.spinWaitService.unblock(blockUiName); });
            };
            SignupController.prototype.determineActiveStep = function (accountCreated) {
                var signupViewModel = this.$scope.viewModel;
                if (!accountCreated) {
                    // No account yet. Note: Account view model will be used for first steps but not account directive
                    var account = signupViewModel.accountViewModel.account = {};
                    account.address = {};
                    // Use any query parameters providing profile info
                    account.firstName = this.$location.search()[names.zbuyer.queryparameters.FirstName] || '';
                    account.lastName = this.$location.search()[names.zbuyer.queryparameters.LastName] || '';
                    account.phone = this.$location.search()[names.zbuyer.queryparameters.Phone] || '';
                    account.email = this.$location.search()[names.zbuyer.queryparameters.Email] || '';
                    account.address.zipCode = this.$location.search()[names.zbuyer.queryparameters.Zip] || '';
                    if (account.email && account.email.match(EmailRegExp)) {
                        this.$scope.hideEmail = true;
                    }
                    // Set up single field for first and last name (will be split into firstName/lastName on submit)
                    signupViewModel.fullName = "".concat(account.firstName, " ").concat(account.lastName).trim();
                    this.sendLandingToApi();
                    this.setActiveStep(vme.SignupStep.ContactInfo);
                }
                else {
                    // Account has been created - continue steps
                    var accountViewModel = this.$scope.viewModel.accountViewModel;
                    if (!accountViewModel.account.subscription) {
                        this.setActiveStep(vme.SignupStep.Subscription);
                    }
                    else {
                        // Nothing to do in signup: account already fully created and subscribed
                        this.$window.location.href = this.appConfiguration.baseUrl;
                    }
                }
                var account = signupViewModel.accountViewModel.account;
            };
            SignupController.prototype.displaySignupException = function () {
                this.scrollToTop();
                var viewModel = this.$scope.viewModel;
                viewModel.signupException = true;
                viewModel.signupProcessing = false;
                this.animationService.animateElement(document.querySelector('.signup-exception'), 'slideInUp', function () { });
            };
            SignupController.prototype.getAccountController = function () {
                var accountDirectiveElement = angular.element(controllers.AccountDirectiveElement)[0];
                var controller = SignupController.getControllerFromSourceElement(accountDirectiveElement, names.zbuyer.directives.Account);
                return controller;
            };
            SignupController.prototype.getNewPasswordController = function () {
                var newPasswordDirectiveElement = angular.element(controllers.NewPasswordDirectiveElement)[0];
                var controller = SignupController.getControllerFromSourceElement(newPasswordDirectiveElement, names.zbuyer.directives.NewPassword);
                return controller;
            };
            SignupController.prototype.initializeAccountViewModel = function (authenticated) {
                var _this = this;
                var deferred = this.$q.defer();
                var signupViewModel = this.$scope.viewModel;
                var accountViewModel = signupViewModel.accountViewModel = {
                    subscriptionViewModel: {},
                    isEditingEnabled: true,
                    subscriptionEditViewModel: {},
                    cartBuilderViewModel: {}
                };
                if (!authenticated) {
                    // No account will exist, but ensure member type options are available for initial signup steps
                    this.accountService.getMemberTypes().then(function (result) {
                        accountViewModel.memberTypes = result.memberTypes;
                    });
                    deferred.resolve();
                    return deferred.promise;
                }
                this.accountService.getAccountProfile().then(function (result) {
                    accountViewModel.account = result.account;
                    accountViewModel.subscriptionViewModel.account = result.account;
                    accountViewModel.subscriptionEditViewModel.account = result.account;
                    accountViewModel.memberTypes = result.memberTypes;
                    // Already collected from form, but may be used for live chat plugin
                    signupViewModel.fullName = "".concat(result.account.firstName, " ").concat(result.account.lastName).trim();
                    deferred.resolve();
                }).catch(function (response) {
                    _this.notificationService.error(response.data.message, zbuyer.messages.ApplicationTitle);
                    deferred.reject();
                });
                this.accountService.getInvestorNotificationEmails().then(function (result) {
                    accountViewModel.investorNotificationEmails = result.investorNotificationEmails;
                }).catch(function (response) {
                    _this.notificationService.error(response.data.message, zbuyer.messages.ApplicationTitle);
                });
                return deferred.promise;
            };
            SignupController.prototype.redirectToLogin = function () {
                this.$window.location.href = 'account/login';
            };
            SignupController.prototype.scrollToTop = function () {
                this.$window.scrollTo(this.$window.scrollX, 0);
            };
            SignupController.prototype.sendLandingToApi = function () {
                var _this = this;
                var storedViewId = this.$cookies.get(names.zbuyer.cookies.ViewId);
                if (typeof storedViewId !== 'undefined') {
                    return;
                }
                var viewModel = this.$scope.viewModel;
                var request = {
                    authCode: this.$location.search()[names.zbuyer.queryparameters.AuthCode],
                    campaignNumber: parseInt(this.$location.search()[names.zbuyer.queryparameters.CampaignNumber]) || null,
                    clickTrackId: parseInt(this.$location.search()[names.zbuyer.queryparameters.ClickTrackId]) || null,
                    publisherId: this.$location.search()[names.zbuyer.queryparameters.PublisherId],
                    referrer: this.$location.search()[names.zbuyer.queryparameters.Referrer] || viewModel.referrer,
                    viewId: storedViewId
                };
                this.signupService.sendLanding(request).then(function (response) {
                    _this.$cookies.put(names.zbuyer.cookies.ViewId, response.viewId.toString());
                    viewModel.signupFailed = false;
                }).catch(function (reason) {
                    _this.notificationService.error(zbuyer.messages.ViewIdError, zbuyer.messages.ApplicationTitle);
                    viewModel.signupFailed = true;
                });
            };
            /**
             * Sets next active sign step in UI and activates relevant area in account view
             *
             * @param nextStep - signup step to become active
             */
            SignupController.prototype.setActiveStep = function (nextStep) {
                var accountController = this.getAccountController();
                var viewModel = this.$scope.viewModel;
                viewModel.signupStep = nextStep;
                var isTransition = true;
                switch (viewModel.signupStep) {
                    case vme.SignupStep.ContactInfo:
                        isTransition = false;
                        this.$scope.validate = false;
                        break;
                    case vme.SignupStep.LocationInfo:
                        this.$scope.validate = false;
                        break;
                    case vme.SignupStep.Password:
                        var newPasswordController = this.getNewPasswordController();
                        newPasswordController.newPasswordFocus();
                        accountController.showChangePassword();
                        break;
                    case vme.SignupStep.Subscription:
                        accountController.showAccountSubscription();
                        break;
                }
                if (isTransition) {
                    this.animateNextStep(document.querySelector(SignupStepElement), function () { });
                    // Ensure view is showing (after allowing animation to start)
                    this.$timeout(function () {
                        viewModel.signupProcessing = false;
                    });
                }
                else {
                    viewModel.signupProcessing = false;
                }
            };
            SignupController.prototype.signupEmailDuplicate = function () {
                this.startOver();
                this.animateNextStep(document.querySelector(SignupStepElement), function () { });
            };
            SignupController.prototype.startOver = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.signupStep = vme.SignupStep.ContactInfo;
                viewModel.signupException = false;
                viewModel.signupProcessing = false;
            };
            SignupController.prototype.updateChatInfo = function () {
                var viewModel = this.$scope.viewModel;
            };
            SignupController.$inject = [
                names.angular.Scope,
                names.angular.Cookies,
                names.angular.Location,
                names.angular.Q,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.AppConfiguration,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.AuthenticationService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SignupService,
                names.zbuyer.services.SpinWaitService,
                names.zbuyer.ui.services.AnimationService
            ];
            return SignupController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .factory('signupViewModel', function () { return signupViewModel; })
            .controller(names.zbuyer.controllers.SignupController, SignupController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/sitefooterdirective.html';
        var SiteFooterDirectiveController = /** @class */ (function (_super) {
            __extends(SiteFooterDirectiveController, _super);
            function SiteFooterDirectiveController($scope, appSettingsService, notificationService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.appSettingsService = appSettingsService;
                _this.notificationService = notificationService;
                _this.initializeSiteFooterDirective();
                return _this;
            }
            SiteFooterDirectiveController.getDirective = function () {
                return {
                    controller: SiteFooterDirectiveController,
                    restrict: 'E',
                    scope: {
                        minimal: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            SiteFooterDirectiveController.prototype.initializeSiteFooterDirective = function () {
                var _this = this;
                this.$scope.viewModel = {};
                this.appSettingsService.getAppSettings().then(function (settings) {
                    _this.$scope.viewModel = settings;
                }).catch(function (err) {
                    console.debug(err);
                    _this.notificationService.error(zbuyer.messages.AppSettingsError, zbuyer.messages.ApplicationTitle);
                });
            };
            SiteFooterDirectiveController.prototype.getCopyrightYear = function () {
                var date = new Date();
                return date.getFullYear().toString();
            };
            SiteFooterDirectiveController.$inject = [
                names.angular.Scope,
                names.zbuyer.services.AppSettingsService,
                names.zbuyer.services.NotificationService
            ];
            return SiteFooterDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.SiteFooter, SiteFooterDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/subscriptiondirective.html';
        var SubscriptionDirectiveController = /** @class */ (function (_super) {
            __extends(SubscriptionDirectiveController, _super);
            function SubscriptionDirectiveController($scope, $sce, $window, appSettingsService, checkoutService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$sce = $sce;
                _this.$window = $window;
                _this.appSettingsService = appSettingsService;
                _this.checkoutService = checkoutService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.initializeSubscriptionDirectiveController();
                return _this;
            }
            SubscriptionDirectiveController.getDirective = function () {
                return {
                    controller: SubscriptionDirectiveController,
                    restrict: 'E',
                    scope: {
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            SubscriptionDirectiveController.prototype.initializeSubscriptionDirectiveController = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.paymentViewModel = {};
                this.setAppSettings();
                this.setSubscriptionDetails();
            };
            SubscriptionDirectiveController.prototype.cancelUpdatePayment = function () {
                this.resetUpdatePaymentForm();
            };
            SubscriptionDirectiveController.prototype.resetUpdatePaymentForm = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.editPayment = false;
                viewModel.updatePaymentErrorMessage = null;
                viewModel.paymentForm.$setPristine();
                viewModel.paymentViewModel = {};
            };
            SubscriptionDirectiveController.prototype.setAppSettings = function () {
                var _this = this;
                this.appSettingsService.getAppSettings().then(function (settings) {
                    _this.$scope.appSettings = settings;
                }).catch(function (response) {
                    _this.notificationService.error(response.data.message, zbuyer.messages.ApplicationTitle);
                });
            };
            SubscriptionDirectiveController.prototype.setSubscriptionDetails = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                this.checkoutService.getSubscriptionStatusAndLocationsHtml().then(function (result) {
                    viewModel.locationAreasHtml = _this.$sce.trustAsHtml(result.locationAreasHtml);
                    viewModel.subscriptionStatusHtml = _this.$sce.trustAsHtml(result.subscriptionStatusHtml);
                });
            };
            SubscriptionDirectiveController.prototype.updatePayment = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (viewModel.paymentForm.$invalid) {
                    return;
                }
                var blockId = 'SubscriptionUpdatePayment';
                this.spinWaitService.block(blockId, names.misc.BlockUISpinnerCheckmarkClass, zbuyer.messages.UpdatingPayment);
                var request = {
                    billingCity: viewModel.paymentViewModel.billingCity,
                    billingState: viewModel.paymentViewModel.billingState.abbreviation,
                    billingStreet: viewModel.paymentViewModel.billingStreet,
                    billingZipCode: viewModel.paymentViewModel.billingZipCode,
                    cardCVV2: viewModel.paymentViewModel.cardCVV2,
                    cardExpirationMonth: viewModel.paymentViewModel.cardExpirationMonth,
                    cardExpirationYear: viewModel.paymentViewModel.cardExpirationYear,
                    cardNumber: viewModel.paymentViewModel.cardNumber.replace(/ /g, '')
                };
                this.checkoutService.updateCreditCard(request).then(function (result) {
                    if (result.success) {
                        _this.notificationService.success(zbuyer.messages.PaymentUpdatedSuccess);
                        _this.resetUpdatePaymentForm();
                        _this.setSubscriptionDetails();
                    }
                    else {
                        viewModel.updatePaymentErrorMessage = result.errorMessageToDisplay;
                        _this.notificationService.error(result.errorMessageToDisplay);
                    }
                }).catch(function (reason) {
                    viewModel.updatePaymentErrorMessage = zbuyer.messages.ErrorUpdatingPayment;
                    _this.notificationService.error(zbuyer.messages.ErrorUpdatingPayment);
                }).finally(function () {
                    _this.spinWaitService.unblock(blockId);
                });
            };
            SubscriptionDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Sce,
                names.angular.Window,
                names.zbuyer.services.AppSettingsService,
                names.zbuyer.services.CheckoutService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService
            ];
            return SubscriptionDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.Subscription, SubscriptionDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var me = zbuyer.models.enums;
        var TemplateUrl = 'staticpages/directives/subscriptioneditdirective.html';
        var CartFlashTimeoutMillis = 1000; // Time to block UI with indication on "cart updated"
        var BuyerLeadsPerPeriodMinimum = 20;
        var SubscriptionEditDirectiveController = /** @class */ (function (_super) {
            __extends(SubscriptionEditDirectiveController, _super);
            function SubscriptionEditDirectiveController($scope, $filter, $location, $q, $timeout, $window, checkoutService, countiesService, countyPackagesService, countyStatisticsService, spinWaitService, statesService, subscriptionService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$filter = $filter;
                _this.$location = $location;
                _this.$q = $q;
                _this.$timeout = $timeout;
                _this.$window = $window;
                _this.checkoutService = checkoutService;
                _this.countiesService = countiesService;
                _this.countyPackagesService = countyPackagesService;
                _this.countyStatisticsService = countyStatisticsService;
                _this.spinWaitService = spinWaitService;
                _this.statesService = statesService;
                _this.subscriptionService = subscriptionService;
                _this.initializeSubscriptionEditDirectiveController();
                return _this;
            }
            SubscriptionEditDirectiveController.getDirective = function () {
                return {
                    controller: SubscriptionEditDirectiveController,
                    restrict: 'E',
                    scope: {
                        checkoutCallback: '&onCheckout',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            SubscriptionEditDirectiveController.prototype.initializeSubscriptionEditDirectiveController = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.sellerLeadsPerMonth = 0;
                this.$scope.losAngelesSubdivided = { county: 'Los Angeles (Subdivided)', state: 'CA' };
                this.showOverlayDuring(function () {
                    return _this.statesService.getStates().then(function (result) {
                        viewModel.states = result;
                        if (!viewModel.account.address) {
                            return _this.$q.resolve();
                        }
                        return _this.selectCountyByZip(viewModel.account.address.zipCode);
                    });
                });
                this.setupCart();
                var checkoutFlag = this.$location.search()[names.zbuyer.queryparameters.Checkout];
                if (checkoutFlag) {
                    if (checkoutFlag.toLowerCase() === true.toString()) {
                        // Flag indicates we want to go straight to checkout
                        this.$timeout(function () { return _this.cartCheckout(); });
                    }
                }
            };
            SubscriptionEditDirectiveController.prototype.cartCheckout = function () {
                this.$scope.checkoutCallback();
            };
            SubscriptionEditDirectiveController.prototype.cartItemDescription = function (cartItem) {
                var memberAreaPending = cartItem.memberAreaPending;
                var quantity = '';
                var leadType;
                var detail;
                var plural = '';
                var packageSize = this.getPackageSize(memberAreaPending, cartItem.type);
                if (packageSize > 0) {
                    quantity = "".concat(packageSize, " ");
                }
                if (packageSize > 1 || packageSize === 0) {
                    // Note: packageSize 0 is valid for a plural since 0 indicates "no lead(s)", and no number is shown
                    // e.g. "Seller Leads in Contra Costa, CA"
                    plural = 's';
                }
                switch (cartItem.type) {
                    case me.MemberAreaPendingType.Buyer:
                        leadType = 'Buyer';
                        detail = "in ".concat(memberAreaPending.county, ", ").concat(memberAreaPending.state);
                        break;
                    case me.MemberAreaPendingType.ProspectingInstant:
                        leadType = 'Prospecting';
                        detail = '(Instant Access)';
                        break;
                    case me.MemberAreaPendingType.ProspectingMonthly:
                        leadType = 'Prospecting';
                        detail = '(Added Monthly)';
                        break;
                    case me.MemberAreaPendingType.Seller:
                        leadType = 'Seller';
                        detail = "in ".concat(memberAreaPending.county, ", ").concat(memberAreaPending.state);
                        break;
                }
                // e.g. "100 Buyer Leads in Greene, MO" or "50 Prospecting Leads (Added Monthly)" or "Seller Leads in Contra Costa, CA"
                return "".concat(quantity).concat(leadType, " Lead").concat(plural, " ").concat(detail);
            };
            SubscriptionEditDirectiveController.prototype.cartItemPrice = function (memberAreaPending, type) {
                var countyPackageData = this.getCountyPackageData(memberAreaPending.state, memberAreaPending.county);
                var price;
                switch (type) {
                    case me.MemberAreaPendingType.Buyer:
                        price = countyPackageData.setDefaultPricePerLeadBuyer * memberAreaPending.packageSizeBuyer;
                        break;
                    case me.MemberAreaPendingType.ProspectingInstant:
                    case me.MemberAreaPendingType.ProspectingMonthly:
                        price = 0;
                        break;
                    case me.MemberAreaPendingType.Seller:
                        price = countyPackageData.setDefaultPricePerLeadSeller * memberAreaPending.packageSizeSeller;
                        break;
                }
                return price;
            };
            SubscriptionEditDirectiveController.prototype.cartItemPriceText = function (cartItem) {
                var price = this.cartItemPrice(cartItem.memberAreaPending, cartItem.type);
                if (price === 0) {
                    return 'FREE';
                }
                else if (!price) {
                    // Invalid data used in calculating price
                    return '';
                }
                return this.displayPrice(price);
            };
            SubscriptionEditDirectiveController.prototype.cartTotal = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var total = 0;
                viewModel.memberAreasPending.forEach(function (memberAreaPending) {
                    var buyerLeadsPrice = _this.cartItemPrice(memberAreaPending, me.MemberAreaPendingType.Buyer);
                    if (buyerLeadsPrice) {
                        total += buyerLeadsPrice;
                    }
                    var sellerLeadsPrice = _this.cartItemPrice(memberAreaPending, me.MemberAreaPendingType.Seller);
                    if (sellerLeadsPrice) {
                        total += sellerLeadsPrice;
                    }
                });
                return this.displayPrice(total);
            };
            SubscriptionEditDirectiveController.prototype.checkStatisticsModalShouldBeVisible = function () {
                var viewModel = this.$scope.viewModel;
                var state = viewModel.selectedState.abbreviation;
                var county = viewModel.selectedCountyPackageData.county;
                if (!state || !county) {
                    // County is un-selected
                    viewModel.statisticModalLinkVisible = false;
                    return this.$q.resolve();
                }
                var countyStatisticsFuture = this.countyStatisticsService.getCountyStatisticsForStateAndCounty(state, county);
                var countyMapFuture = this.countyStatisticsService.getCountyLeadsCoordinatesForStateAndCounty(state, county);
                var cityLeadsFuture = this.countyStatisticsService.getCityLeadCountsForStateAndCounty(state, county);
                var results = this.$q.all([countyStatisticsFuture, countyMapFuture, cityLeadsFuture]);
                return results.then(function (result) {
                    // Verify results still match scope values for requested states and counties
                    if (viewModel.selectedState && viewModel.selectedCountyPackageData) {
                        if (viewModel.selectedState.abbreviation === state && viewModel.selectedCountyPackageData.county === county) {
                            var countyStatistics = result[0].countyStatistics;
                            var countyLeadsCoordinates = result[1].countyLeadsCoordinates;
                            var cityLeads = result[2].cityLeads;
                            try {
                                viewModel.statisticModalLinkVisible = Boolean(countyStatistics.availability) ||
                                    Boolean(countyStatistics.averageHomeValue) ||
                                    Boolean(countyStatistics.averageLeadSharing) ||
                                    Boolean(countyStatistics.maxHomeValue) ||
                                    Boolean(countyStatistics.minHomeValue) ||
                                    Boolean(countyStatistics.needFinancingToBuy) ||
                                    Boolean(countyStatistics.sellersAlsoBuying) ||
                                    Boolean(countyStatistics.willingToDiscount) ||
                                    (Boolean(countyStatistics.leadMapEnabled) && Boolean(countyLeadsCoordinates.coordinates.length > 0)) ||
                                    (Boolean(countyStatistics.cityStatisticsEnabled) && Boolean(cityLeads.length > 0));
                            }
                            catch (e) {
                                // One or more properties is currently undefined, keep from emitting errors
                                viewModel.statisticModalLinkVisible = false;
                            }
                        }
                    }
                }).catch(function (_) {
                    // Do not display invalid data on error
                    viewModel.statisticModalLinkVisible = false;
                });
            };
            SubscriptionEditDirectiveController.prototype.countyPackageButtonText = function (type) {
                var viewModel = this.$scope.viewModel;
                var found = viewModel.memberAreasPending.filter(function (m) { return m.state === viewModel.selectedState.abbreviation && m.county === viewModel.selectedCountyPackageData.county; });
                var buttonText = 'Add';
                if (found && found.length > 0) {
                    var packageSize = this.getPackageSize(found[0], type);
                    if (packageSize && packageSize > 0) {
                        buttonText = 'Update';
                    }
                }
                return buttonText;
            };
            SubscriptionEditDirectiveController.prototype.countySelected = function (blockUI) {
                var _this = this;
                if (blockUI === void 0) { blockUI = true; }
                if (blockUI) {
                    return this.showOverlayDuring(function () { return _this.countySelected(false); });
                }
                var viewModel = this.$scope.viewModel;
                viewModel.relatedCounties = null;
                if (!viewModel.selectedCountyPackageData) {
                    return this.$q.resolve(); // Nothing else to do
                }
                if (viewModel.selectedCountyPackageData.county != this.$scope.losAngelesSubdivided.county) {
                    this.setupBuyerSelector();
                    this.setupSellerSelector();
                    this.setupMemberAreaPendingSelections();
                }
                return this.$q.all([this.fillRelatedCounties(), this.checkStatisticsModalShouldBeVisible()]).then(function (_) { return; });
            };
            SubscriptionEditDirectiveController.prototype.deleteCartItem = function (cartItem) {
                var _this = this;
                switch (cartItem.type) {
                    case me.MemberAreaPendingType.Buyer:
                        cartItem.memberAreaPending.packageSizeBuyer = null;
                        break;
                    case me.MemberAreaPendingType.Seller:
                        cartItem.memberAreaPending.packageSizeSeller = null;
                        break;
                    case me.MemberAreaPendingType.ProspectingInstant:
                    case me.MemberAreaPendingType.ProspectingMonthly:
                        // Prospecting item, not used to update database
                        return;
                }
                this.showOverlayDuring(function () {
                    return _this.subscriptionService.updateMemberAreaPending(cartItem.memberAreaPending).then(function () {
                        return _this.setupCart();
                    });
                }, 'Updating Cart...').then(function () { return _this.flashUpdatedCartOverlay(); });
            };
            SubscriptionEditDirectiveController.prototype.displayPrice = function (price) {
                return this.$filter(names.zbuyer.filters.Price)(price);
            };
            SubscriptionEditDirectiveController.prototype.editCartItem = function (cartItem) {
                var _this = this;
                this.showOverlayDuring(function () { return _this.selectCounty(cartItem.memberAreaPending.county, cartItem.memberAreaPending.state); });
            };
            SubscriptionEditDirectiveController.prototype.fillCartItems = function (memberAreasPending, prospectingLeadsOnSite, prospectingLeadsPerMonth) {
                var viewModel = this.$scope.viewModel;
                var cartItems = new Array();
                viewModel.memberAreasPending = memberAreasPending;
                viewModel.memberAreasPending.forEach(function (memberAreaPending) {
                    if (memberAreaPending.packageSizeSeller !== null) {
                        cartItems.push({ type: me.MemberAreaPendingType.Seller, memberAreaPending: memberAreaPending });
                    }
                    if (memberAreaPending.packageSizeBuyer !== null) {
                        cartItems.push({ type: me.MemberAreaPendingType.Buyer, memberAreaPending: memberAreaPending });
                    }
                });
                if (prospectingLeadsOnSite) {
                    var cartItem = {
                        type: me.MemberAreaPendingType.ProspectingInstant,
                        memberAreaPending: { packageSizeProspecting: prospectingLeadsOnSite }
                    };
                    cartItems.push(cartItem);
                }
                if (prospectingLeadsPerMonth) {
                    var cartItem = {
                        type: me.MemberAreaPendingType.ProspectingMonthly,
                        memberAreaPending: { packageSizeProspecting: prospectingLeadsPerMonth }
                    };
                    cartItems.push(cartItem);
                }
                viewModel.cartItems = cartItems;
            };
            SubscriptionEditDirectiveController.prototype.fillCounties = function (stateAbbreviation) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                viewModel.countyPackageDataCounties = null; // incoming...
                return this.countyPackagesService.getCountyPackageDataForState(stateAbbreviation).then(function (result) {
                    viewModel.countyPackageDataCounties = result;
                    if (stateAbbreviation === _this.$scope.losAngelesSubdivided.state) {
                        viewModel.countyPackageDataCounties.push(_this.$scope.losAngelesSubdivided);
                        viewModel.countyPackageDataCounties = viewModel.countyPackageDataCounties.sort(function (a, b) { return a.county < b.county ? -1 : a.county > b.county ? 1 : 0; });
                    }
                    // Auto-select single choice if only one.
                    if (viewModel.countyPackageDataCounties.length === 1) {
                        viewModel.selectedCountyPackageData = viewModel.countyPackageDataCounties[0];
                        return _this.countySelected(false);
                    }
                    return _this.$q.resolve();
                });
            };
            SubscriptionEditDirectiveController.prototype.fillRelatedCounties = function () {
                var viewModel = this.$scope.viewModel;
                if (!viewModel.selectedCountyPackageData) {
                    // County was un-selected, no related counties to fill
                    return this.$q.resolve();
                }
                return this.countiesService.getRelatedCounties(viewModel.selectedState.abbreviation, viewModel.selectedCountyPackageData.county).then(function (result) {
                    // Ensure reponse is still relevant to current state of UI
                    if (viewModel.selectedCountyPackageData && viewModel.selectedState) {
                        if (viewModel.selectedCountyPackageData.county === result.countyRequested && viewModel.selectedState.abbreviation === result.stateRequested) {
                            viewModel.relatedCounties = result.counties;
                        }
                    }
                });
            };
            SubscriptionEditDirectiveController.prototype.flashUpdatedCartOverlay = function () {
                var blockId = 'SubscriptionCart';
                this.spinWaitService.block(blockId, names.misc.BlockUISpinnerCheckmarkClass, zbuyer.messages.UpdateCart);
                var spinWaitService = this.spinWaitService;
                this.$timeout(CartFlashTimeoutMillis).finally(function () {
                    spinWaitService.unblock(blockId);
                });
            };
            SubscriptionEditDirectiveController.prototype.getCountyPackageData = function (state, county) {
                var viewModel = this.$scope.viewModel;
                return viewModel.pendingCountyPackageDataCounties.filter(function (cpd) { return cpd.county === county && cpd.state === state; })[0];
            };
            SubscriptionEditDirectiveController.prototype.getPackageSize = function (memberAreaPending, type) {
                var packageSize;
                switch (type) {
                    case me.MemberAreaPendingType.Buyer:
                        packageSize = memberAreaPending.packageSizeBuyer;
                        break;
                    case me.MemberAreaPendingType.ProspectingInstant:
                    case me.MemberAreaPendingType.ProspectingMonthly:
                        packageSize = memberAreaPending.packageSizeProspecting;
                        break;
                    case me.MemberAreaPendingType.Seller:
                        packageSize = memberAreaPending.packageSizeSeller;
                        break;
                }
                return packageSize;
            };
            SubscriptionEditDirectiveController.prototype.getSelector = function (value, floor, ceil, disabled, onChange) {
                var _this = this;
                return {
                    selectedValue: value,
                    options: {
                        autoHideLimitLabels: false,
                        ceil: ceil,
                        disabled: disabled,
                        floor: floor,
                        hideLimitLabels: false,
                        onChange: function () {
                            onChange(_this.$scope);
                        },
                        // Render all numeric values (max/min/etc except the central model value since we will render that independently)
                        translate: function (value, sliderId, label) {
                            return label == 'model' ? '' : value;
                        }
                    }
                };
            };
            SubscriptionEditDirectiveController.prototype.isProspectingCartItem = function (cartItem) {
                return (cartItem.type === me.MemberAreaPendingType.ProspectingInstant || cartItem.type === me.MemberAreaPendingType.ProspectingMonthly);
            };
            SubscriptionEditDirectiveController.prototype.isLosAngelesCounty = function () {
                var viewModel = this.$scope.viewModel;
                return viewModel.selectedCountyPackageData && viewModel.selectedCountyPackageData.county === this.$scope.losAngelesSubdivided.county;
            };
            SubscriptionEditDirectiveController.prototype.memberAreaPendingType = function () {
                return me.MemberAreaPendingType;
            };
            SubscriptionEditDirectiveController.prototype.notify = function (type) {
                var viewModel = this.$scope.viewModel;
                switch (type) {
                    case me.MemberAreaPendingType.Buyer:
                        viewModel.buyerLeadsPerMonth = 0;
                        break;
                    case me.MemberAreaPendingType.Seller:
                        viewModel.sellerLeadsPerMonth = 0;
                        break;
                }
                this.saveMemberAreaPackage(type);
            };
            SubscriptionEditDirectiveController.prototype.resetDropdownSelection = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.selectedCountyPackageData = null;
                viewModel.selectedState = null;
                this.$window.scrollTo({ top: 0 });
            };
            SubscriptionEditDirectiveController.prototype.saveMemberAreaPackage = function (type) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var search = viewModel.memberAreasPending.filter(function (m) { return m.state === viewModel.selectedState.abbreviation && m.county === viewModel.selectedCountyPackageData.county; });
                var memberAreaPending = (search && search.length > 0) ? search[0] : { county: viewModel.selectedCountyPackageData.county, state: viewModel.selectedState.abbreviation };
                switch (type) {
                    case me.MemberAreaPendingType.Buyer:
                        memberAreaPending.packageSizeBuyer = viewModel.buyerLeadsPerMonth;
                        break;
                    case me.MemberAreaPendingType.Seller:
                        memberAreaPending.packageSizeSeller = viewModel.sellerLeadsPerMonth;
                        break;
                    case me.MemberAreaPendingType.ProspectingInstant:
                    case me.MemberAreaPendingType.ProspectingMonthly:
                        // Package should not be changed (only for display)
                        return;
                }
                this.showOverlayDuring(function () {
                    if (search && search.length > 0) {
                        return _this.subscriptionService.updateMemberAreaPending(memberAreaPending).then(function () {
                            return _this.setupCart();
                        });
                    }
                    else {
                        return _this.subscriptionService.addMemberAreaPending(memberAreaPending).then(function () {
                            return _this.setupCart();
                        });
                    }
                }, 'Updating Cart...').then(function () { return _this.flashUpdatedCartOverlay(); });
            };
            SubscriptionEditDirectiveController.prototype.selectCounty = function (countyName, stateAbbreviation) {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                if (stateAbbreviation) {
                    var selectedStateAbbrev = viewModel.selectedState && viewModel.selectedState.abbreviation;
                    if (selectedStateAbbrev != stateAbbreviation) {
                        // Need right state first. Bring blocking overlay back up after state load finished
                        return this.selectState(stateAbbreviation).then(function () { return _this.showOverlayDuring(function () { return _this.selectCounty(countyName); }); });
                    }
                }
                var search = viewModel.countyPackageDataCounties.filter(function (c) { return c.county == countyName; });
                if (search.length > 0) {
                    this.$scope.viewModel.selectedCountyPackageData = search[0];
                    return this.countySelected(false);
                }
                else {
                    return this.$q.reject();
                }
            };
            SubscriptionEditDirectiveController.prototype.selectState = function (abbreviation) {
                var viewModel = this.$scope.viewModel;
                if (viewModel.selectedState && viewModel.selectedState.abbreviation === abbreviation) {
                    return this.$q.resolve();
                }
                var search = viewModel.states.filter(function (s) { return s.abbreviation === abbreviation; });
                if (search.length > 0) {
                    viewModel.selectedState = search[0];
                    return this.stateSelected();
                }
                return this.$q.resolve();
            };
            SubscriptionEditDirectiveController.prototype.selectCountyByZip = function (zip) {
                var _this = this;
                return this.showOverlayDuring(function () {
                    return _this.countiesService.getCountyForZip(zip).then(function (county) {
                        if (county) {
                            _this.selectCounty(county.name, county.stateAbbreviation);
                        }
                    });
                });
            };
            SubscriptionEditDirectiveController.prototype.setupBuyerSelector = function () {
                var viewModel = this.$scope.viewModel;
                var onChange = function (scope) {
                    scope.viewModel.buyerLeadsPerMonth = scope.buyerLeadsPerMonthSelector.selectedValue;
                };
                // Determine max leads/month for selector, and constrain the initial value to that max
                var ceil = Math.min(viewModel.selectedCountyPackageData.calcMaxPackageSizeBuyer, viewModel.selectedCountyPackageData.setMaxPackageSizeBuyer);
                var value = Math.min(ceil, viewModel.selectedCountyPackageData.setStdPackageSizeBuyer);
                var floor = ceil == 0 ? 0 : BuyerLeadsPerPeriodMinimum;
                viewModel.buyerLeadsPerMonth = value;
                // Strictly for display, treat as sold out when data indicates sold out OR allowed leads-per-month value is 0
                viewModel.treatBuyerAsSoldOut = (viewModel.selectedCountyPackageData.isSoldOutBuyer === 1 || value === 0);
                this.$scope.buyerLeadsPerMonthSelector = this.getSelector(value, floor, ceil, viewModel.treatBuyerAsSoldOut, onChange);
            };
            SubscriptionEditDirectiveController.prototype.setupCart = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var didCheckCart = this.checkoutService.checkCartIsValid().then(function (cartValidResponse) {
                    viewModel.cartIsValid = cartValidResponse.cartIsValid;
                    viewModel.cartErrorMessage = cartValidResponse.cartIsValid ? '' : cartValidResponse.errorMessageToDisplay;
                    return cartValidResponse;
                });
                return this.countyPackagesService.getCountyPackageDataPendingForAccount().then(function (result) {
                    viewModel.pendingCountyPackageDataCounties = result;
                    return didCheckCart.then(function (cartValidResponse) {
                        return _this.subscriptionService.getMemberAreasPending().then(function (memberAreasPending) {
                            _this.fillCartItems(memberAreasPending, cartValidResponse.prospectingLeadsOnSite, cartValidResponse.prospectingLeadsPerMonth);
                        });
                    });
                });
            };
            SubscriptionEditDirectiveController.prototype.setupMemberAreaPendingSelections = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                // Default the selected leads per month to existing member area pending sizes if they exist
                if (viewModel.memberAreasPending && viewModel.memberAreasPending.length > 0) {
                    var found = viewModel.memberAreasPending.filter(function (m) { return m.state === viewModel.selectedState.abbreviation && m.county === viewModel.selectedCountyPackageData.county; });
                    if (found && found.length > 0) {
                        var memberAreaPending = found[0];
                        this.$timeout(function () {
                            if (memberAreaPending.packageSizeBuyer != null && memberAreaPending.packageSizeBuyer > 0) {
                                viewModel.buyerLeadsPerMonth = memberAreaPending.packageSizeBuyer;
                                _this.$scope.buyerLeadsPerMonthSelector.selectedValue = memberAreaPending.packageSizeBuyer;
                            }
                            if (memberAreaPending.packageSizeSeller != null && memberAreaPending.packageSizeSeller > 0) {
                                viewModel.sellerLeadsPerMonth = memberAreaPending.packageSizeSeller;
                                _this.$scope.sellerLeadsPerMonthSelector.selectedValue = memberAreaPending.packageSizeSeller;
                            }
                        });
                    }
                }
            };
            SubscriptionEditDirectiveController.prototype.setupSellerSelector = function () {
                var viewModel = this.$scope.viewModel;
                var onChange = function (scope) {
                    scope.viewModel.sellerLeadsPerMonth = scope.sellerLeadsPerMonthSelector.selectedValue;
                };
                // Determine max leads/month for selector, and constrain the initial value to that max
                var ceil = Math.min(viewModel.selectedCountyPackageData.calcMaxPackageSizeSeller, viewModel.selectedCountyPackageData.setMaxPackageSizeSeller);
                var value = Math.min(ceil, viewModel.selectedCountyPackageData.setStdPackageSizeSeller);
                var floor = ceil == 0 ? 0 : 1;
                viewModel.sellerLeadsPerMonth = value;
                // Strictly for display, treat as sold out when data indicates sold out OR allowed leads-per-month value is 0
                viewModel.treatSellerAsSoldOut = (viewModel.selectedCountyPackageData.isSoldOutSeller === 1 || value === 0);
                this.$scope.sellerLeadsPerMonthSelector = this.getSelector(value, floor, ceil, viewModel.treatSellerAsSoldOut, onChange);
            };
            SubscriptionEditDirectiveController.prototype.shouldStatisticsModalLinkBeVisible = function () {
                return this.$scope.viewModel.statisticModalLinkVisible;
            };
            SubscriptionEditDirectiveController.prototype.showCountyStatisticsModal = function () {
                var viewModel = this.$scope.viewModel;
                controllers.CountyStatisticsModalController.loadModal(viewModel.selectedState.abbreviation, viewModel.selectedCountyPackageData.county);
            };
            SubscriptionEditDirectiveController.prototype.showLearnMoreModal = function (track) {
                controllers.LearnMoreModalController.loadModal(track);
            };
            SubscriptionEditDirectiveController.prototype.showOverlay = function (active, message) {
                if (active === void 0) { active = true; }
                if (message === void 0) { message = null; }
                var blockId = 'SubscriptionStateCountyLoading';
                if (active) {
                    this.spinWaitService.block(blockId, 'image logo', message || 'Loading...');
                }
                else {
                    this.spinWaitService.unblock(blockId);
                }
            };
            SubscriptionEditDirectiveController.prototype.showOverlayDuring = function (untilFunc, message) {
                var _this = this;
                if (message === void 0) { message = null; }
                try {
                    this.showOverlay(true, message);
                    return untilFunc().finally(function () { return _this.showOverlay(false); });
                }
                catch (error) {
                    this.showOverlay(false);
                    return this.$q.reject(error);
                }
            };
            SubscriptionEditDirectiveController.prototype.showPrice = function (cartItem) {
                // Show price when package size not zero or null
                return !!this.getPackageSize(cartItem.memberAreaPending, cartItem.type);
            };
            SubscriptionEditDirectiveController.prototype.showZipLookupModal = function () {
                var _this = this;
                controllers.ZipLookupModalController.loadModal().result.then(function (zip) { return _this.selectCountyByZip(zip); });
            };
            SubscriptionEditDirectiveController.prototype.stateSelected = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                return this.showOverlayDuring(function () { return _this.fillCounties(viewModel.selectedState.abbreviation); });
            };
            SubscriptionEditDirectiveController.$inject = [
                names.angular.Scope,
                names.angular.Filter,
                names.angular.Location,
                names.angular.Q,
                names.angular.Timeout,
                names.angular.Window,
                names.zbuyer.services.CheckoutService,
                names.zbuyer.services.CountiesService,
                names.zbuyer.services.CountyPackagesService,
                names.zbuyer.services.CountyStatisticsService,
                names.zbuyer.services.SpinWaitService,
                names.zbuyer.services.StatesService,
                names.zbuyer.services.SubscriptionService
            ];
            return SubscriptionEditDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.SubscriptionEdit, SubscriptionEditDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TestNotificationModalController = /** @class */ (function () {
            function TestNotificationModalController($scope, $uibModalInstance, modalService, formViewModel) {
                this.$scope = $scope;
                this.$uibModalInstance = $uibModalInstance;
                this.modalService = modalService;
                this.modalService.handleCloseActions(this.$scope, this.$uibModalInstance);
                $scope.formViewModel = formViewModel;
                $scope.controller = this;
                formViewModel.submitCallback = this.handleSubmit.bind(this);
            }
            TestNotificationModalController.prototype.handleSubmit = function (formInputs) {
                this.$uibModalInstance.close(formInputs);
            };
            TestNotificationModalController.prototype.cancel = function () {
                this.$uibModalInstance.close(null);
            };
            TestNotificationModalController.loadModal = function (formInputs) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var modalInstance = $uibModal.open({
                    controller: names.zbuyer.controllers.TestNotificationModalController,
                    backdrop: true,
                    backdropClass: 'test-lead-modal-backdrop',
                    resolve: {
                        formViewModel: {
                            inputFormItems: formInputs,
                            submitButtonText: "Send",
                            title: "Test Lead"
                        }
                    },
                    size: 'sm',
                    templateUrl: TestNotificationModalController.TemplateUrl,
                    windowClass: 'test-lead-modal'
                });
                return modalInstance.result;
            };
            TestNotificationModalController.TemplateUrl = 'staticpages/modals/TestNotificationModal.html';
            TestNotificationModalController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.ModalService,
                'formViewModel'
            ];
            return TestNotificationModalController;
        }());
        controllers.TestNotificationModalController = TestNotificationModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.TestNotificationModalController, TestNotificationModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/directives/transactionsdirective.html';
        var DefaultSort = 'date';
        var SearchInputElement = '.search-input';
        var TransactionsDirectiveController = /** @class */ (function (_super) {
            __extends(TransactionsDirectiveController, _super);
            function TransactionsDirectiveController($scope, accountService, notificationService, spinWaitService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.accountService = accountService;
                _this.notificationService = notificationService;
                _this.spinWaitService = spinWaitService;
                _this.itemsPerPage = 10;
                _this.sortByDirections = {
                    creditCardCharge: false,
                    date: false,
                    descrption: false
                };
                _this.initializeTransactionsDirectiveController();
                return _this;
            }
            TransactionsDirectiveController.getDirective = function () {
                return {
                    controller: TransactionsDirectiveController,
                    restrict: 'E',
                    scope: {
                        backCallback: '&onBack',
                        viewModel: '='
                    },
                    templateUrl: TemplateUrl
                };
            };
            TransactionsDirectiveController.prototype.initializeTransactionsDirectiveController = function () {
                this.getTransactionsDefault();
            };
            TransactionsDirectiveController.prototype.clearSearch = function () {
                this.$scope.viewModel.search = null;
                this.getTransactionsDefault();
            };
            TransactionsDirectiveController.prototype.getPageSize = function () {
                return this.itemsPerPage;
            };
            TransactionsDirectiveController.prototype.getTransactions = function () {
                var _this = this;
                var viewModel = this.$scope.viewModel;
                var blockUiString = 'LoadingTransactions';
                this.spinWaitService.block(blockUiString);
                this.accountService.getTransactions({
                    itemsPerPage: this.itemsPerPage,
                    page: viewModel.page,
                    search: viewModel.search,
                    sortAscending: this.sortByDirections[this.sortByProperty],
                    sortBy: this.sortByProperty
                }).then(function (result) {
                    viewModel.pages = result.pages;
                    viewModel.total = result.total;
                    viewModel.transactions = result.transactions;
                }).catch(function (reason) {
                    _this.notificationService.error(zbuyer.messages.TransactionsError, 'Error');
                }).finally(function () {
                    _this.spinWaitService.unblock(blockUiString);
                });
            };
            TransactionsDirectiveController.prototype.getTransactionsDefault = function () {
                this.sortByProperty = DefaultSort;
                this.sortByDirections[DefaultSort] = false;
                this.getTransactions();
            };
            TransactionsDirectiveController.prototype.sortTransactions = function (property) {
                this.sortByProperty = property;
                this.sortByDirections[property] = !this.sortByDirections[property];
                this.getTransactions();
            };
            TransactionsDirectiveController.prototype.toggleSearchPanel = function () {
                var viewModel = this.$scope.viewModel;
                viewModel.searchOpen = !viewModel.searchOpen;
                var inputElement = angular.element(SearchInputElement);
                inputElement.focus();
            };
            TransactionsDirectiveController.$inject = [
                names.angular.Scope,
                names.zbuyer.services.AccountService,
                names.zbuyer.services.NotificationService,
                names.zbuyer.services.SpinWaitService
            ];
            return TransactionsDirectiveController;
        }(controllers.ControllerBase));
        angular.module(names.zbuyer.Application)
            .directive(names.zbuyer.directives.Transactions, TransactionsDirectiveController.getDirective);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/yesnomodal.html';
        var YesNoModalResults;
        (function (YesNoModalResults) {
            YesNoModalResults[YesNoModalResults["Cancel"] = 0] = "Cancel";
            YesNoModalResults[YesNoModalResults["No"] = 1] = "No";
            YesNoModalResults[YesNoModalResults["Yes"] = 2] = "Yes";
        })(YesNoModalResults = controllers.YesNoModalResults || (controllers.YesNoModalResults = {}));
        var YesNoModalOptions = /** @class */ (function () {
            function YesNoModalOptions() {
            }
            return YesNoModalOptions;
        }());
        controllers.YesNoModalOptions = YesNoModalOptions;
        var YesNoModalComponent = /** @class */ (function () {
            function YesNoModalComponent() {
            }
            YesNoModalComponent.getController = function () {
                return {
                    controller: YesNoModalComponent,
                    bindings: {
                        $uibModalInstance: "<modalInstance",
                        resolve: '<'
                    },
                    templateUrl: TemplateUrl
                };
            };
            YesNoModalComponent.prototype.cancelModalClose = function () {
                this.$uibModalInstance.close(YesNoModalResults.Cancel);
            };
            YesNoModalComponent.prototype.noModalClose = function () {
                this.$uibModalInstance.close(YesNoModalResults.No);
            };
            YesNoModalComponent.prototype.yesModalClose = function () {
                this.$uibModalInstance.close(YesNoModalResults.Yes);
            };
            YesNoModalComponent.loadModal = function (options) {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var $q = $injector.get(names.angular.Q);
                var modalInstance = $uibModal.open({
                    backdropClass: 'yes-no-modal-backdrop',
                    component: names.zbuyer.components.YesNoModalComponent,
                    resolve: {
                        options: function () { return options; }
                    },
                    size: 'md',
                    templateUrl: TemplateUrl,
                    windowClass: 'yes-no-modal'
                });
                return modalInstance.result.then(function (result) { return $q.resolve(result); });
            };
            return YesNoModalComponent;
        }());
        controllers.YesNoModalComponent = YesNoModalComponent;
        angular.module(names.zbuyer.Application)
            .component(names.zbuyer.components.YesNoModalComponent, YesNoModalComponent.getController());
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var TemplateUrl = 'staticpages/modals/ziplookupmodal.html';
        var ZipLookupModalController = /** @class */ (function (_super) {
            __extends(ZipLookupModalController, _super);
            function ZipLookupModalController($scope, $uibModalInstance, modalService) {
                var _this = _super.call(this, $scope) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.modalService = modalService;
                modalService.handleCloseActions($scope, $uibModalInstance);
                return _this;
            }
            ZipLookupModalController.loadModal = function () {
                var $injector = angular.element('html').injector();
                var $uibModal = $injector.get(names.angular.UiBootstrapModal);
                var modal = $uibModal.open({
                    controller: names.zbuyer.controllers.ZipLookupModalController,
                    size: 'sm',
                    templateUrl: TemplateUrl,
                    windowClass: 'zip-lookup-modal'
                });
                return modal;
            };
            ZipLookupModalController.prototype.close = function () {
                this.$uibModalInstance.close(this.$scope.viewModel ? this.$scope.viewModel.zipCode : null);
            };
            ZipLookupModalController.$inject = [
                names.angular.Scope,
                names.angular.UiBootstrapModalInstance,
                names.zbuyer.services.ModalService
            ];
            return ZipLookupModalController;
        }(controllers.ControllerBase));
        controllers.ZipLookupModalController = ZipLookupModalController;
        angular.module(names.zbuyer.Application)
            .controller(names.zbuyer.controllers.ZipLookupModalController, ZipLookupModalController);
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

//# sourceMappingURL=app-controllers.js.map
